/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */
'use strict';

//Object.assign polyfill
if (typeof Object.assign !== 'function') {
  Object.assign = function(target, varArgs) { // .length of function is 2
    if (target == null) { // TypeError if undefined or null
      throw new TypeError('Cannot convert undefined or null to object');
    }

    var to = Object(target);

    for (var index = 1; index < arguments.length; index++) {
      var nextSource = arguments[index];

      if (nextSource !== null) { // Skip over if undefined or null
        for (var nextKey in nextSource) {
          // Avoid bugs when hasOwnProperty is shadowed
          if (Object.prototype.hasOwnProperty.call(nextSource, nextKey)) {
            to[nextKey] = nextSource[nextKey];
          }
        }
      }
    }
    return to;
  };
}
jQuery(document).ready(function() {
if(jQuery(".carouselblock ")[0]) {
   var owl = jQuery('#businessCarousel .owl-carousel,#consumersCarousel .owl-carousel');
    owl.owlCarousel({
      margin: 0,
      nav: false,
      loop: true,
      slideBy: 2,
      autoWidth:true,
      autoplayTimeout: 5000,
      responsive: {
        0: {
          items: 1.5
        },
        600: {
          items: 2.5
        },
        767: {
          items: 1.5
        },
        1000: {
          items: 2
        }
      }
 });
 var owl1 =jQuery('#employeesCarousel .owl-carousel');
   owl1.owlCarousel({
       rtl:true,
       margin: 0,
            nav: false,
            loop: true,
            slideBy: 2,
            autoWidth:true,
            autoplayTimeout: 5000,
            responsive: {
              0: {
                items: 1.5
              },
              600: {
                items: 2
              },
              767: {
                items: 1.5
              },
              1000: {
                items: 2
              }
            }
   });
}
      //To disable page source Disable CTRL U and Right Click
      // if (jQuery('body').hasClass('logged-in')===false) { console.log('disable');
      //      document.onkeydown = function(e) {
      //      if (e.ctrlKey && e.keyCode === 85) {
      //           return false;
      //       }
      //     };
      //     jQuery('body').contextmenu(function() {
      //         return false;
      //     });
      //     }
});
(function($, undefined) {
  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  //define this before everything else so jshint doesn't thrown error
  var SageGlobals;
  var SiteUrl='https://mynpp.com';//for GA
   var PortalSiteUrl='https://portal.mynpp.com';//for GA
   var emailid =''; //For qualtrics

  // Google event tracker code. Currently setup to use GA vs GTM
  window.GATracker = window.GATracker || { subs: {} };

  (function(GATracker) {
    var gat = GATracker;

    gat.sub = function(label, func) {
      if( (label && func) && typeof this.subs[label] === 'undefined' ) {
        this.subs[label] = func;
      }
    };

    gat.isInt = function(value) {
      return !isNaN(value) && parseInt(Number(value)) === value && !isNaN(parseInt(value, 10));
    };

    gat.gatPush = function(eventObject) {
      //GA event
      ga('send', {
        hitType: eventObject.hitType,
        eventCategory: eventObject.eventCategory,
        eventAction: eventObject.eventAction,
        eventLabel: eventObject.eventLabel,
        eventValue: eventObject.eventValue
      });

      //GTM datalayer push - update to use eventObject
      // dataLayer.push(
      //   {
      //     'category': $this.data('gatcategory') || this,
      //     'action': $this.data('gataction') || 'click',
      //     'label': $this.data('gatlabel') || '',
      //     'value': isInt($this.data('gatvalue')) ? $this.data('gatvalue') : 0,
      //     'event': 'gatpush'
      //   }
      // );
    };

    gat.consumeEvent = function($this, callback) {
      var preFunction = $this.data('gatpre');
      if( preFunction && typeof gat.subs[preFunction] === 'function' ) {
        gat.subs[preFunction]($this);
      }

      gat.gatPush({
        hitType: 'event',
        eventCategory: $this.data('gatcategory') || this,
        eventAction: $this.data('gataction') || 'click',
        eventLabel: $this.data('gatlabel') || '',
        eventValue: gat.isInt($this.data('gatvalue')) ? $this.data('gatvalue') : 0
      });

      if( typeof callback !== 'undefined' && typeof callback === 'function' ) {
        callback();
      }
    };

    $(document).on('click', '[data-gat~="click"]', function(e) {
      var $this = $(this),
        targetProperty = $this.attr('target'),
        callback;

      if( this.nodeName === 'A' ) {
        e.preventDefault();

        var target = (targetProperty && targetProperty.match(/^_(self|parent|top|blank)$/i)) ? targetProperty : false;
        var link = $this.attr('href');

        callback = (function(link, target) {
          if(target) {
            window.open(link, target);
          }
          else {
            window.location.href = link;
          }
        })(link, target);
      }

      gat.consumeEvent( $(this), callback);
    });

    $(document).on('change', '[data-gat~="change"]', function() {
      var $this = $(this),
        callbackFuncName = $this.data('gatcallback'),
        callback = null;

      if(callbackFuncName && typeof gat.subs[callbackFuncName] === 'function') {
        callback = (function($this) {
          gat.subs[callbackFuncName]($this);
        })($this);
      }

      gat.consumeEvent($(this), callback);
    });

    $(document).on('mouseover', '[data-gat~="mouseover"]', function() {
      gat.consumeEvent( $(this) );
    });

    $(document).on('submit', '[data-gat~="submit"]', function() {
      gat.consumeEvent( $(this) );
    });

  })(window.GATracker);

  var _Lib = {
    sendRequest: function(action, endPoint, data) {
            var url = action === 'GET' ? '/lib/'+ endPoint + '?' + data : '/lib/' + endPoint,
        dataObj = action === 'GET' ? '' : data;

      return new Promise( function (resolve, reject) {
        $.ajax({
          method: action,
          url: url,
          dataType: 'json',
          data: dataObj
        })
          .done(function (data) {
            if(data === null) {
              reject(new Error('result is undefined'));
            }
            else if(data.hasOwnProperty('success') && data.success === 'false') {
              reject(data);
            }
            else {
              resolve(data);
            }
          })
          .fail(function (jqXHR) {
            reject({
              status: jqXHR.status,
              statusText: jqXHR.statusText,
              responseText: jqXHR.responseText
            });
          });

      });
    }
  };

  var _Auth0 = {
    sendRequest: function(action, endPoint, data) {
      var url = action === 'GET' ? endPoint + '?' + data : endPoint,
        dataObj = action === 'GET' ? '' : data;

      return new Promise( function (resolve, reject) {
        $.ajax({
          method: action,
          url: url,
          dataType: 'json',
          data: dataObj,
          headers: {
            'Authorization': 'Bearer ' + IOT_CONFIG.AUTH0_GWT_TOKEN
          }
        })
          .done(function (data) {
            resolve(data);
          })
          .fail(function (jqXHR) {
            reject(jqXHR.responseJSON);
          });

      });
    },

    query: function(queryParams) {
      var qstring = 'fields=' + encodeURIComponent(queryParams.fields) || 'id';
      qstring += '&email=' + encodeURIComponent(queryParams.searchValues) || '';

      return _Auth0.sendRequest('GET', IOT_CONFIG.AUTH0_API_ENDPOINT + 'users-by-email', qstring);
    },

    linkUser: function(userId, contactId) {
      //bare bones profile. Simply to link Auth0 to SFDC Contact
      //all syncing happens during login process

      var auth0ProfileData = {
        app_metadata: {
          contactId: contactId
        }
      };

      return _Auth0.sendRequest('PATCH', IOT_CONFIG.AUTH0_API_ENDPOINT + 'users/' + userId, auth0ProfileData);
    },

    deleteUser: function(userId) {
      return _Auth0.sendRequest('DELETE', IOT_CONFIG.AUTH0_API_ENDPOINT + 'users/' + userId);
    },

    createUser: function(profileData) {
      return _Auth0.sendRequest('POST', IOT_CONFIG.AUTH0_API_ENDPOINT + 'users', profileData);
    },

    sendVerificationEmail: function(userId) {
      var data = {
        user_id: userId
      };

      return _Auth0.sendRequest('POST', IOT_CONFIG.AUTH0_API_ENDPOINT + 'jobs/verification-email', data);
    },

    getImpersonationUrl: function(userId, imposterId, nonce, redirectUrl) {
      var data = {
        user: userId,
        imposter: imposterId,
        nonce: nonce,
        redirect: redirectUrl
      };

      return _Auth0.sendRequest('POST', '/lib/impersonate.php', data);
    }
  };
  function getSalesforceAccessToken() {
    var currentDomain = window.location.origin;
    // Construct the token URL using the current domain
    var tokenUrl = currentDomain + "/app/themes/sage/lib/leadSearch.php";
    return $.ajax({
      url: tokenUrl,
      method: 'GET',
      data: {action: 'getAccessToken'},
      dataType: 'json'
    }).then(function(response) {
      return response;
    }).catch(function(error) {
      console.error("Error getting access token:", error);
      console.error("Error details:", JSON.stringify(error, null, 2));
      throw error;
    });
  }

        function checkDateFormat(data) {
          /**
           * Helper function to determine if a value is a valid date string.
           * 
           * @param {string} value - The value to check.
           * @returns {boolean} - True if the value is a valid date, false otherwise.
           */
          function isValidDate(value) {
              return moment(value, moment.ISO_8601, true).isValid();
          }

          /**
           * Recursive function to traverse and process the input.
           * - Formats date strings into the desired format.
           * - Recursively processes nested objects.
           * 
           * @param {any} obj - The current value to process.
           * @returns {any} - The processed value with dates formatted.
           */
          function traverse(obj) {
              // If the value is a string and a valid date, format it
              if (typeof obj === 'string' && isValidDate(obj)) {
                  return moment(obj).format('gggg-MM-DD HH:mm:ss.SSS');
              }
              // If the value is an object, recursively process its properties
              else if (typeof obj === 'object' && obj !== null) {
                  for (var key in obj) {
                      if (obj.hasOwnProperty(key)) {
                          obj[key] = traverse(obj[key]); // Process each property
                      }
                  }
              }
              // Return the original value if it's not a date or object
              return obj;
          }

          // Start the recursive processing with the input data
          return traverse(data);
      }
     // Generic function for Salesforce API calls
      function callSalesforceApi(endpoint, method, data) {
          data = checkDateFormat(data);
          return $.ajax({
              url: '/wp/wp-admin/admin-ajax.php',
              method: 'POST',
              data: {
                  action: 'salesforce_api_request',
                  endpoint: endpoint,
                  method: method,
                  data: data
              },
              dataType: 'json'
          });

      }
  var _Boomi = {
    sendRequest: function(action, endPoint, data, headers, attemptsLeft) {
      var attempts = attemptsLeft === undefined ? 2 : attemptsLeft;

      if(endPoint === '') {
        SageGlobals.log({
          errorSeverity: 'WARNING',
          error: 'missing endpoint from Boomi call',
          payload: {data: data, action: action, headers: headers}
        });
      }

      var url = action === 'GET' ? IOT_CONFIG.BOOMI_API_ENDPOINT + endPoint + '/' + data + ';boomi_auth=' + IOT_CONFIG.BOOMI_AUTH : IOT_CONFIG.BOOMI_API_ENDPOINT + endPoint + ';boomi_auth=' + IOT_CONFIG.BOOMI_AUTH,
        dataObj = action === 'GET' ? '' : JSON.stringify(data),
        headersObj = headers || {};

      return new Promise( function (resolve, reject) {
        $.ajax({
          method: action,
          url: url,
          headers: headersObj,
          dataType: 'text',
          data: dataObj
        })
        .done(function (data, textStatus) {
          //remove newlines to prevent JSON parse error
          try {
            data = data.replace(/\s\s+/g, ' ');
            resolve(JSON.parse(data.replace(/\r?\n/g, '')));
          }
          catch(e) {
            SageGlobals.log({
              errorSeverity: 'WARNING',
              error: e.message,
              payload: data,
              description: textStatus
            });
            reject(new Error('Failed to parse document returned from Boomi'));
          }

        })
        .fail(function (jqXHR) {
          if(attempts > 0) {
            resolve(_Boomi.sendRequest(action, endPoint, data, headers, --attempts));
          }
          else {
            reject({
              status: jqXHR.status,
              statusText: jqXHR.statusText,
              responseText: jqXHR.responseText
            });
          }
        });

      });
    }
  };

  SageGlobals = {

    //common vars
    formClasses: '',
    formStateClasses: {
      success: 'is_success',
      error: 'is_error'
    },
    invalidRedirects:['/password-reset-confirmation', '/company-rep-registration-thank', '/register-verizon-rep-thank-you', '/registration-additional-information', '/complete-account-thank-you', '/partner-rep-registration-thank-you', '/express-registration-complete', '/complete-account', '/express-registration', '/register-verizon-rep', '/error', '/account-pending', '/email-verified', '/migrate', '/partner-registration', '/registration'],
    GENERIC_ERROR_MSG: 'Something went wrong. Please try again later.',

    bannerHeight: $('#banner').outerHeight(),
    wpAdminHeight: $('#wpadminbar').length ? $('#wpadminbar').outerHeight() : 0,

    log: function(errorData) {
      var defaults = {
        errorSeverity: 'NOTICE',
        error: '',
        payload: '',
        scriptLocation: window.location.pathname,
        description: '',
        nonce: $('#log-nonce').val()
      };

      var mergedData = Object.assign(defaults, errorData);

      _Lib.sendRequest('POST', 'log.php', mergedData);
    },

    //taken from https://davidwalsh.name/javascript-debounce-function
    debounce: function(func, wait, immediate) {
      var timeout;
      return function() {
        var context = this, args = arguments;
        var later = function() {
          timeout = null;
          if (!immediate) {
            func.apply(context, args);
          }
        };
        var callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) {
          func.apply(context, args);
        }
      };
    },

    getTimeStamp: function() {
      return moment().tz('America/New_York').format('ggggMMDD HHmmss.SSS');
    },
    showLoader:function(){
          jQuery("#loader").addClass('white-loader');
          jQuery("#loader").show();
    },
    hideMenu:function(){
             //setTimeout(function (event) {
                jQuery('.hide_nav').hide();
                jQuery('.footer').css("background", "#ffffff");
                jQuery('.asso_spec').hide();
                jQuery('.association_menu').show();
                jQuery('.footer_terms').show();
                jQuery('.remove_href, .asso_href').removeAttr('href');
                jQuery('.copyright').css("padding-top", "12px");
          //  }, 5000);
          },
        validateEmailField:function(){
        // function for disallow spam leads in single landing page
        var email = jQuery(".custom-validation input[title='Email']").val().toLowerCase();
        var rejectList = [ "itisverywell.com","example.com", "thefmails.com" , "yandex.com" ,".ru" ,".top", ".de",".xyz",".ua",".pl",".lv",".website"];
        var splitArray = email.split('@'); // To Get Array
        var dotemail=email.substring(email.lastIndexOf("."));
        console.log(splitArray);
        jQuery('.val-email-wrapper .errMsg').remove();
        if(rejectList.indexOf(splitArray[1]) >= 0 || rejectList.indexOf(dotemail) >= 0 ){

            jQuery( '<div id="primaryInput" class="errMsg" tabindex="-1"><span>This does not appear to be a valid email address.</span></div>' ).insertAfter( ".val-email-wrapper .inputWrapper" );
                    jQuery('#submit_button').attr('disabled', true);
                    return false;

            } else {
                if (jQuery("#primaryInput").length || jQuery("#secondInput").length){
                    jQuery('#submit_button').attr('disabled', true);
                    return false;
                } else {
                    jQuery('#submit_button').attr('disabled', false);
                    jQuery('.val-email-wrapper .errMsg').remove();
                    return true;
                }

            }
        },
        trackingScript: function(url,user){
           SageGlobals.showLoader();
            var queryParams = SageGlobals.getQueryParameters();
            var loginParam = queryParams.tracking ? queryParams.tracking : 'false';
            var tracking = loginParam === 'true';
            if(tracking){
                 window.dataLayer = window.dataLayer || [];
                                window.dataLayer.push({
                                     'event': 'portalloginevent',
                                     'portalcategory': 'Affiliate'
                                 });
                                console.log(window.dataLayer);
                window.history.pushState('page2', 'Title', '/'+url);
             }
             setTimeout(function () {
                 jQuery("#loader").hide();
                 }, 5000);
        },
    //basic check for absolute urls. Not concerned about any other url format except http e.g. ftp etc.
    isAbsoluteUrl: function(url) {
      return url.charAt(0) !== '/';
    },

    formatRedirectUrl: function(url) {
      if(SageGlobals.isAbsoluteUrl(url)) {
        return SageGlobals.verifyExternalUrl(url) ? url : '/';
      }
      else {
        return url;
      }
    },

    getHostName: function(url) {
      var match = url.match(/:\/\/(www[0-9]?\.)?(.[^\/:]+)/i);
      if (match != null && match.length > 2 && typeof match[2] === 'string' && match[2].length > 0) {
        return match[2];
      }
      else {
        return null;
      }
    },

    parseDomain: function(url) {
      var hostName = SageGlobals.getHostName(url);
      var domain = hostName;

      if (hostName !== null) {
        var parts = hostName.split('.').reverse();

        //only work on TLD's without a .
        //co.uk would fail
        if (parts !== null && parts.length > 1) {
          domain = parts[1] + '.' + parts[0];
        }
      }

      return domain;
    },

    verifyExternalUrl: function(url) {
      return IOT_CONFIG.WHITELISTED_DOMAINS.indexOf(SageGlobals.parseDomain(url)) !== -1;
    },

    toggleLoginModal: function() {
      $('#login').trigger('click');
    },

    saveAccount: function(viewModel, payload) {
      viewModel.accountId(payload.id || '');
      viewModel.accounts(payload.accountContactRelation || []);
      viewModel.memberId(payload.memberId || '');
      viewModel.companyName(payload.companyName || '');
      viewModel.industry(payload.industry || '');
      viewModel.companySize(payload.companySize || '');
      viewModel.empCount(payload.empCount || '');
      viewModel.vendorInterest(payload.vendorInterest  || '');
      viewModel.nonprofit(payload.nonprofit  || '');
      viewModel.taxID(payload.taxID  || '');
      viewModel.memberLeadSource(payload.memberLeadSource  || '');
      viewModel.memberLeadSourceDetail(payload.memberLeadSourceDetail  || '');
      viewModel.website(payload.website || '');
      viewModel.membershipSize(payload.membershipSize || '');
      viewModel.address1(payload.billingStreetAddress || '');
      viewModel.city(payload.billingCity || '');
      viewModel.st(payload.billingSt || '');
      viewModel.postalCode(payload.billingPostalCode || '');
      viewModel.country(payload.billingCountry || '');
      viewModel.verizonNPPEligibility(payload.verizonNPPEligibility || '');
      viewModel.verizonVerizonEligibility(payload.verizonVerizonEligibility || '');
      viewModel.verizonAgreement(payload.verizonAgreement || '');
      viewModel.passCode(payload.passCode || '');
    },

    saveContact: function(viewModel, payload) {
      viewModel.username(payload.email || '');
      viewModel.fname(payload.firstName || '');
      viewModel.lname(payload.lastName || '');
      viewModel.tel(payload.phone || '');
      viewModel.telExt(payload.phoneExt || '');
      viewModel.telMobile(payload.phoneMobile || '');
      viewModel.userId(payload.contactIdentifier || '');
      viewModel.title(payload.title || '');
      viewModel.department(payload.department || '');
      viewModel.emailOptOut(payload.emailOptOut || 'false');
      viewModel.dataSharingAllowed(payload.dataSharingAllowed || false);
      jQuery('#optIn').prop( "checked", (payload.emailOptOut==='true')?false:true)  ;
      jQuery('#dataSharingAllowed').prop( "checked", (payload.dataSharingAllowed==='true')?true:false)  ;
    },

    _mergeAppMetadata: function(userMetaData, appMetaData) {
      var userProfile = {
        firstName: '',
        lastName: ''
      };

      var appProfile = {
        contactId: '',
        contactType: '',
        accountId: '',
        accounts: '',
        associationId: '',
        industry: '',
        billingSt: '',
        billingCountry: '',
        verizonNPPEligibility: '',
        verizonVerizonEligibility: '',
        verizonAgreement: ''
      };

      //prevent properties from being added to the default obj
      Object.seal(userProfile);
      Object.seal(appProfile);

      return {
        user: Object.assign(userProfile, userMetaData),
        app: Object.assign(appProfile, appMetaData)
      };
    },

    mergeProfile: function(userMetaData, appMetaData) {
      var metadata = SageGlobals._mergeAppMetadata(userMetaData, appMetaData);

      return {
        user_metadata: metadata.user,
        app_metadata: metadata.app
      };
    },

    //internal use observables
    _saveContact: function(viewModel, payload) {
      viewModel._contactType(payload.type || '');
      viewModel._contactId(payload.id || '');
      viewModel._username(payload.email || '');
      viewModel._fname(payload.firstName || '');
      viewModel._lname(payload.lastName || '');
      viewModel._tel(payload.phone || '');
      viewModel._telExt(payload.phoneExt || '');
      viewModel._telMobile(payload.phoneMobile || '');
      viewModel._userId(payload.userId || '');
      viewModel._title(payload.title || '');
      viewModel._department(payload.department || '');
      viewModel._emailOptOut(payload.emailOptOut || 'false');
      viewModel._dataSharingAllowed(payload.dataSharingAllowed || 'false');
      viewModel._association(payload.associationId || '');
      viewModel._recordTypeName(payload.recordTypeName || '');
      viewModel._migratedUser(payload.migratedUser || '');
    },

    UserLoggedInViewModel: function(isLoggedIn) {
      var self = this;
      self.isLoggedIn = ko.observable(isLoggedIn);
    },

    resetPasswordViewModal: function(email, connection) {
      var self = this;
      SageGlobals.formViewModel.call(self);

      self.connectionValid = ko.observable(false);
      self.email = ko.observable(email || '');
      self.submit('Reset My Password');

      if(typeof connection !== 'undefined') {
        self.connectionValid(connection.split(';').indexOf('Database') !== -1);
      }

      self.validate = function() {
        return self.validateEmail(self.email()) &&
          self.connectionValid();
      };

      self.resetPassword = function() {
        /* jshint ignore:start */
        SageGlobals.showLoader();
        var webAuth = new auth0.WebAuth({
            domain:         IOT_CONFIG.AUTH0_DOMAIN,
            clientID:       IOT_CONFIG.AUTH0_CLIENT_ID,
            responseType: 'token id_token',
            redirectUri:    IOT_CONFIG.AUTH0_REDIRECTION_URL + '?connection=' + IOT_CONFIG.connection.DB
          });

        if(self.preSubmit()) {
          webAuth.changePassword({
            connection: IOT_CONFIG.connection.DB,
            email: self.email()
          }, function (err, response) {
            if(err) {
              jQuery("#loader").addClass('background-white').delay(3000).queue(function(next ){
                      jQuery(this).removeClass('background-white');
                      next();
                      jQuery("#loader").hide();
               }) ;
              self.setMessage('error', self.errorClass, err);
            }
            else {
              //return custom msg on success
              jQuery("#loader").addClass('background-white').delay(3000).queue(function(next ){
                  jQuery(this).removeClass('background-white');
                  next();
                  jQuery("#loader").hide();
               }) ;
              self.setMessage('success', self.successClass, 'We\'ve just sent you an email to reset your password.');
            }
            setTimeout(function() {
               self.resetMessages();
            }, 10000);

          });
        }
        /* jshint ignore:end */

      };
    },

    formViewModel: function() {
      var self = this;

      self.errorClass = SageGlobals.formStateClasses.error;
      self.successClass = SageGlobals.formStateClasses.success;

      self.messages = ko.observableArray();
      self.messageState = ko.observable('');

      self.submit = ko.observable('Submit');
      self.tabIndex = ko.observable('');
      self.formSubmitted = ko.observable(false);
      self.formWorking = ko.observable(false);
      self.state = ko.observable();
      self.honeyPot = ko.observable('');
      self.validateMessage = {
        tel: 'Telephone number needs to be in the format of 555-555-5555',
        email: 'Please enter a valid email address',
        require: 'This field is required',
       // confirmPassword: 'Your passwords do not match',
        //confirmEmail: 'Your email addresses do not match',
        url: 'Please enter a URL',
        postalCode: 'Please enter a postal code',
        password: 'Password must be at least 8 characters in length and contain 1 lowercase letter, 1 uppercase letter and 1 number'
      };
      self.inputClasses = {
        focus: 'is-focus',
        valid: 'is-valid',
        dirty: 'is-dirty'
      };

      //validation functions
      self.validateRequire = function(value) {
                if(jQuery('.association_page').length > 0) {
                    // jQuery('html, body').scrollTop(jQuery("#association-registration .comman-reg").offset().top-100);
                }
        return value !== '';
      };

      self.validateTel = function(value) {
        var telRe = /^\(?[\d]{3}\)?(\s|-|\.)?[\d]{3}(\s|-|\.)?[\d]{4}$/;
        return telRe.test(value);
      };

      self.validateTelOpt = function(value) {
        return self.validateTel(value) || value === '';
      };

      self.validateEmail = function(value) {
        //regex per HTML5 spec
        //var emailRe = /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
                var emailRe = /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,15}$/;
        return emailRe.test(value);
      };

      self.validateEmailOpt = function(value) {
        return self.validateEmail(value) || value === '';
      };

      self.validateUrl = function(value) {
        var urlRe = /^(?:(?:(?:https?|ftp):)?\/\/)?(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,}))\.?)(?::\d{2,5})?(?:[\/?#]\S*)?$/i;
        return urlRe.test(value);
      };

      self.validateUrlOpt = function(value) {
        return self.validateUrl(value) || value === '';
      };

      self.validatePostalCode = function(value) {
                //var postalCodeRe = /(^\d{5}(-\d{4})?$)|(^[ABCEGHJKLMNPRSTVXY]{1}\d{1}[A-Z]{1} *\d{1}[A-Z]{1}\d{1}$)/;
                var postalCodeRe = /(^(\d{5}-\d{4}|\d{5}|\d{9})$|^([a-zA-Z]\d[a-zA-Z]( )?\d[a-zA-Z]\d)$)/;
        return postalCodeRe.test(value);
      };

      self.validatePassword = function(value) {
        var passwordRe = /^((?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])).{8,}$/;
        return passwordRe.test(value);
      };

      self.validateConfirm = function(value) {
        return value[0] === value[1];
      };

      //internal validate function to allow for extending on a VM basic
      self._validate = function() {
        return true;
      };

      self.validate = ko.pureComputed(function() {
        return self._validate();
      });

      //functions to process validation/focus feedback on form elements
      //msg, validateFunction and value are optional for non-required inputs
      self.updateInput = function(event, element, className, msg, validateFunction, value) {
        if(event === 'blur') {
          $(element).removeClass(className);
        }
        else if(event === 'focus') {
          $(element).addClass(className);
        }

        self.processInput(element, msg, validateFunction, value);
      };
             self.validateRegEmail = function(event, element, className, msg, validateFunction, value) {
                 console.log(value);
                  var email=value;
                  var rejectList = [ "itisverywell.com", "example.com", "thefmails.com" , "yandex.com" ,".ru" ,".top", ".de",".xyz",".ua",".pl",".lv",".website"];
                  var splitArray = email.split('@'); // To Get Array
                  var dotemail=email.substring(email.lastIndexOf("."));
                  if(rejectList.indexOf(splitArray[1]) >= 0 || rejectList.indexOf(dotemail) >= 0 ){
                 
                   if(jQuery('#partner-registration').length===0){
                    jQuery(".email_ck").parent().parent().siblings('.button-section').find('.btn-inactive-ra').addClass('btn-active-ra');
                    jQuery(".email_ck").parent().parent().siblings('.button-section').find('.btn-inactive-ra').prop("disabled", true);
                    }else {
                     jQuery('.btn-active-ra').prop("disabled", true);
                    }
                     jQuery(".email_ck").addClass('is-invalid user-error');
                     return false;
                 } else { 
                    if(jQuery('#partner-registration').length===0){
                    jQuery(".email_ck").parent().parent().siblings('.button-section').find('.btn-inactive-ra').removeClass('btn-active-ra');
                    jQuery(".email_ck").parent().parent().siblings('.button-section').find('.btn-inactive-ra').prop("disabled", false);
                    } else { jQuery('.btn-active-ra').prop("disabled", false); }
                    jQuery(".email_ck").removeClass('is-invalid user-error');
                     return true;
                 }
            };
            //for rep email validation start
            self.validateRepEmail = function(event, element, className, msg, validateFunction, value) {
                console.log(value);
                var email=value;
                var rejectList = [ "itisverywell.com", "example.com", "thefmails.com" , "yandex.com" ,".ru" ,".top", ".de",".xyz",".ua",".pl",".lv",".website"];
                var splitArray = email.split('@'); // To Get Array
                var dotemail=email.substring(email.lastIndexOf("."));
                if(rejectList.indexOf(splitArray[1]) >= 0 || rejectList.indexOf(dotemail) >= 0 ){
                        jQuery(".email_ck").parent().parent().siblings('.button-section').find('.btn-inactive-ra').addClass('btn-active-ra');
                        jQuery(".email_ck").parent().parent().siblings('.button-section').find('.btn-inactive-ra').prop("disabled", true);
                        jQuery(".email_ck").addClass('is-invalid user-error');
                    return false;
                } else {
                    var str=jQuery(".domain_allow").val();
                    var splitString = str.split(',');
                    var emailRep=  jQuery("#empstep_2 input[name=username]").val().split('@').pop();
                    if(splitString.indexOf(emailRep) > -1)
                    {
                        jQuery("#empstep_2 input[name=username]").removeClass('is-invalid user-error');
                        jQuery("#empstep_2 .btn-inactive-ra").prop("disabled", false);
                        return true;
                    } else{

                        if( jQuery("#empstep_2 input[name=username]").val()==='cras.nmcmillan@gmail.com'||
                            jQuery("#empstep_2 input[name=username]").val()==='mcmillanaudio@gmail.com'){
                            jQuery("#empstep_2 input[name=username]").removeClass('is-invalid user-error');
                            jQuery("#empstep_2 .btn-inactive-ra").prop("disabled", false);
                            return true;
                        } else{
                            jQuery("#empstep_2 input[name=username]").addClass('is-invalid user-error');
                            jQuery("#empstep_2 .btn-inactive-ra").prop("disabled", true);
                            return false;
                        }

                    }

                    return true;
                }
            };

            //for rep email validation end

      //check passcode on blur
            self.checkPasscode = function (event, element, className, msg, validateFunction, value,type,fieldid) {
               if(event === 'blur') {
                $(element).removeClass(className);
              }
              else if(event === 'focus') {
                $(element).addClass(className);
              }
                jQuery("#passcode_wrong, #passcode_wrong_affilate").css({display: "none"});
                jQuery("#passcode_ok, #passcode_ok_affilate").css({display: "none"});

              self.endPoint = 'contact';
              var queryParams = SageGlobals.getQueryParameters();
              var passcode = queryParams.passcode || '';
               if (self.endPoint === 'contact' && jQuery('#'+fieldid).val().length === 8 ) {
                jQuery('#employee-section .form__msg ul').empty();
                self.processInput(element, msg, validateFunction, value);
                jQuery('#loading_data_icon').html('<i class="fa fa-spinner fa-pulse fa-2x fa-fw"></i>');
                var img_url= IOT_CONFIG.AUTH0_SITE_URL+"/app/themes/sage/assets/images/image-loader.gif";
                jQuery('#loading_data_icon_pass, #loading_data_icon_pass_affilate').html("<img src='" + img_url + "'>");
                 // Get Salesforce access token
                callSalesforceApi('/services/apexrest/CompanyPasscodeVerification/' + self.passCode() + '/' + type, 'GET')

                   .then(function(result) {
                   var flow = queryParams.flow || '';
                   jQuery('#loading_data_icon').html('');
                   jQuery('#loading_data_icon_pass, #loading_data_icon_pass_affilate').html('');

                   // Parse the result string into a JSON object
                   var parsedResult = result;

                   if (parsedResult.success === true) {
                       var accountID1 = parsedResult.accountid;
                       sessionStorage.setItem('accountId', accountID1);
                       jQuery("#passcode_wrong, #passcode_wrong_affilate").css({display: "none"});
                     jQuery("#passcode_ok, #passcode_ok_affilate").css({display: "block"});
                     jQuery('#regpasscodeinfo #continue,#regpasscodeinfo #continue_affilate').removeAttr("disabled");
                     jQuery('#regpasscodeinfo #continue,#regpasscodeinfo #continue_affilate').addClass('btn-active-ra');
                     jQuery('#passcode, #passcode-affiliate').removeClass('is-invalid user-error');

                     if (passcode !== '') {
                       setTimeout(function () {
                         jQuery('#regpasscodeinfo #continue,#regpasscodeinfo #continue_affilate').trigger('click');
                       }, 500);
                     }

                     if(jQuery(".domain_allow").length > 0){
                       var accountID = parsedResult.accountId;
                       console.log(accountID);
                       if(jQuery('#'+accountID).length > 0) {
                         console.log('here'+accountID);
                         jQuery(".domain_allow[id !='"+accountID+"']").remove();
                       } else {
                         jQuery(".domain_allow[id !='domain_allow']").remove();
                       }
                     }
                   }
                   else {
                     jQuery("#passcode_ok, #passcode_ok_affilate").css({display: "none"});
                     jQuery("#passcode_wrong, #passcode_wrong_affilate").css({display: "block"});
                     jQuery('#passcode, #passcode-affiliate').addClass('is-invalid user-error');
                     jQuery('#regpasscodeinfo #continue,#regpasscodeinfo #continue_affilate').attr("disabled","disabled");
                     jQuery('#regpasscodeinfo #continue, #regpasscodeinfo #continue_affilate').removeClass('btn-active-ra');
                   }
              })
              .catch(function (response) {
                            jQuery("#passcode_wrong, #passcode_wrong_affilate").css({display: "block"});
                            jQuery("#passcode_ok, #passcode_ok_affilate").css({display: "none"});
                            jQuery('#regpasscodeinfo #continue,#regpasscodeinfo #continue_affilate').attr("disabled","disabled");
                            jQuery('#regpasscodeinfo #continue,#regpasscodeinfo #continue_affilate').removeClass('btn-active-ra');
                SageGlobals.log({
                  errorSeverity: 'WARNING',
                  error: response,
                  payload: self.passCode(),
                  description: 'Exception during CompanyPasscode.Get in ' + self.endPoint
                });
                //self.setMessage('error', self.errorClass, SageGlobals.GENERIC_ERROR_MSG);
              });
            }else{
                    jQuery("#passcode_ok,#passcode_ok_affilate").css({display: "none"});
              if(passcode!==''){
                        jQuery('#passcode, #passcode-affiliate').addClass('is-invalid user-error');
              }
                    jQuery('#regpasscodeinfo #continue,#regpasscodeinfo #continue_affilate').attr("disabled","disabled");
              //jQuery("span#errMsg").html("<b>! Invalid passcode</b>");
                    jQuery('#regpasscodeinfo #continue,#regpasscodeinfo #continue_affilate').removeClass('btn-active-ra');
            }


      };
      //passcode verification end
      //handles any validation logic for the form element
      self.processInput = function(element, msg, validateFunction, value) {
        //trigger autofill check for Safari to keep Knockout in sync
        $(element).checkAndTriggerAutoFillEvent();
        self.setValidationMessage(element, msg, validateFunction, value);

        //set dirty class on element to handle UI rendering of invalid state
        if(!$(element).hasClass(self.inputClasses.dirty)) {
          $(element).addClass(self.inputClasses.dirty);
        }
      };

      //set custom validation message for element
      self.setValidationMessage = function(element, msg, validateFunction, value) {
        //if element is <select> add :invalid class to select wrapper
        if(typeof validateFunction === 'function') {
          if(!validateFunction(value)) {
            element.setCustomValidity(msg);

            if($(element).hasClass('is-dirty')) {
              $(element).addClass('is-invalid');
              if($(element).data('customvalidate') === true) {
                $(element).parents('.field').find('.field__validation').text(msg);
              }
            }
          }
          else {
            $(element).removeClass('is-invalid');
            element.setCustomValidity('');
            if($(element).data('customvalidate') === true) {
              element.setCustomValidity('');
              $(element).parents('.field').find('.field__validation').text('');
            }
          }
        }

      };

      self.clearValidationMessage = function(element) {
        element.setCustomValidity('');
      };

      self.resetMessages = function() {
        self.messages([]);
      };

      self.setMessage = function(status, statusClass, message) {
        self.setWorking(false);
          self.messages.push({
            status: status,
            statusClass: statusClass,
            message: message
          });
      };

      self.setState = function(val) {
        self.state(val);
        self.resetMessages();
      };

      self.setWorking = function(state) {
        self.formWorking(state);
      };

      self.preSubmit = function() {
        //empty message array to reset
        self.resetMessages();

        //ignore all form submit events while form is processing
        if(self.formWorking()) {
          return false;
        }

        /*if(!self.validate()) {
          self.setMessage('error', self.errorClass, 'Please fill out all required fields.');
          return false;
        }*/

        //set form working states
        self.formSubmitted(true);
        self.setWorking(true);

        //ignore request if honeypot is triggered by bot
        if(self.honeyPot() !== '') {
          self.setWorking(false);
          return false;
        }
        else {
          return true;
        }
      };
    },

    stateCountryViewModel: function() {
      var self = this;

      self.st = ko.observable('');
      self.stDisplay = ko.observable('');
      self.country = ko.observable('');
      self.countryDisplay = ko.observable('');

      //when country changes, reset state select to null to force user to choose a new valid state
      self.country.subscribe(function(newValue) {
        self.st('');
      });
    },

    contactViewModel: function() {
      var self = this;

      //external properties
      self.username = ko.observable('');
      self.manageremail = ko.observable('');
      //self.usernameConfirm = ko.observable('');
      self.fname = ko.observable('');
      self.lname = ko.observable('');
      self.tel = ko.observable('');
      self.telExt = ko.observable('');
      self.telMobile = ko.observable('');
      self.userId = ko.observable('');
      self.title = ko.observable('');
      self.vendorInterest = ko.observable('');
      self.rep_Name = ko.observable('');
      self.rep_email = ko.observable('');
      self.rep_tel = ko.observable('');
      self.taxID = ko.observable('');
      self.nonprofit = ko.observable('');
      self.department = ko.observable('');
      self.emailOptOut = ko.observable('false');
      self.dataSharingAllowed = ko.observable('false');
      self.passCode = ko.observable('');
      self.password = ko.observable('');
      //self.passwordConfirm = ko.observable('');

      //internal props
      self._contactType = ko.observable('');
      self._contactId = ko.observable('');
      self._username = ko.observable('');
      self._manageremail = ko.observable('');
      self._fname = ko.observable('');
      self._lname = ko.observable('');
      self._tel = ko.observable('');
      self._telExt = ko.observable('');
      self._telMobile = ko.observable('');
      self._userId = ko.observable('');
      self._title = ko.observable('');
      self._department = ko.observable('');
      self._emailOptOut = ko.observable('false');
      self._dataSharingAllowed = ko.observable('false');
      self._association = ko.observable('');
      self._recordTypeName = ko.observable('');
      self._migratedUser = ko.observable('');

      self.$referrerAssociation = $('#referrer-association');
      self.$referrerAssociationName = $('#referrer-association-name');
      self.$referrer_lead_source = $('#referrer-association_lead_source');
      self.$referrer_campaign = $('#referrer-association_campaign');
      self.memberAssocEndPoint = 'Member_Association__c';

      self.formatTel = function(val) {
        var reFormat = /([\d]{3})([\d]{3})([\d]{4})/,
          strippedTel = val.replace(self.telReplaceRe, '');

        return strippedTel.replace(reFormat, '($1) $2-$3');
      };

      self.formatPasscode = function(val) {
        return val.toUpperCase();
      };

      self.createUserData = function() {
        return {
          firstname: self.fname(),
          lastname: self.lname(),
          email: self.username(), 
          tel: self.formatTel(self.tel()),
          ext: self.telExt(),
          joinDate: SageGlobals.getTimeStamp(),
          userSelectedAssociation: self.computedAssociation(),
          managerEmail: self.manageremail()
        };
      };


      self.computedAssociation = ko.pureComputed(function() {
        return self.$referrerAssociation.length ? self.$referrerAssociation.val() : '';
      });

      self.computedAssociationName = ko.pureComputed(function() {
        return self.$referrerAssociationName.length ? self.$referrerAssociationName.val() : '';
      });


      //passcode validation
      self.validateMessage.passCode = 'Passcode needs to be 8 characters long';
      self.validatePasscode = function(value) {
        var passCodeRe = /^[a-zA-Z0-9]{8}$/;
        return passCodeRe.test(value);
      };

      self.validatePasscodeOpt = function(value) {
        return self.validatePasscode(value) || value === '';
      };

      //TODO: replace with standard tel validation functions in Form VM
      self.telRe = /^[0-9]{10}$/;
      self.telReplaceRe = /[^0-9]/g;
      self.emailRe = /^.+@.+\..+$/;

      //TODO: replace with standard tel validation functions in Form VM
      self.confirmTel = function() {
        var strippedTel = self.tel().replace(self.telReplaceRe, '');
        return strippedTel.match(self.telRe);
      };

      //TODO: replace with standard tel validation functions in Form VM
      self.confirmTelMobile = function() {
        var strippedTel = self.telMobile().replace(self.telReplaceRe, '');
        return strippedTel.match(self.telRe) || self.telMobile() === '';
      };

      self.fullName = ko.pureComputed(function() {
        return self.fname() + ' ' + self.lname();
      });

      self.emailOptOutFormatted = ko.pureComputed(function() {
        return self.emailOptOut() === 'false' ? 'Yes' : 'No';
      });
    },

    accountViewModel: function() {
      var self = this;

      self.accountId = ko.observable('');
      self.accounts = ko.observableArray();
      self.memberId = ko.observable('');
      self.companyName = ko.observable('');
      self.industry = ko.observable('');
      self.industrySubCategory = ko.observable('');
      self.companySize = ko.observable();
      self.empCount = ko.observable();
      self.memberLeadSource = ko.observable();
      self.memberLeadSourceDetail = ko.observable();
      self.website = ko.observable('');
      self.address1 = ko.observable('');
      self.address2 = ko.observable('');
      self.city = ko.observable('');
      self.st = ko.observable('');
      self.stDisplay = ko.observable('');
      self.postalCode = ko.observable('');
      self.country = ko.observable('');
      self.countryDisplay = ko.observable('');
      self.verizonNPPEligibility = ko.observable('');
      self.verizonVerizonEligibility = ko.observable('');
      self.verizonAgreement = ko.observable('');
      self.membershipSize = ko.observable('');

      self.industryDisplay = ko.pureComputed(function () {
        return self.industry() !== '' ? self.industry() : '--Select Industry--';
      });

      self.companySizeDisplay = ko.pureComputed(function () {
        return self.companySize() !== '' ? self.companySize() : '--Select Company Size--';
      });

      self.streetAddress = ko.pureComputed(function() {
        if(self.address2() !== '') {
          return self.address1() + ' ' + self.address2();
        }
        else {
          return self.address1();
        }
      });

      self.address = ko.pureComputed(function() {
        return self.accountBillingStreet() + '<br>' +
          self.accountBillingCity() + ', ' + self.accountBillingState() + ' ' + self.accountBillingPostalCode() + '<br>' +
          self.accountBillingCountry();
      });
    },
        sort_Data:function(subIndustry){
            var temp = [];
            jQuery.each(subIndustry, function(key, value) {
                temp.push({v:value, k: key});
            });
            temp.sort(function(a,b){
               if(a.v > b.v){ return 1;}
                if(a.v < b.v){ return -1;}
                  return 0;
            });
            return temp;
         },
          getIndustryData: function (host,recordType){
                 var values="Dependent_Picklist_Field=Lead.Organization_Category__c&getIndustryList=Yes&recordType="+recordType;
                                jQuery.ajax({
                                    url: host + "/app/themes/sage/lib/leadSearch.php",
                                    type: "POST",
                                    dataType: 'text',
                                    data: values,
                                    success: function(data) {
                                      jQuery('#busi_industry').empty();
                                      jQuery('#busi_industry').append('<option value="">--Select Industry--</option>');
                                      var mainIndustry=Object.keys(JSON.parse(data));
                                      mainIndustry=mainIndustry.sort();
                                      var mainIndustrytemp = [];
                                      jQuery.each(mainIndustry, function(key, value) {
                                          var industryArr = value.split('+');
                                          mainIndustrytemp.push(industryArr[1]+"+"+industryArr[0]);
                                      });
                                      mainIndustrytemp = mainIndustrytemp.sort();
                                      jQuery.each(mainIndustrytemp, function(key, value) {
                                          var industryArr = value.split('+');
                                          var $option = jQuery("<option/>", {
                                          //value: value,
                                          //text: value
                                           value: industryArr[1],
                                           text: industryArr[0]
                                      });
                                      jQuery('#busi_industry').append($option);
                              });

                              jQuery('#busi_industry').niceSelect('update');
                              jQuery('#busi_industry').next(".nice-select").children('.list').mCustomScrollbar();
                              jQuery("#busi_industry").change(function (e) {
                                  jQuery('#busi_industry').next(".nice-select").find('li:first').prop("disabled", true);
                                  //var industry=jQuery("#busi_industry option:selected" ).val();
                                  var industry=jQuery("#busi_industry option:selected" ).val() +"+"+ jQuery("#busi_industry option:selected" ).text() ;
                                  var subIndustry=JSON.parse(data)[industry];
                                  var temp= SageGlobals.sort_Data(subIndustry);
                                  jQuery('#busi_subindustry').empty();
                                  jQuery('#busi_subindustry').append('<option value="">--Select Sub Industry--</option>');

                                    jQuery.each(temp, function(key, obj) {

                                  jQuery('#busi_subindustry').append(jQuery("<option></option>")
                                         .attr("value", obj.v).text(obj.k));
                                  });
                                   jQuery('#busi_subindustry').niceSelect('update');
                                   jQuery('#busi_subindustry').next(".nice-select").children('.list').mCustomScrollbar();
                                   jQuery('#busi_subindustry').next(".nice-select").find('li:first').prop("disabled", true);
                              });
                                                   }
                                               });
          },
    getCookieValue: function (cname){
                      var name = cname + "=";
                      var decodedCookie = decodeURIComponent(document.cookie);
                      var ca = decodedCookie.split(';');
                      for(var i = 0; i <ca.length; i++) {
                        var c = ca[i];
                        while (c.charAt(0) === ' ') {
                          c = c.substring(1);
                        }
                        if (c.indexOf(name) === 0) {
                          return c.substring(name.length, c.length);
                        }
                      }
                      return "";
          },
    registrationViewModel: function() {
      var self = this;
      //define redirection url. Override with querystring parameter if one exists
      var queryParams = SageGlobals.getQueryParameters();
      var redirectParam = queryParams.redirection ? SageGlobals.formatRedirectUrl(decodeURIComponent(queryParams.redirection)) : false;
      self.redirectUrl = redirectParam ? redirectParam : '/account-pending';
      self.migrateUserUrl = redirectParam ? redirectParam : '/email-verified';

      self.leadSource = 'Web';
      self.$redirectForm = $('#registration-next-step');

      SageGlobals.formViewModel.call(self);

      self.data = {};
      self.endPoint = null;

      //internal validate function to allow for extending on a VM basic
      self._validate = function() {

          //self.validateConfirm([self.username(), self.usernameConfirm()]) &&
         return self.validateEmail(self.username()) &&
          //self.validateConfirm([self.username()]) &&
          self.fname() !== '' &&
          self.lname() !== '' &&
             self.manageremail() !== '' &&
          self.validateTelOpt(self.tel()) &&
          self.validatePassword(self.password()) ;
          //self.validateConfirm(self.password());
          //self.validateConfirm([self.password(), self.passwordConfirm()]);
      };

      self.login = function(redirect) {
        /* jshint ignore:start */
        var webAuth = new auth0.WebAuth({
          domain: IOT_CONFIG.AUTH0_DOMAIN,
          clientID: IOT_CONFIG.AUTH0_CLIENT_ID,
          responseType: 'token id_token',
          redirectUri:    IOT_CONFIG.AUTH0_REDIRECTION_URL + '?connection=' + IOT_CONFIG.connection.DB + '&origin=' + redirect
        });

        if(self.loginPassthrough()) {
          window.location.href = self.modalRedirect();
        }
        else {
          webAuth.login({
            realm: IOT_CONFIG.connection.DB,
            username: self.username(),
            email: self.username(),
            password: self.password()
          }, function(err) {
            SageGlobals.log({
              errorSeverity: 'NOTICE',
              error: err,
              payload: {email: self.username(), password: self.password()}
            });
            //just redirect them. They will have to login manually
            window.location.href = redirect;
          });
        }
        /* jshint ignore:end */

      };

      //stub method that is meant to be overridden to allow for additional properties to be added to the object
      self.getRegistrationFlowData = function(data) {
        return data;
      };

      self.checkEmailExists = function(msg) {
        if(msg === 'The user already exists.') {
          return {
            errorMsg: 'This email address is already in use. Please <a data-gat="click" data-gatcategory="Registration" data-gatlabel="Error Message" data-gataction="Toggle Login" href="/?login=true">login</a> or use another email address.If you have any questions on your registration, please contact us at <a href="mailto:customerservice@mynpp.com">customerservice@mynpp.com</a> or <a href="tel:800.810.3909">800.810.3909</a>.',
            errorSeverity: 'NOTICE'
          };
        }
        else {
          return false;
        }
      };

      self.createAccounts = function($this, existingUser, profileData, mergedConnections) {
          var accountId1 = sessionStorage.getItem('accountId'); // Retrieve the accountId from sessionStorage
          self.data.accountId = accountId1;
        var createIncompleteUserPromise = _Auth0.createUser(profileData);
        createIncompleteUserPromise.then(function(result) {
          //result = Auth0 profile
          var userId = result.user_id;
          //create SF contact
          self.data.connection = mergedConnections.join(';');

          //append registration flow specific data
          self.data = self.getRegistrationFlowData(self.data);

          //dont set joinDate if existing user as to maintain the original join date
          //Delete if existing user and current registration have same type
          if(existingUser) {
            delete self.data.joinDate;
           }

            callSalesforceApi("/services/apexrest/"+self.endPoint, "POST", {contact:self.data})
          .then(function(result) {
            if(result.success === true) {

              //if association selected - create MemberAssociation object and attach to Contact
              // if(self.computedAssociation()) {
              //   var memberAssociation = {
              //     association: self.computedAssociation(),
              //     contact: result.id,
              //     isMember: true,
              //     primaryAssociation: true
              //   };
              //
              //   var memberAssocProm = _Boomi.sendRequest('POST', self.memberAssocEndPoint, memberAssociation);
              //   memberAssocProm.then(function (result) {
              //     if(result.success !== 'true') {
              //       SageGlobals.log({
              //         errorSeverity: 'WARNING',
              //         error: result.status.errors,
              //         payload: result.payload,
              //         description: 'Failure in ' + self.endPoint + ' - ' + self.memberAssocEndPoint + '.Create'
              //       });
              //     }
              //   }).catch(function(response) {
              //     //if there is an error adding the association log it, but let the process continue
              //     SageGlobals.log({
              //       errorSeverity: 'WARNING',
              //       error: response,
              //       payload: memberAssociation,
              //       description: 'Exception thrown during ' + self.endPoint + ' - ' + self.memberAssocEndPoint + '.Create'
              //     });
              //   });
              // }

              var prom = _Auth0.linkUser(userId, result.contact.Id);
              prom.then(function() {
                                        var date = new Date(),
                                            expires = 'expires=';
                                        var minutes = 30;
                                        date.setTime(date.getTime() + (minutes * 60 * 1000));
                                        expires += date.toGMTString();
                                        document.cookie =  'emp_details=' + JSON.stringify({fname: self.data.firstname, lname: self.data.lastname,manageremail: self.data.manageremail, email: self.data.email, phone: self.data.phone}) + '; ' + expires + '; path=/';

               window.location.href = self.redirectUrl;
              })
                .catch(function(response) {
                  SageGlobals.log({
                    errorSeverity: 'WARNING',
                    error: response,
                    payload: {userId: userId, payload: result.contact.Id},
                    description: 'Failure in Auth0.linkUser'
                  });

                     window.location.href = self.redirectUrl;
                });

                //set pageview completion of registration flow
                  if(IOT_CONFIG.HOST===SiteUrl) {
                      ga('set', 'page', '_registration/' + self.endPoint);
                      ga('send', 'pageview');

                      //if external url - add GA pageview to help with Goal tracking
                      if(SageGlobals.isAbsoluteUrl(self.redirectUrl)) {
                        ga('set', 'page', '_' + self.redirectUrl);
                        ga('send', {
                          hitType: 'pageview',
                          title: self.redirectUrl
                        });
                      }
                  }
                  //for sales rep registration
                 if(window.location.origin===PortalSiteUrl){
                    ga('set', 'page', 'rep-registration');
                    ga('send', 'pageview');

                    //if external url - add GA pageview to help with Goal tracking
                      if(SageGlobals.isAbsoluteUrl(self.redirectUrl)) {
                        ga('set', 'page', '_' + self.redirectUrl);
                        ga('send', {
                          hitType: 'pageview',
                          title: self.redirectUrl
                        });
                      }
                 }

            }
            else {
              if(result.statusCode === '200') {
                // failed to create SF contact. But no exception thrown.
                result.status.errors.forEach(function(item) {
                  self.setMessage('error', self.errorClass, item.message);
                });

                SageGlobals.log({
                  errorSeverity: 'NOTICE',
                  error: result.status.errors,
                  payload: result.payload,
                  description: 'Failure in ' + self.endPoint + '.Create. Deleting Auth0 user [' + self.username() + '].'
                });

                var deleteUserOnFailureProm = _Auth0.deleteUser(userId);
                deleteUserOnFailureProm.then(function() {
                  //Auth0 user successfully deleted
                  SageGlobals.log({
                    errorSeverity: 'NOTICE',
                    description: 'Successfully deleted Auth0 account because registration failure'
                  });
                })
                  .catch(function(response) {
                    SageGlobals.log({
                      errorSeverity: 'WARNING',
                      error: response,
                      payload: userId,
                      description: 'Failed to delete Auth0 account during registration failure'
                    });
                  });

              }
              else {
                //failed to create SF contact - delete Auth0 account to ensure atomic operation
                SageGlobals.log({
                  errorSeverity: 'WARNING',
                  error: result.status.errors || result.status,
                  payload: result.payload,
                  description: 'Error in ' + self.endPoint + '.Create. Deleting Auth0 user [' + self.username() + '].'
                });
                self.setMessage('error', self.errorClass, 'Something went wrong during registration. Please try again later.');

                var deleteUserProm = _Auth0.deleteUser(userId);
                deleteUserProm.then(function() {
                  //Auth0 user successfully deleted
                  SageGlobals.log({
                    errorSeverity: 'NOTICE',
                    description: 'Successfully deleted Auth0 account because registration failure'
                  });
                })
                  .catch(function(response) {
                    SageGlobals.log({
                      errorSeverity: 'WARNING',
                      error: response,
                      payload: userId,
                      description: 'Failed to delete Auth0 account during registration failure'
                    });
                  });
              }
            }
          })
            .catch(function(response) {
              //exception thrown during create request
              SageGlobals.log({
                errorSeverity: 'WARNING',
                error: response,
                payload: self.data,
                description: 'Exception thrown during ' + self.endPoint + '.Create. Deleting Auth0 user [' + self.username() + '].'
              });
              self.setMessage('error', self.errorClass, 'Something went wrong during registration. Please try again later.');
              var prom = _Auth0.deleteUser(userId);
              prom.then(function() {
                self.setWorking(false);
                SageGlobals.log({
                  errorSeverity: 'NOTICE',
                  description: 'Successfully deleted Auth0 account because registration failure'
                });
              })
                .catch(function(response) {
                  SageGlobals.log({
                    errorSeverity: 'WARNING',
                    error: response,
                    payload: userId,
                    description: 'Failed to delete Auth0 account during registration failure'
                  });
                });
            });
        })
          .catch(function(response) {
            //failed to create Auth0 account
            var errorMsg = SageGlobals.GENERIC_ERROR_MSG;
            var errorSeverity = 'CRITICAL';
            var emailExists = self.checkEmailExists(response.message);
            if(emailExists !== false) {
              errorMsg = emailExists.errorMsg;
              errorSeverity = emailExists.errorSeverity;
              jQuery("#loader").hide();
            }

            SageGlobals.log({
              errorSeverity: errorSeverity,
              error: response,
              payload: profileData.email,
              description: 'Exception thrown during Auth0.Create'
            });
            self.setMessage('error', self.errorClass, errorMsg);
          });
      };

      self.register = function(form) {
       SageGlobals.showLoader();
        var $this = $(form);
        if(self.preSubmit()) {
          //check if user exists in SF by email.
          //if exists and migrated - sync, else deny
          var record_type='';
          var acc_type="Member Company";
          if (self.contactType.toLowerCase() === "consumer"){
              record_type = "Consumer";
          } else if( self.contactType.toLowerCase() === "company rep" ){
              record_type = "company rep";
          }  else if ( self.contactType.toLowerCase() === "company employee") {
              record_type = "company employee";
          } else if(self.contactType.toLowerCase()==="affiliate"){
              acc_type="Association";
              record_type = "affiliate";
          } else if(self.contactType.toLowerCase()==="sales rep"){
              acc_type="Partner";
              record_type = "sales rep";
          } else {
              record_type = "Sales Rep,Affiliate";
          }

          // var prom = _Boomi.sendRequest('GET', 'contact/email', self.username()+ '/' +record_type);
          var encodedEmail = encodeURIComponent(self.username());
          var prom = callSalesforceApi('services/apexrest/contact?contacttype='+ encodeURIComponent(record_type) +'&email='+encodedEmail, 'GET', {'apiName':'getContact'});
          prom.then(function(result) {
            var profileData = {
              connection: IOT_CONFIG.connection.DB,
              email: self.username(),
              password: self.password(),
              name: self.fullName()
            };
            var existingConnections = result.connection ? result.connection.split(';') : [];
            var mergedConnections = [];
            var existingUser = result.success === 'true';

            var mergeConnections = function (array1, array2) {
              var mergedArray = array1.concat(array2);

              return mergedArray.filter(function (item, index) {
                return mergedArray.indexOf(item) === index;
              });
            };


                            //var validateRecordType=false;
//                            var record_type = '';
//                            if (self.contactType.toLowerCase() === "consumer" || self.contactType.toLowerCase() === "company rep" || self.contactType.toLowerCase() === "company employee") {
//                                record_type = "member";
//                            }
//                            else {
//                               record_type = self.contactType.toLowerCase();
//                            }
//                            if(result.success === 'true'){
//                              validateRecordType=(self.contactType.toLowerCase() === result.recordTypeName.toLowerCase());
//                            }

                            //if (existingUser && result.success === 'true' && validateRecordType) {
                             if (existingUser && result.success === 'true' ) {
                                var url=IOT_CONFIG.PORTAL_HOST + "/";
                                if(record_type === "Consumer"){
                                    self.setMessage('error', self.errorClass, "This email address is already in use. Please <a data-gat='click' data-gatcategory='Registration' data-gatlabel='Error Message' data-gataction='Toggle Login' href='/?login=true'>login</a> or use another email address.");
                                } else {
                                    self.setMessage('error', self.errorClass, "This email address is already in use. Please <a href="+url+">login</a> or use another email address.");
            }
                       jQuery("#loader").hide();
            }else{
            //migrated user
            if (existingUser && result.migratedUser === 'true') {
              //do async operations to update user in SF as well as Auth0 since the operations don't depend on each other
              mergedConnections = mergeConnections(existingConnections, ['Database']);

              var userData = {
                emailVerified: true,
                emailVerifiedDate: SageGlobals.getTimeStamp(),
                connection: mergedConnections.join(';')
              };
              //since migrated user. Set email verified fields
              // var updateUserPromise = _Boomi.sendRequest('PUT',  'contact/' + result.id, userData);
              var updateUserPromise = callSalesforceApi("/services/apexrest/contact/" + result.id, "PUT", {contact:userData});
              updateUserPromise.then(function(result) {
                if (result.success !== true) {
                  SageGlobals.log({
                    errorSeverity: 'WARNING',
                    error: result.status.errors || result.status,
                    payload: Object.assign({}, profileData, userData),
                    description: 'Error when updating Migrated user email verified timestamp on registration'
                  });
                }
              })
              .catch(function(response) {
                SageGlobals.log({
                  errorSeverity: 'WARNING',
                  error: response,
                  payload: Object.assign({}, profileData, userData),
                  description: 'Exception when updating Migrated user email verified timestamp on registration'
                });
              });


              //user is a migrated user in SF, only create Auth0 account
              //set email as verified because they already exist in SF
              profileData.email_verified = true;
              emailid=profileData.email; //for qualtrics
              profileData = Object.assign(profileData, SageGlobals.mergeProfile(
                {
                  firstName: result.firstName,
                  lastName: result.lastName
                },
                {
                  contactId: result.id,
                  contactType: result.type,
                  accountId: result.hasOwnProperty('accountId') ? result.accountId : '',
                  accounts: result.hasOwnProperty('accountContactRelation') ? result.accountContactRelation : []
                }
              ));

              var createCompleteUserPromise = _Auth0.createUser(profileData);
              createCompleteUserPromise.then(function() {
                //result == Auth0 profile
              if(IOT_CONFIG.HOST===SiteUrl) {
                ga('set', 'page', '_registration/' + self.endPoint);
                ga('send', 'pageview');

                //if external url - add GA pageview to help with Goal tracking
                if(SageGlobals.isAbsoluteUrl(self.migrateUserUrl)) {
                  ga('set', 'page', '_' + self.migrateUserUrl);
                  ga('send', {
                    hitType: 'pageview',
                    title: self.migrateUserUrl
                  });
                }
                }

                window.location.href = self.migrateUserUrl;
              })
              .catch(function(response) {
                var errorMsg = SageGlobals.GENERIC_ERROR_MSG;
                var errorSeverity = 'CRITICAL';
                var emailExists = self.checkEmailExists(response.message);
                if(emailExists !== false) {
                  errorMsg = emailExists.errorMsg;
                  errorSeverity = emailExists.errorSeverity;
                   jQuery("#loader").hide();

                }

                SageGlobals.log({
                  errorSeverity: errorSeverity,
                  error: response,
                  payload: profileData,
                  description: 'Failure in Auth0.createUser'
                });
                self.setMessage('error', self.errorClass, errorMsg);
              });
            }
            else { //net new user or existing non-migrated user
              if(existingUser || (result.success === 'false' && result.statusCode === '200')) {


                //valid response. Create Auth0 + SF account
                 
                mergedConnections = mergeConnections(existingConnections, ['Database']);

  
                //if existing user, set email_verified to current user value, otherwise set to false to force verification
                //Delete if existing user and current registration have same type
                if(result.success === 'true') {
                  profileData.email_verified = result.emailVerified === 'true';
                }
                else {
                  profileData.email_verified = false;
                }

                //if Employee flow check if passcode is valid before creating Auth0 account
                  if(self.endPoint === 'contact' && self.passCode() ) {
                 callSalesforceApi('/services/apexrest/CompanyPasscodeVerification/' + self.passCode() + '/' + acc_type, 'GET')

                 .then(function(result) {
                    // Parse the result string into a JSON object
                    var parsedResult = result;

                    if (parsedResult.success === true) {
                      self.createAccounts($this, existingUser, profileData, mergedConnections);
                    }
                    else {
                      self.setMessage('error', self.errorClass, 'Invalid passcode.');
                    }
                  })
                    .catch(function(response) {
                      SageGlobals.log({
                        errorSeverity: 'WARNING',
                        error: response,
                        payload: self.passCode(),
                        description: 'Exception during CompanyPasscode.Get in ' + self.endPoint
                      });
                      self.setMessage('error', self.errorClass, SageGlobals.GENERIC_ERROR_MSG);
                    });
                }
                else {
                  self.createAccounts($this, existingUser, profileData, mergedConnections);
                }

              }
              else {
                //exception thrown during contact.email.get
                SageGlobals.log({
                  errorSeverity: 'WARNING',
                  error: result.status.errors || result.status,
                  payload: result.payload,
                  description: 'Exception thrown during contact/email.get'
                });
                self.setMessage('error', self.errorClass, 'Something went wrong during registration. Please try again later.');
              }

            }
          }
          })
          .catch(function(errorMessage) {
            //exception thrown during getMigratedUser
            SageGlobals.log({
              errorSeverity: 'WARNING',
              error: errorMessage,
              payload: self.username(),
              description: 'Exception thrown during Contact/email.Get'
            });
            self.setMessage('error', self.errorClass, 'Something went wrong, please try again later.');
          });
        }
      };
    },

    accountRegistrationViewModel: function (username, token, redirectUrl, nonce, processFlow) {
      var self = this;
      SageGlobals.registrationViewModel.call(self);
      SageGlobals.contactViewModel.call(self);
      SageGlobals.accountViewModel.call(self);

      //internal properties
      self.endPoint = 'contact/email';
      self.contactEndPoint = 'contact/token';
      self.accountEndPoint = 'Account';
      self.registrationPromises = [];
      self.verifyEmail = true;
      self.processFlow = processFlow || '';
      self.accountLoad = true;

      //override default registration redirect
      self.redirectUrl = redirectUrl || self.redirectUrl;

      //validity checks + state holders
      self.loaded = ko.observable(false);
      self.loadingFailure = ko.observable(false);
      self.accountExists = ko.observable();

      self.valid = ko.pureComputed(function() {
        return username !== '' && token !== '';
      });

      self.cityStateZip = ko.pureComputed(function() {
        return self.city() + ', ' + self.st() + ' ' + self.postalCode();
      });

      //extend validate function to add validUser check because inputs come in through qstring
      self.validate = ko.pureComputed(function() {
        return self._validate() && self.valid();
      });

      self.toggleLoginModal = function() {
        SageGlobals.toggleLoginModal();
      };

      //STUB function to be override as necessary to pass additional promises to AccountRegistration
      self.getPromises = function() {
        return [];
      };

      //STUB function to be overridden to set user values prior to Auth0 account creation
      self.setUserData = function() {
        return;
      };

      //override register process to only update Contact and create Auth0 account
      self.register = function() {
        // update Contact and then create Auth0 account
         SageGlobals.showLoader();
        if (self.preSubmit()) {
          //let viewModels update the properties as needed prior to Auth0 account creation
          self.setUserData();
          var profileData = {
            connection: IOT_CONFIG.connection.DB,
            email: self.username(),
            email_verified: self.verifyEmail,
            password: self.password(),
            name: self.fullName()
          };

          //set accounts to empty string because passing an empty array causes Auth0 to ignore it
          //accounts gets set on impersonation
          profileData = Object.assign(profileData, SageGlobals.mergeProfile(
            {
              firstName: self.fname(),
              lastName: self.lname()
            },
            {
              contactId: self._contactId(),
              contactType: self._contactType(),
              accountId: self.accountId(),
              accounts: '',
              associationId: self._association(),
              industry: self.industry(),
              billingSt: self.st(),
              billingCountry: self.country(),
              verizonNPPEligibility: self.verizonNPPEligibility(),
              verizonVerizonEligibility: self.verizonVerizonEligibility(),
              verizonAgreement: self.verizonAgreement()
            }
          ));

          self.userData = self.getRegistrationFlowData();
          var createIdpAccountPromise = _Auth0.createUser(profileData);
          //make sure to reset promises to empty array so we don't keep adding new promises in case reg fails the first time
          self.registrationPromises = [];
          self.registrationPromises.push(createIdpAccountPromise);

          try {
            self.registrationPromises = self.registrationPromises.concat(self.getPromises(self));
          }
          catch(e) {
            SageGlobals.log({
              errorSeverity: 'WARNING',
              error: 'Promises not passed in as an Array',
              payload: null
            });
             jQuery("#loader").hide();
            self.setMessage('error', self.errorClass, SageGlobals.GENERIC_ERROR_MSG);
            throw new Error('Invalid parameters passed to accountRegistrationViewModel');
          }

          Promise.all(self.registrationPromises).then(function(result) {
            //redirect user to thank you page.
            window.location.href = self.redirectUrl;
          })
            .catch(function(response) {
              SageGlobals.log({
                errorSeverity: 'WARNING',
                error: response,
                payload: Object.assign({contactId: self.contactId}, self.userData),
                description: 'Exception caught during Contact update and/or Auth0 account create for ' + self.processFlow
              });
              //Don't show error message because the individual exceptions will show their own specific ones
            });

          createIdpAccountPromise.catch(function(response) {
            var errorMsg = SageGlobals.GENERIC_ERROR_MSG;
            var errorSeverity = 'CRITICAL';
            var emailExists = self.checkEmailExists(response.message);
            if(emailExists !== false) {
              errorMsg = emailExists.errorMsg;
              errorSeverity = emailExists.errorSeverity;
            }

            SageGlobals.log({
              errorSeverity: errorSeverity,
              error: response,
              payload: profileData,
              description: 'Exception thrown during Auth0.Create'
            });
             jQuery("#loader").hide();
            self.setMessage('error', self.errorClass, errorMsg);
          });
        }
      };

      //load account + contact data to init VW with data
      if(username !== '' && token !== '') {
        //query Auth0 for email
        var queryParams = {
          fields: 'user_id',
          searchValues: username
        };

        _Auth0.query(queryParams).then(function (result) {
          if (result.length) {
            //Auth0 account already exists. Show error message
            self.accountExists(true);
            self.loaded(true);
          }
          else {
            self.accountExists(false);
            //user doesn't exist in Auth0. Let me complete the flow
            // var contactProm = _Boomi.sendRequest('GET', self.contactEndPoint, username + '/' + token);
            var contactProm = callSalesforceApi('services/apexrest/contact?token='+ token + '&email=' + encodeURIComponent(username), 'GET', {'apiName':'getContact'});
            contactProm.then(function(result) {

            if(result.success === 'true') {
                //reject if contact is a Partner
                //because those don't go through registration and email should never show up in this flow
                if (result.recordTypeName !== 'Member' && result.recordTypeName !== 'Sales Rep' && result.recordTypeName !== 'Affiliate') {
                  SageGlobals.log({
                    errorSeverity: 'NOTICE',
                    error: 'Non-Member email used during ' + self.processFlow,
                    payload: {email: username, token: token}
                  });
                    // jQuery("#loader").hide();
                  self.loadingFailure(true);
                  self.setMessage('error', self.errorClass, 'Invalid email address. Please contact support.');
                }
                else {
                  //set knockout observable properties from data returned from SFDC
                  //save raw object because we don't want to pre-populate contact info
                  self.contactObject = result;
                  SageGlobals._saveContact(self, result);

                  if(self.accountLoad) {
                    if(typeof result.accountId === 'undefined' || result.accountId === '') {
                      SageGlobals.log({
                        errorSeverity: 'WARNING',
                        error: 'No Account found for ' + self.processFlow,
                        payload: result.accountId
                      });
                    // jQuery("#loader").hide();
                      self.loadingFailure(true);
                      self.setMessage('error', self.errorClass, SageGlobals.GENERIC_ERROR_MSG);

                    }
                    else {
                      // var accountProm = _Boomi.sendRequest('GET', self.accountEndPoint, result.accountId);
                      var accountProm = callSalesforceApi('services/apexrest/Account/'+ result.accountId, 'GET', {'apiName':'getAccount'});
                      accountProm.then(function(result) {

                        if(result.success === 'true') { //found an Account
                          SageGlobals.saveAccount(self, result);
                          self.loaded(true);

                        }
                        else { //Either didn't find Account or an error happened
                          SageGlobals.log({
                            errorSeverity: 'WARNING',
                            error: result,
                            payload: {id: result.accountId},
                            description: 'No account found or an error happened during ' + self.processFlow
                          });
                            //jQuery("#loader").hide();
                          self.loadingFailure(true);
                          self.setMessage('error', self.errorClass, SageGlobals.GENERIC_ERROR_MSG);

                        }
                      })
                        .catch(function(response) { //Most likely 500 error from Boomi/SFDC
                          SageGlobals.log({
                            errorSeverity: 'WARNING',
                            error: response,
                            payload: {email: username, token: token},
                            description: 'Exception when loading account on ' + self.processFlow
                          });
                          //jQuery("#loader").hide();
                          self.loadingFailure(true);
                          self.setMessage('error', self.errorClass, SageGlobals.GENERIC_ERROR_MSG);

                        });
                    }
                  }
                  else {
                    //since we aren't loading Account - set loaded to true
                    self.loaded(true);
                  }

                }
              }
              else { //Didn't find Contact or error happened
                SageGlobals.log({
                  errorSeverity: 'WARNING',
                  error: result.status.errors || result.status,
                  payload: {email: username, token: token},
                  description: 'Failure to find contact on ' + self.processFlow
                });
                  // jQuery("#loader").hide();
                //failed due to user not being found
                self.loadingFailure(true);
                self.setMessage('error', self.errorClass, SageGlobals.GENERIC_ERROR_MSG);

              }
            }).catch(function(response) { //Most likely 500 error from Boomi/SFDC
              SageGlobals.log({
                errorSeverity: 'WARNING',
                error: response,
                payload: {email: username, token: token},
                description: 'Exception when loading contact on ' + self.processFlow
              });
             //jQuery("#loader").hide();
              self.loadingFailure(true);
              self.setMessage('error', self.errorClass, SageGlobals.GENERIC_ERROR_MSG);

            });
          }
        })
          .catch(function(response) {
            self.loadingFailure(true);
             // jQuery("#loader").hide();
            self.setMessage('error', self.errorClass, SageGlobals.GENERIC_ERROR_MSG);

            SageGlobals.log({
              errorSeverity: 'WARNING',
              error: response,
              payload: {email: username}
            });

          });
      }
      else {
        self.loadingFailure(true);
         // jQuery("#loader").hide();
        self.setMessage('error', self.errorClass, SageGlobals.GENERIC_ERROR_MSG);

        SageGlobals.log({
          errorSeverity: 'WARNING',
          error: 'Missing username and/or token in ' + self.processFlow,
          payload: {email: username, token: token}
        });

      }
    },

    common: function() {
      //setup form classes string
      var classes = Object.getOwnPropertyNames(this.formStateClasses);
      this.formClasses = classes.reduce(function(a, b) {
        return this.formStateClasses[a] + ' ' + this.formStateClasses[b];
      }.bind(this));
    },

    handleFormMsg: function($el, state, msg) {
      $el.find('.form__msg__text').removeClass(this.formClasses).addClass(this.formStateClasses[state]).text(msg);
    },

    equalHeight: function($elements) {
      var maxHeight = 0;

      $elements.each(function(index, element) {
        var currHeight = $(element).outerHeight();
        maxHeight = currHeight > maxHeight ? currHeight : maxHeight;
      });

      $elements.css({'min-height' : maxHeight + 'px'});
    },

    /*
     *  getQueryParameters.js
     *  Copyright (c) 2014 Nicholas Ortenzio
     *  The MIT License (MIT)
     *
     */
    getQueryParameters: function(str) {
      return decodeURIComponent((str || document.location.search)).replace(/(^\?)/, '').split("&").map(function (n) {
        return n = n.split("="), this[n[0]] = n[1], this;
      }.bind({}))[0];
    }
  };

  var Sage = {
    // All pages
    'common': {

      // JavaScript to be fired on all pages
      init: function() {
        //set initial set of logged in. Key off log out button in header
        var userState = new SageGlobals.UserLoggedInViewModel($('#logout').length !== 0);
         var oldFlexBoxSupport = Modernizr.prefixedCSSValue('display', 'flex') === '-webkit-flex';

        SageGlobals.common();
         if ( ! Modernizr.objectfit ) {
           $('.hero').each(function () {
             var $container = $(this),
               imgUrl = $container.find('.hero__image').prop('src');
             if (imgUrl) {
               $container
                 .css('backgroundImage', 'url(' + imgUrl + ')')
                 .addClass('hero--no-object-fit ');
             }
           });
         }

         if(oldFlexBoxSupport) {
           $('html').addClass('old-flex');
         }

        //polyfill html5 form functionality such as validation etc
        webshim.setOptions('loadStyles', false);
        webshims.polyfill('forms');

        //init header nav
        //calc height of nav to push submenu to be flush with bottom of header
        this.initSessionCheck(userState);
        var $primaryNav = $('#primary-nav'),
          $banner = $('#banner'),
          paddingDifference = parseInt($banner.css('padding-top'), 10) - parseInt($banner.css('padding-bottom'), 10);

        $primaryNav.find('.sub-menu').css('padding-top', ($('#banner').outerHeight() - paddingDifference - $primaryNav.outerHeight()) / 2);

        //toggle 'active' class to show submenus on hover
        $primaryNav.on('mouseover mouseout', '.menu-item-has-children', function(e) {
          if(e.type === 'mouseover') {
            $(this).addClass('is-active');
          }
          else {
            $(this).removeClass('is-active');
          }
        });

        $('[data-toggle]').on('click', function() {
          var $this = $(this);
          $this.toggleClass('is-active');
          $this.parents('.menu-item-has-children').find('.sub-menu').slideToggle(500, function() {});
        });

        //add EH for all login model trigger buttons/links
        if($('#login').length) {
          $('[data-login-trigger]').on('click', function(e) {
            e.preventDefault();
            SageGlobals.toggleLoginModal();
          });
        }
      var self = this,
      queryParams = SageGlobals.getQueryParameters();
      var loginParam = queryParams.login ? queryParams.login : 'false';
      var login = loginParam === 'true';
       if(login){
            setTimeout(function (event) {
                  jQuery("#login_main_button").trigger('click');
            }, 1000);
        }
        //make header fixed
        this.fixHeader();
        this.initKo();
        this.setupBanner();
      },

      initKo: function() {
        ko.bindingHandlers.updateStateSelectDisplay = {
          init: function(element, valueAccessor, allBindings, bindingContext) {
            var value = valueAccessor(),
              valueUnwrapped = ko.unwrap(value);

            bindingContext.stDisplay($(element).find(':selected').text());
          },
          update: function(element, valueAccessor, allBindings, bindingContext) {
            var value = valueAccessor(),
              valueUnwrapped = ko.unwrap(value);

            bindingContext.stDisplay($(element).find(':selected').text());

            }
        };

        ko.bindingHandlers.updateCountrySelectDisplay = {
          init: function(element, valueAccessor, allBindings, bindingContext) {
            var value = valueAccessor(),
              valueUnwrapped = ko.unwrap(value);

            bindingContext.countryDisplay($(element).find(':selected').text());
          },
          update: function(element, valueAccessor, allBindings, bindingContext) {
            var value = valueAccessor(),
              valueUnwrapped = ko.unwrap(value);

            bindingContext.countryDisplay($(element).find(':selected').text());
              setTimeout(
                  function()
                  {
                               //jQuery('#company_state').niceSelect('update');
                               // jQuery('#company_state').next().removeClass('user-success');
                               // jQuery('.comman-reg #company_state').next().addClass('is-invalid');
                                //jQuery('.select_states .list').mCustomScrollbar();
                            jQuery( "#company_state" ).select2();
                             jQuery("#company_state").find('option:first').prop("disabled", false);
                             jQuery('.select2-container--default').css('width','100%').addClass('nice-select');
                             jQuery('.select2-selection--single').css({"border": "none", "height": "35px","margin-top": "8px","outline": "none!important"});
                            jQuery('.select2-selection__arrow').css({"height": "100%"}).hide();
                   }, 300);

                    if ($(element).find(':selected').text() === 'Canada') {
                        jQuery('#postal_code_dnb_plus').attr('minlength', 7);
                        jQuery('#postal_code_dnb_plus').attr('maxlength', 10);
                    } else {
                        jQuery('#postal_code_dnb_plus').attr('minlength', 5);
                        jQuery('#postal_code_dnb_plus').attr('maxlength', 5);
                    }
                        jQuery('.comman-reg #postal_code_dnb_plus').val('');
                        jQuery('.comman-reg #postal_code_dnb_plus').addClass('is-invalid');

          }
        };

        ko.bindingHandlers.updateAccountSelectDisplay = {
          init: function(element, valueAccessor, allBindings, bindingContext) {
            var value = valueAccessor(),
              valueUnwrapped = ko.unwrap(value);

            bindingContext.accountDisplay($(element).find(':selected').text());
          },
          update: function(element, valueAccessor, allBindings, bindingContext) {
            var value = valueAccessor(),
              valueUnwrapped = ko.unwrap(value);

            bindingContext.accountDisplay($(element).find(':selected').text());
          }
        };

        ko.bindingHandlers.updateAssociationSelectDisplay = {
          update: function(element, valueAccessor, allBindings, bindingContext) {
            var value = valueAccessor(),
              valueUnwrapped = ko.unwrap(value),
              industry = bindingContext.industry(),
              st = bindingContext.st();

            // only fire off request if we have valid parameters
            if(bindingContext.showAssociationSelection()) {
              bindingContext.associationsLoaded(false);
              //TODO: figure out some kind of caching option here to avoid timeouts
              //cache ALL associations for 24 hours and just request subset here?
              var promAssoc = _Boomi.sendRequest('GET', 'Account/associationlist', '', {'industry': industry, 'state': st});

              promAssoc.then(function(result) {
                if(result.success === 'true') {
                  if(result.accountList) {
                    //empty association array before populating with new results
                    bindingContext.availableAssociations([]);
                    result.accountList.forEach(function(item) {
                      bindingContext.availableAssociations.push(new bindingContext.Association(item));
                    });
                  }
                  else {
                    //log failure to find associations -- should only happen for Other industry.
                    SageGlobals.log({
                      errorSeverity: 'NOTICE',
                      error: 'Empty query result',
                      payload: 'Industry: ' + industry + ', State: ' + st,
                      description: 'NO associations returned from  Account/associationlist.Get'
                    });
                  }
                }
                else {
                  bindingContext.availableAssociations([]);
                  SageGlobals.log({
                    errorSeverity: 'WARNING',
                    error: result.status.errors,
                    payload: 'Industry: ' + industry + ', State: ' + st,
                    description: 'Error returned from Account/associationlist.Get'
                  });
                }
                bindingContext.associationsLoaded(true);
              })
                .catch(function(response) {
                  SageGlobals.log({
                    errorSeverity: 'WARNING',
                    error: response,
                    payload: 'Industry: ' + industry + ', State: ' + st,
                    description: 'Exception thrown during Account/associationlist.Get'
                  });
                });
            }
            else {
              bindingContext.availableAssociations([]);
            }
          }
        };
      },
            initSessionCheck: function(userState) {
                function redirectUser(isLoggedIn) {
                    //if user is logged out send them to inactive page else just reload the current page
                    if(!isLoggedIn) {
                        var redirect = SageGlobals.invalidRedirects.indexOf(window.location.pathname) !== -1 ? '/' : window.location.pathname;
                        window.location.href = '/logged-out-inactive?redirection=' + redirect;
                    }
                    else {
                        window.location.reload(false);
                    }
                }

                //only check 1x/minute for logged in state change
                var checkUserSession = SageGlobals.debounce(function() {
                    $.ajax({
                        method: 'POST',
                        url: '/lib/check-user-session.php',
                        data: {
                            'nonce': $('#user-session-nonce').val(),
                            'loggedInState': userState.isLoggedIn()
                        }
                    })
                        .done(function (data) {
                            var result = JSON.parse(data);
                            if(result.success === 'true') {
                                if(result.stateChange) {
                                    redirectUser(result.loggedIn);
                                }
                            }
                            else {
                                //nonce invalid - force refresh
                                if(result.stateChange) {
                                    redirectUser(result.loggedIn);
                                }
                                else {
                                    window.location.reload(false);
                                }
                            }
                        })
                        .fail(function (data) {
                            SageGlobals.log({
                                errorSeverity: 'WARNING',
                                error: JSON.parse(data),
                                description: 'Error returned from check user session'
                            });
                        });
                }, 60000, true);

                //wait 15 minutes before testing for session change on focus. Session timeout is 24 minutes so we should cover it easily
                setTimeout(function() { 
                    if(jQuery('.accountnav-container .user-name').find('span').text()!=='') {
                    $(window).on('focus', checkUserSession);
                    }
                }, 900000);
            },

      fixHeader: function() {
        $('body').addClass('is-fixed');

        $('#wrap').css('margin-top', $('#banner').outerHeight());
      },

      setupBanner: function() {
        var domain = IOT_CONFIG.AUTH0_DOMAIN,
          clientID = IOT_CONFIG.AUTH0_CLIENT_ID,
          redirectionUrl = IOT_CONFIG.AUTH0_REDIRECTION_URL,
          $loginModal = $('#login-modal'),
          $passwordResetForm = $loginModal.find('[data-pw-reset]');

        var BannerViewModal = function() {
          var self = this,
            queryParams = SageGlobals.getQueryParameters();

          SageGlobals.formViewModel.call(self);

          var loginParam = queryParams.login ? queryParams.login : 'false';
          var login = loginParam === 'true';

          self.email = ko.observable('');
          self.password = ko.observable('');
          self.state = ko.observable('login');
          self.loginActive = ko.observable(login);
          self.searchActive = ko.observable(false);
          self.offCanvasActive = ko.observable(false);
          self.accountToggleActive = ko.observable(false);
          self.searchVisible = ko.observable(false);
          self.loginFocused = ko.pureComputed(function() {
            return self.loginActive();
          });

          self.enableAccountToggle = function() {
            self.accountToggleActive(true);
          };

          self.disableAccountToggle = function() {
            self.accountToggleActive(false);
          };

          self.setLoginActive = function(val) {
			var body = document.body,
			html = document.documentElement;

			var height = Math.max( body.scrollHeight, body.offsetHeight,
					   html.clientHeight, html.scrollHeight, html.offsetHeight );
			document.getElementById("login-modal").style.height = height.toString() + 'px';
            //don't let the user close the modal if the form is processing a form submission
            if(!val && self.formWorking()) {
              return;
            }
			//This will delay while login model close
			if( val ) {
				self.loginActive(val);
				self.resetMessages();
				//if we are closing reset to login state
				if(!val) {
					self.state('login');
				}
				else { //if we are opening ensure offcanvas is false
				  self.offCanvasActive(false);
				}
			}
			else {
				jQuery("._modal").addClass('zoomOut');
				setTimeout(function(){
					self.loginActive(val);
					self.resetMessages();
					//if we are closing reset to login state
					if(!val) {
						self.state('login');
					}
					else { //if we are opening ensure offcanvas is false
					  self.offCanvasActive(false);
					}
					jQuery("._modal").removeClass('zoomOut');
				}, 300);
			}
          };

          self.setSearchActive = function(val) {
            self.searchActive(val);
            jQuery('._search__input').focus();
          };

          self.setState = function(val) {
            //jQuery("#email_alert").hide();
            //jQuery("#pass_alert").hide();
            $('#login-modal').find("input,textarea,select").val('').end()
                             .find("input[type=radio]").prop("checked", "").end();
            self.state(val);
            jQuery('.login_fail .form__msg ul').empty();
            self.resetMessages();
          };

          self.setOffCanvasActive = function(val) {
            self.offCanvasActive(val);
            if(val) {
              $('body').addClass('no-scroll');
            }
            else {
              $('body').removeClass('no-scroll');
            }

            self.loginActive(false);
            self.state('login');
          };

          self.validate = ko.pureComputed(function() {
            return self.validForm();
          });

          self.validForm = function() {
            return self.email() !== '' && self.password() !== '';
          };
        };

        var AccountToggleViewModel = function($form) {
          var self = this;

          self.account = ko.observable();
          self.accountDisplay = ko.observable('');
          self.form = $form;

          self.setActiveAccount = function(account) {
            self.account(account);
            self.toggleAccount();
            SageGlobals.showLoader();
          };

          self.toggleAccount = function() {
            self.form.submit();

          };
        };

        var MobileAccountToggleViewModel = function($form) {
          var self = this;

          AccountToggleViewModel.call(self, $form);

          self.accountListActive = ko.observable(false);

          self.toggleAccountListActive = function() {
            self.accountListActive(!self.accountListActive());
          };
        };

        var LoginFormViewModel = function(bannerViewModal) {
          var self = this;
          SageGlobals.formViewModel.call(self);

          self.email = ko.observable('');
          self.password = ko.observable('');
          self.remember =  ko.observable(true);
          self.submit('Login');
          self.tabIndex(4);

          self.bannerViewModel = bannerViewModal;


          self.validate = ko.pureComputed(function () {
            return self.validateEmail(self.email()) &&
              self.password() !== '';
          });

          self.setState = function(val) {
            self.bannerViewModel.setState(val);
          };

          self.handleLogin = function() {
            /* jshint ignore:start */
           // if(self.preSubmit()) {
              //self.resetMessages();
              var connection = IOT_CONFIG.connection.DB,
                queryParams = SageGlobals.getQueryParameters(),
                redirect = queryParams.redirection ? SageGlobals.formatRedirectUrl(decodeURIComponent(queryParams.redirection)) : window.location.pathname;
                // redirect = window.location.pathname;

              //if redirect location is a page that doesn't make sense e.g. /migrate send user to home instead
              if(SageGlobals.invalidRedirects.indexOf(redirect) !== -1) {
                redirect = '/';
              }
                         var assoc='';
                       if(jQuery('.association_page').length > 0)
                                { assoc='&asscPage=true' }
               SageGlobals.showLoader();
               jQuery('#home_email, #homepassword_type').focus(function()
               { jQuery(this).removeClass('user-error'); });
               var webAuth = new auth0.WebAuth({
                domain:         domain,
                clientID:       clientID,
                responseType: 'token id_token',
                            redirectUri: redirectionUrl + '?connection=' + connection + '&origin=' + redirect + '&remember=' + self.remember()+assoc
              });

              webAuth.login({
                realm: connection,
                username: self.email(),
                email: self.email(),
                password: self.password(),
                responseMode: 'form_post'
              }, function(response) {
               var errorMessage ='Sorry! We are experiencing technical difficulties. Please try back shortly.';
                //override error message if invalid password to give additional guidance
                if(response.code === 'access_denied') {
                  //query for 'imported' user. If found, send change email address email and update message
                  var queryParams = {
                    fields: 'email,app_metadata',
                    searchValues: self.email()
                  };
                  //var errorMessage = 'Your email and/or password is incorrect. Confirm your email above, or click the Forgot Password link to reset your password.<br><br>If you need assistance, please contact us at <a href="mailto:customerservice@mynpp.com">customerservice@mynpp.com</a> or <a href="tel:8008103909">800.810.3909</a>.';
                     errorMessage = 'Your email and/or password is incorrect. Confirm your email below, or click the Forgot Password link to reset your password.';
                  _Auth0.query(queryParams).then(function (result) {
                    var user = result[0];

                    //user will be undefined is the email address does not exist in Auth0
                    if (user !== undefined && user.app_metadata && user.app_metadata.hasOwnProperty('imported') && user.app_metadata.imported) {
                        var resetPassword = new SageGlobals.resetPasswordViewModal(result[0].email, 'Database');
                        resetPassword.resetPassword();
                          jQuery("#loader").addClass('background-white').delay(3000).queue(function(next ){
                            jQuery(this).removeClass('background-white');
                            next();
                            jQuery("#loader").hide();
                         }) ;
                        self.setMessage('success', self.successClass, 'We\'ve updated our systems. We are sending you an email with password reset instructions.');
                    }
                    else {
                      //regular password failure or email doesn't exist
                       jQuery("#loader").addClass('background-white').delay(3000).queue(function(next ){
                            jQuery(this).removeClass('background-white');
                            next();
                            jQuery("#loader").hide();
                         }) ;

                       jQuery("#home_email").addClass('user-error');
                       jQuery("#homepassword_type").addClass('user-error');
                       self.setMessage('error', self.errorClass, errorMessage);
                    }
                  }).catch(function (response) {
                    SageGlobals.log({
                      errorSeverity: 'WARNING',
                      error: response,
                      payload: self.email(),
                      description: 'Exception querying Auth0 during NPP login imported user check'
                    });

                    jQuery("#loader").addClass('background-white').delay(3000).queue(function(next ){
                            jQuery(this).removeClass('background-white');
                            next();
                            jQuery("#loader").hide();
                         }) ;
                     jQuery("#home_email").addClass('user-error');
                     jQuery("#homepassword_type").addClass('user-error');
                     self.setMessage('error', self.errorClass, errorMessage);
                  });
                }
                else {
                 jQuery("#loader").addClass('background-white').delay(3000).queue(function(next ){
                     jQuery(this).removeClass('background-white');
                     next();
                     jQuery("#loader").hide();
                  }) ;
                  jQuery("#home_email").addClass('user-error');
                  jQuery("#homepassword_type").addClass('user-error');
                  if(typeof response[0] == 'undefined' && errorMessage !='')
                    {
                     self.setMessage('error', self.errorClass, errorMessage);
                    }
                    else
                    {
                    self.setMessage('error', self.errorClass, response.message);
                    }

                }
              });
              // setTimeout(function() {
                  self.resetMessages();
               // }, 10000);
          //  }
            /* jshint ignore:end */
          };
        };

        ko.bindingHandlers.stopBinding = {
          init: function () {
            return {controlsDescendantBindings: true};
          }
        };
        ko.virtualElements.allowedBindings.stopBindings = true;

        //init login modal
        //let the user close the modal if they click 'off' the active model
        $loginModal.on('click', function(e) {
          if(e.target === this) {
            $('#model-close').trigger( "click" );
            jQuery("#email_alert").hide();
            jQuery("#pass_alert").hide();
            $(e.target)
                .find("input,textarea,select").val('').end()
                .find("input[type=radio]").prop("checked", "").end();
            jQuery('.login_fail .form__msg ul').empty();
          }
        });
       $('#login-modal #model-close').on('click', function(e) {
                   jQuery("#email_alert").hide();
                   jQuery("#pass_alert").hide();
                   $loginModal
                    .find("input,textarea,select").val('').end()
                    .find("input[type=radio]").prop("checked", "").end();
                     jQuery('.login_fail .form__msg ul').empty();
                });
        //setup EH for social login buttons
        $('[data-social]').on('click', function(e) {
          var queryParams = SageGlobals.getQueryParameters();
          var actionStr = $(this).data('action'),
            action = actionStr !== '' && ['login', 'register'].indexOf(actionStr) !== -1 ? actionStr : 'login',
            redirect = queryParams.hasOwnProperty('redirection') ? SageGlobals.formatRedirectUrl(decodeURIComponent(queryParams.redirection)) : window.location.pathname,
            socialConnection = $(this).data('social'),
            connection;

          e.preventDefault();

          if(!IOT_CONFIG.connection.hasOwnProperty(socialConnection)) {
            SageGlobals.log({
              errorSeverity: 'WARNING',
              error: 'Invalid social connection',
              payload: socialConnection,
              description: ''
            });

            return false;
          }
          else {
            connection = IOT_CONFIG.connection[socialConnection];
            /* jshint ignore:start */
            var webAuth = new auth0.WebAuth({
              domain:         domain,
              clientID:       clientID,
              responseType: 'token id_token',
              responseMode: 'form_post',
              redirectUri:    redirectionUrl + '?connection=' + connection + '&origin=' + redirect + '&action=' + action
            });

            webAuth.authorize({
              connection: connection
            }); // use connection identifier
            /* jshint ignore:end */
          }

        });


        var bannerViewModal = new BannerViewModal();
        //check for existence of banner before binding KO because some pages don't have the banner
        if(document.getElementById('banner')) {
          ko.applyBindings(bannerViewModal, document.getElementById('banner'));
        }

        if(document.getElementById('login-form')) {
          ko.applyBindings(new LoginFormViewModel(bannerViewModal), document.getElementById('login-form'));
        }

        if(document.getElementById('reset-pw')) {
          ko.applyBindings(new SageGlobals.resetPasswordViewModal(null, 'Database'), document.getElementById('reset-pw'));
        }

        if(document.getElementById('account-toggle')) {
          ko.applyBindings(new AccountToggleViewModel($('#account-toggle')), document.getElementById('account-toggle'));
        }

        if(document.getElementById('mobile-account-toggle')) {
          ko.applyBindings(new MobileAccountToggleViewModel($('#account-toggle-mobile')), document.getElementById('mobile-account-toggle'));
        }

      },

      finalize: function() {
        //setup animated scrolling
        $('[data-scroll]').on('click', function(e) {
          e.preventDefault();

          var $target = $($(this).data('scroll'));
          if($target.length) {
            $('html,body').animate({
              scrollTop: ($target.offset().top - SageGlobals.bannerHeight - SageGlobals.wpAdminHeight)
            }, 500);
          }
        });
      },
    },

    // Home
    'home': {
      init: function() {
        //init carousel
                $('.carousel').carousel({});
                 var queryParams = SageGlobals.getQueryParameters();
                var formAssemblySubmitted = queryParams.hasOwnProperty('tfa_next');
                var contactUpdate = queryParams.hasOwnProperty('contactUpdate');
                 if (formAssemblySubmitted) {
                    var date = new Date();
                     date.setTime(date.getTime()+(1*24*60*60*1000));
                     var expires = "; expires="+date.toGMTString();
                     document.cookie = "Survey=Submitted"+expires+"; path=/";
                    jQuery('#myModal').modal('show');
                    jQuery('.modal').attr('style', 'display: block !important');
                    jQuery('.offer_redemption_main').css('display','none');
                    jQuery('#offer_redemption_thanks').css('display','block');
                    window.history.pushState('page2', 'Title', '/');
               }
               if (contactUpdate) {
                  var date1 = new Date();
                   date1.setTime(date1.getTime()+(2147483647 * 1000));
                   var expires1 = "; expires="+date1.toGMTString();
                   document.cookie = "contactUpdate=Submitted"+expires1+"; path=/";
                  jQuery('#myModalContact').modal('show');
                  jQuery('#myModalContact').attr('style', 'display: block !important');
                  jQuery('#offer_redemption_main_contact').css('display','none');
                  jQuery('#offer_redemption_thanks_contact').css('display','block');
                  window.history.pushState('page2', 'Title', '/');
              }
                jQuery('#myModal').on('hidden.bs.modal', function () {
                  var date = new Date();
                   date.setTime(date.getTime()+(1*24*60*60*1000));
                   var expires = "; expires="+date.toGMTString();
                   document.cookie = "Survey=Submitted"+expires+"; path=/";
        });
                 jQuery("#myModalContact #modal-btn-si").off('click').on("click", function(){
                           jQuery('#myModalContact').modal('hide');
                            var date = new Date();
                           date.setTime(date.getTime()+(2147483647 * 1000));
                           var expires = "; expires="+date.toGMTString();
                           document.cookie = "contactUpdate=Submitted"+expires+"; path=/";
               	});
               	 jQuery("#myModalContact").on('hidden.bs.modal', function () {
                       jQuery('#myModalContact').modal('hide');
                        var date = new Date();
                       date.setTime(date.getTime()+(2147483647 * 1000));
                       var expires = "; expires="+date.toGMTString();
                       document.cookie = "contactUpdate=Submitted"+expires+"; path=/";
                });

      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
      }
    },
'single_marketing': {
   init: function () {
    SageGlobals.showLoader();
    setTimeout(function () {
         jQuery("#loader").hide();
    }, 3000);
  }
},
    //Offer Detail
    'single_offer': {
      init: function() {
        var queryParams = SageGlobals.getQueryParameters();
        var formAssemblySubmitted = queryParams.hasOwnProperty('tfa_next');

        var $loginTrigger = $('#login-trigger');

        var emailViewModel = function() {
          var self = this,
            userId = $('#uid').val();

          SageGlobals.formViewModel.call(self);

          self.submit = ko.observable('Resend verification email');

          self.sendVerificationEmail = function() {
            if(self.preSubmit()) {
              var prom = _Auth0.sendVerificationEmail(userId);
              prom.then(function() {
                self.setMessage('success', self.successClass, 'Verification email sent.');
              })
              .catch(function(response) {
                    self.setMessage('error', self.errorClass, 'Failure sending verification email: ' );
              });
            }
          };
        };

        if($('#email-verification-form').length) {
          ko.applyBindings(emailViewModel, document.getElementById('email-verification-form'));
        }

        //setup Login trigger click if necessary
        if($loginTrigger.length) {
          $loginTrigger.on('click', function() {
            $('#login').trigger('click');
          });
        }

        //TODO: remove once Gravity Forms are deprecated
        $(document).bind('gform_confirmation_loaded', function(){
          $('#redemption-heading').remove();
          //scroll to confirmation text
          $('html,body').animate({
            scrollTop: ($('#redemption-container').offset().top - SageGlobals.bannerHeight - SageGlobals.wpAdminHeight)
          }, 200);
        });

        //scroll to confirmation text for FormAssembly submissions
        if(formAssemblySubmitted) {
//                    $('html,body').animate({
//                        scrollTop: ($('#redemption-container').offset().top - SageGlobals.bannerHeight - SageGlobals.wpAdminHeight)
//                    }, 200);
                   jQuery('#myModal').modal('show');
                  jQuery('.offer_redemption_main').css('display','none');
                  jQuery('#offer_redemption_thanks').css('display','block');
                  window.history.pushState('page2', 'Title', window.location.pathname);
        }

        //AJAX submission of redemption link
        var RedemptionLinkViewModel = function($form) {
          var self = this;

          SageGlobals.formViewModel.call(self);

          self.handleSubmit = function() {
            var data = $form.serialize(),
              action = $form.attr('action'),
              method = $form.attr('method'),
              url = $(this).attr('href');

            _Lib.sendRequest('POST', 'redeem.php', data);
            return true;
          };
            self.handleSubmitExpedia = function() {
                      var data = $form.serialize(),
                        action = $form.attr('action'),
                        method = $form.attr('method'),
                        url = $(this).attr('href');

                      _Lib.sendRequest('POST', 'redeem.php', data);
                       setTimeout(function() {
                     location.reload(true);
                        }, 5000);

                      return true;
                    };
        };

        $('[data-redemption]').each(function() {
          var $form = $(this);
          ko.applyBindings(new RedemptionLinkViewModel($form), $form.get(0));
        });
      }
    },

    //Category Pages
    'archive': {
      init: function() {
        //archive includes news articles so need to specify only the category pages
        var $offerFilter = $('#filter-select');

        //setup GA tracking for offer filtering
        //update label to match selected option and call navigation change as a callback to ensure the tracking call finishes
        if($offerFilter.length) {
          window.GATracker.sub('setTaxonomy', function($this) {
            $this.attr('data-gatlabel', $this.find(':selected').text());
          });

          window.GATracker.sub('navToTaxonomy', function($this) {
            window.location.href = $this.val();
          });
        }
      }
    },
//Association/Affiliate Page
'single_association': {
       init: function () {
                   jQuery('.banner__body nav.banner__nav').addClass('assoc_logo');
                   jQuery('.second_text p a').removeAttr('href onClick');
                   jQuery('.second_text p a').addClass('show_login').attr({href:'javascript'+String.fromCharCode(58)+'void(0);',onclick: 'javascript'+String.fromCharCode(58)+'show_login_popup();'});
                   jQuery('.mobile_copyright').addClass('col-xs-12').removeClass('col-xs-6');
                   jQuery('.mobile_copyright').children('.copyright').addClass('assoc_copy').css({"text-align": "center"});
                   jQuery('.mobile_copyright').children('.assoc_copy').removeClass('copyright');
                   if ($('#show_navigation').hasClass('off')) {
                         SageGlobals.hideMenu();
                      }

                      var BusinessViewModel = function () {
                          var self = this;
                          SageGlobals.registrationViewModel.call(self);
                          SageGlobals.contactViewModel.call(self);
                          SageGlobals.accountViewModel.call(self);
                          SageGlobals.stateCountryViewModel.call(self);

                          jQuery( "#company_state" ).select2();
                          jQuery("#company_state").find('option:first').prop("disabled", false);
                          jQuery('.select2-container--default').css('width','100%').addClass('nice-select');
                          jQuery('.select2-selection--single').css({"border": "none", "height": "35px","margin-top": "8px","outline": "none!important"});
                          jQuery('.select2-selection__arrow').css({"height": "100%"}).hide();

                          self.country('US');
                          //self.st(st);
                          self.leadSource = $('#lead_source').val();
                          self.leadSourceDetail = $('#lead_source_detail').val();
                          self.industry = $('#industry').val();
                          self.industrySubCategory = $('#industrySubCategory').val();
                          self.recordType = IOT_CONFIG.sfdc.recordType.COMPANY_REP;
                          self.availableAssociations = ko.observableArray([]);
                          self.selectedAssociation = ko.observable();
                          self.referrerAssociation = ko.observable('');
                          self.userSelectedAssociation =  '';
                          self.showAssociationSelection = ko.observable(false);
                          self.associationsLoaded = ko.observable(false);
                          self.userSubmittedAssociation = ko.observable('');
                          //self.$referrerAssociation = $('#referrer-association');
                          //self.$referrerAssociationName = $('#referrer-association-name');
                          self.$referrerAssociation = $('#referrer-association');
                          self.$referrerAssociationName = $('#referrer-association-name');
                          self.$referrer_lead_source = $('#referrer-association_lead_source');
                          self.$referrer_campaign = $('#referrer-association_campaign');

                          //self.guidantId = ko.observable();
                          //.usernameConfirm = ko.observable('');
                          self.endPoint = 'Lead';
                          self.redirectUrl = '/association-registration-thank/';

                          self.validate = ko.pureComputed(function () {
                              return self.validateEmail(self.username()) &&
                                  self.fname() !== '' &&
                                  self.lname() !== '' &&
                                  self.companyName() !== '' &&
                                  self.title() !== '' &&
                                  self.industry() !== '' &&
                                  self.industrySubCategory() !== '' &&
                                  self.companySize() !== '' &&
                                  self.address1() !== '' &&
                                  self.city() !== '' &&
                                  self.st() !== '' &&
                                  self.validatePostalCode(self.postalCode()) &&
                                  self.country() !== '' &&
                                  self.validateTel(self.tel()) &&
                                  self.validateUrlOpt(self.website());
                          });

                          self.getRegistrationFlowData = function () {
                              var data = {
                                  lead: {},
                                  // rep: {},
                                  isSalesRepCreation: false
                              };
                              data.lead.email = self.username();
                              // Lead fields
                              data.lead.title = self.title();
                              data.lead.lastname = self.lname();
                              data.lead.firstname = self.fname();
                              data.lead.phone = self.tel();
                              data.lead.companyName = self.companyName();
                              data.lead.industry = self.industry;
                              data.lead.industrySubCategory = self.industrySubCategory;
                              // data.vendorInterest = jQuery("#vendor_interest:checked").val() ? jQuery("#vendor_interest:checked").val() : '';
                              data.lead.vendorInterest = jQuery('.check-interest:checked').map(function() {return this.value;}).get().join(', ');
                              data.lead.companySize = self.companySize();
                              data.lead.website = self.website();
                              data.lead.street = self.streetAddress();
                              data.lead.city = self.city();
                              data.lead.state = self.st();
                              data.lead.postalCode = self.postalCode();
                              data.lead.country = self.country();
                              data.lead.accountType = "Member Company";
                              data.lead.verizonEligible = "";
                              data.lead.leadSource = self.leadSource;
                              data.lead.leadSourceDetail = self.leadSourceDetail;
                              data.lead.emailDuplicationCheck = self.username() + ' - Member';
                              // data.contractedMarketingPartnerId = self.guidantId();
                              data.lead.recordTypeId = self.recordType;
                              if (self.computedAssociation() !== '') {
                                  self.userSelectedAssociation = self.computedAssociation();

                                  // if lead is referred from association landing page override lead source and lead source detail
                                  // data.leadSource = 'Contracted Marketing Partner';
                                  if (self.$referrer_campaign.val() !== '') {
                                      data.lead.campaign = self.$referrer_campaign.val();
                                  }
                              }
                              else {
                                  self.userSelectedAssociation = self.selectedAssociation() ? self.selectedAssociation().id : '';
                              }

                              data.userSubmittedAssociation = self.userSubmittedAssociation();

                              return data;
                          };

                          //override registration for company rep because we create a Lead w/out an Auth0 account
                          self.register = function () {
                              SageGlobals.showLoader();
                              if (self.preSubmit()) {
                                  //test if email address already exists in Lead or member Contact

                                  //append registration flow specific data
                                  self.data = self.getRegistrationFlowData();
                                  callSalesforceApi("/services/apexrest/CreateLeadAndRep", "POST", self.data)
                                      .then(function (result) {
                                          if (result.success === true || result.success === 'true') {

                                              //if association exists, create member association object and tie to lead
                                              var memberAssociation = {
                                                  association: self.userSelectedAssociation,
                                                  lead: result.leadid,
                                                  isMember: true,
                                                  primaryAssociation: true
                                              };

                                            callSalesforceApi('/services/apexrest/MemberAssociation', 'POST', memberAssociation)
                                            .then(function (result) {

                                                  // Parse the response manually
                                                   var parsedResult = JSON.parse(result);
                                                    if (parsedResult.success === true) {
                                                          self.redirect();
                                                     }
                                                     else {
                                                       throw new Error("Member association creation failed: " + JSON.stringify(result));
                                                     }
                                                })
                                                .catch(function (response) {
                                                  //if there is an error adding the association log it, but let the process continue
                                                  SageGlobals.log({
                                                      errorSeverity: 'WARNING',
                                                      error: response,
                                                      payload: memberAssociation,
                                                      description: 'Exception thrown during ' + self.endPoint + ' - ' + self.memberAssocEndPoint + '.Create'
                                                  });
                                                   jQuery("#loader").hide();
                                                  self.setMessage('error', self.errorClass, SageGlobals.GENERIC_ERROR_MSG);
                                                   jQuery('html, body').animate({
                                                            scrollTop: jQuery("#association-registration").offset().top-200
                                                }, 1000);
                                                   setTimeout(function(){
                                                              jQuery('.login-portal .form__msg ul').empty();
                                                          }, 10000);
                                              });
                                          }
                                          else {
                                              if (result.statusCode === '200') {

                                                  result.status.errors.forEach(function (item) {
                                                      var emailExists = self.checkEmailExists(item.message),
                                                          errorMsg = item.message;

                                                      if (emailExists !== false) {
                                                          errorMsg = emailExists.errorMsg;
                                                      }
                                                      jQuery("#loader").hide();
                                                      var custom_msg= 'This email address is already in use. Please <a data-gat="click" data-gatcategory="Registration" data-gatlabel="Error Message" data-gataction="Toggle Login" href="/?login=true">login</a> or use another email address.If you have any questions on your registration, please contact us at <a href="mailto:customerservice@mynpp.com">customerservice@mynpp.com</a> or <a href="tel:800.810.3909">800.810.3909</a>.';
                                                     self.setMessage('error', self.errorClass, custom_msg);
                                                     jQuery('html, body').animate({
                                                                 scrollTop: jQuery("#association-registration").offset().top-200
                                                     }, 1000);
                                                     setTimeout(function(){
                                                         jQuery('.login-portal .form__msg ul').empty();
                                                     }, 10000);

                                                      //self.setMessage('error', self.errorClass, errorMsg);
                                                  });

                                                  SageGlobals.log({
                                                      errorSeverity: 'NOTICE',
                                                      error: result.status.errors,
                                                      payload: result.payload,
                                                      description: 'Failure in ' + self.endPoint + '.Create'
                                                  });
                                              }
                                              else {
                                                  SageGlobals.log({
                                                      errorSeverity: 'WARNING',
                                                      error: result.status.errors || result.status,
                                                      payload: result.payload,
                                                      description: 'Error in ' + self.endPoint + '.Create'
                                                  });
                                                  jQuery("#loader").hide();
                                                  self.setMessage('error', self.errorClass, 'Something went wrong during registration. Please try again later.');
                                                   jQuery('html, body').animate({
                                                            scrollTop: jQuery("#association-registration").offset().top-200
                                                }, 1000);
                                                   setTimeout(function(){
                                                            jQuery('.login-portal .form__msg ul').empty();
                                                        }, 10000);
                                              }
                                          }
                                      })
                                      .catch(function (response) {
                                          var errorMessage = '';
                                          jQuery("#loader").hide();
                                          if (response.responseText) {
                                              try {
                                                  var errorObj = JSON.parse(response.responseText);
                                                  errorMessage = errorObj.error;

                                                  // Check for specific duplicate email error
                                                  if (errorMessage && errorMessage.includes('Duplicate Contact')) {
                                                      var custom_msg = 'This email address is already in use. Please <a data-gat="click" data-gatcategory="Registration" data-gatlabel="Error Message" data-gataction="Toggle Login" href="/?login=true">login</a> or use another email address. If you have any questions on your registration, please contact us at <a href="mailto:customerservice@mynpp.com">customerservice@mynpp.com</a> or <a href="tel:800.810.3909">800.810.3909</a>.';
                                                      self.setMessage('error', self.errorClass, custom_msg);
                                                  } else {
                                                      self.setMessage('error', self.errorClass, 'Something went wrong during registration. Please try again later.');
                                                  }
                                              } catch (e) {
                                                  errorMessage = 'Failed to parse error response.';
                                                  self.setMessage('error', self.errorClass, errorMessage);
                                              }
                                          } else {
                                              self.setMessage('error', self.errorClass, 'No response from the server.');
                                          }
                                          //exception thrown during create request
                                          SageGlobals.log({
                                              errorSeverity: 'WARNING',
                                              error: response,
                                              payload: self.data,
                                              description: 'Exception thrown during ' + self.endPoint + '.Create'
                                          });

                                          jQuery('html, body').animate({
                                              scrollTop: jQuery("#association-registration").offset().top - 200
                                          }, 1000);
                                          setTimeout(function () {
                                              jQuery('.login-portal .form__msg ul').empty();
                                          }, 10000);
                                      });
                              }
                          };

                          self.redirect = function () {
                              window.location.href = self.redirectUrl;

                         };
                      };
                //custom binding that wraps the value binding and does initialization
                      ko.bindingHandlers.valueWithInitialize = {
                          init: function (element, valueAccessor, allBindingsAccessor) {
                              var value = valueAccessor();
                              if (ko.isObservable(value)) {
                                  value(element.value);
                              }
                              ko.bindingHandlers.value.init(element, valueAccessor, allBindingsAccessor);
                          },
                          update: function (element, valueAccessor) {
                              ko.bindingHandlers.value.update(element, valueAccessor);
                          }
                      };

                      //ko.applyBindings(businessModel, document.getElementById('affiliate-registration'));
                       ko.applyBindings(new BusinessViewModel(), document.getElementById('association-registration'));

                  }
    },
//Single RM Landin page
'single_rm_landing_page': {
       init: function () {
                   jQuery('.banner__body nav.banner__nav').addClass('assoc_logo');
                   jQuery('.second_text p a').removeAttr('href onClick');
                   jQuery('.second_text p a').addClass('show_login').attr({href:'javascript'+String.fromCharCode(58)+'void(0);',onclick: 'javascript'+String.fromCharCode(58)+'show_login_popup();'});
                    jQuery('.mobile_copyright').addClass('col-xs-12').removeClass('col-xs-6');
                   jQuery('.mobile_copyright').children('.copyright').addClass('assoc_copy').css({"text-align": "center"});
                   jQuery('.mobile_copyright').children('.assoc_copy').removeClass('copyright');
                   if ($('#show_navigation').hasClass('off')) {
                      SageGlobals.hideMenu();
                      }
                 var queryParams = SageGlobals.getQueryParameters();
                 var formAssemblySubmitted = queryParams.hasOwnProperty('tfa_next');
                 var response = queryParams.tfa_next ? queryParams.tfa_next : '';
                    console.log(response);
                    if (formAssemblySubmitted && response==='/responses/last_success?jsid' ) {
                      jQuery('#myModal').modal('show');
                       jQuery('.success_msg').remove();
                      jQuery('.show_form').show();
                      jQuery('#offer_redemption_thanks').css('display','block');
                      window.history.pushState('page2', 'Title', window.location.pathname);
                  } else if (formAssemblySubmitted && response!=='/responses/last_success?jsid' ) {
                  jQuery('.success_msg').show();
                  jQuery('.show_form').hide();
                  }
          }
    },

//Single Tradeshow page
'single_trade_show': {
       init: function () {
                   jQuery('.banner__body nav.banner__nav').addClass('assoc_logo');
                   jQuery('.second_text p a').removeAttr('href onClick');
                   jQuery('.second_text p a').addClass('show_login').attr({href:'javascript'+String.fromCharCode(58)+'void(0);',onclick: 'javascript'+String.fromCharCode(58)+'show_login_popup();'});
                   //jQuery('.second_text p a').addClass('show_login').attr({href:"javascript:void(0);",onclick: "javascript:show_login_popup();"});
                   jQuery('.mobile_copyright').addClass('col-xs-12').removeClass('col-xs-6');
                   jQuery('.mobile_copyright').children('.copyright').addClass('assoc_copy').css({"text-align": "center"});
                   jQuery('.mobile_copyright').children('.assoc_copy').removeClass('copyright');
                   if ($('#show_navigation').hasClass('off')) {
                     SageGlobals.hideMenu();
                      }
                 var queryParams = SageGlobals.getQueryParameters();
                 var formAssemblySubmitted = queryParams.hasOwnProperty('tfa_next');
                var response = queryParams.tfa_next ? queryParams.tfa_next : '';
                    console.log(response);
                    if (formAssemblySubmitted && response==='/responses/last_success?jsid' ) {
                      jQuery('#myModal').modal('show');
                       jQuery('.success_msg').remove();
                      jQuery('.show_form').show();
                      jQuery('#offer_redemption_thanks').css('display','block');
                      window.history.pushState('page2', 'Title', window.location.pathname);
                  } else if (formAssemblySubmitted && response!=='/responses/last_success?jsid' ) {
                  jQuery('.success_msg').show();
                  jQuery('.show_form').hide();
                  }
           // spam leads validation
           jQuery(".custom-validation input[title='Email']").closest('.field-container-D').addClass('val-email-wrapper');
           jQuery(".custom-validation input[title='Email']").blur(function(){
               SageGlobals.validateEmailField();
           });


                  }
    },

        //Landing Page
        'single_landing_page': {
            init: function () {
                //show login popup on custom template
                jQuery('.landing_page-template-single-landing_page-custom-template .second_text p a').addClass('show_login').attr({href:'javascript'+String.fromCharCode(58)+'void(0);',onclick: 'javascript'+String.fromCharCode(58)+'show_login_popup();'});

               if(jQuery('#has_script').length !== 0){ jQuery("#main p").first().appendTo('head').contents().unwrap(); }
                jQuery( ".actions" ).after( jQuery( "#notForm" ) );
                var FormViewModel = function () {
                    var self = this;
                    self.formType = ko.observable('me');

          self.toggleNotMe = function() {
            self.formType('notMe');
          };
        };

        if(document.getElementById('form')) {
          ko.applyBindings(new FormViewModel(), document.getElementById('form'));

          //hide all labels for readonly fields. So labels can be visible when editing via FormAssembly, but not to the end user
          $('#form').find('.readonly').each(function() {
            $(this).parents('.oneField').addClass('is-readonly');
          });
        }
        if($('#show_navigation').hasClass('off')){
         jQuery('.hide_nav').hide();
         jQuery('.remove_href').removeAttr('href');
         jQuery('.copyright').css("padding-top", "12px");
        }
                var queryParams = SageGlobals.getQueryParameters();
                 var formAssemblySubmitted = queryParams.hasOwnProperty('tfa_next');

                if (formAssemblySubmitted) {
                   if(jQuery('.indirct_partner').length > 0 || jQuery("body").hasClass("landing_page-template-single-landing_page-custom-template")){
                      jQuery('#myModal').modal('show');
                      jQuery('.success_msg').hide();
                      jQuery('.show_form').show();
                      jQuery('#offer_redemption_thanks').css('display','block');
                      window.history.pushState('page2', 'Title', window.location.pathname);
                     } else {

                     jQuery('.show_form').hide();
                     }
                  }
                // spam leads validation
                jQuery(".custom-validation input[title='Email']").closest('.field-container-D').addClass('val-email-wrapper');
                jQuery(".custom-validation input[title='Email']").blur(function(){
                    SageGlobals.validateEmailField();
                });

            }
        },
       'single_coupon_landing_page': {
            init: function () {
                jQuery('.banner__container').hide();
                jQuery('#cookie-law-info-bar').hide();
                jQuery('.footer').hide();
            }
        },
       //Association thank you page
       'page_id_38458': { // for production
       //'page_id_31567': { // for staging
                   init: function () {
                       jQuery('.banner__body nav.banner__nav').addClass('assoc_logo');
                       SageGlobals.hideMenu();
                       setTimeout(function(){
                            jQuery('.asso_spec').hide();
                            jQuery('.association_menu').show();
                       }, 1500);
                   }
         },
    'page_id_4757': {
      init: function () {
        var details_cookie=JSON.parse(SageGlobals.getCookieValue('details'));
                jQuery('#join-firstname').val(details_cookie.fname);
                jQuery('#join-lastname').val(details_cookie.lname);
                jQuery('#join-email').val(details_cookie.email);
                jQuery('#join-phone').val(details_cookie.phone);
                jQuery('#join-country').val(details_cookie.country);
                jQuery('#join-postalcode').val(details_cookie.postalcode);
        setTimeout(function () {
          document.cookie = 'details=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
        }, 1 * 60 * 1000);
      }
    },
        'page_id_1206': {
            init: function () {
                var details_cookie=JSON.parse(SageGlobals.getCookieValue('emp_details'));
                jQuery('#join-firstname').val(details_cookie.fname);
                jQuery('#join-lastname').val(details_cookie.lname);
                jQuery('#join-email').val(details_cookie.email);
                jQuery('#join-phone').val(details_cookie.phone);
                setTimeout(function () {
                    document.cookie = 'emp_details=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
                }, 1 * 60 * 1000);

      }
    },
         //Become an affiliate
         'page_id_37877': { // for production
                            init: function () {
                              var self = this;
                               var queryParams = SageGlobals.getQueryParameters();
                               var formAssemblySubmitted = queryParams.hasOwnProperty('tfa_next');
                               var response = queryParams.tfa_next ? queryParams.tfa_next : '';
                               console.log(response);
                               if (formAssemblySubmitted && response==='/responses/last_success?jsid' ) {
                                     jQuery('#myModal').modal('show');
                                     jQuery('.success_msg').remove();
                                     jQuery('.show_form').show();
                                     jQuery('#offer_redemption_thanks').css('display','block');
                                     window.history.pushState('page2', 'Title', window.location.pathname);
                                }
                                else if (formAssemblySubmitted && response!=='/responses/last_success?jsid' ) {
                                 jQuery('.success_msg').show();
                                 jQuery('.show_form').hide();
                                }
                                jQuery(document).ready(function () {
                                      jQuery("#partnership").trigger('click').parents('.naics-row').addClass('activated');
                                        setTimeout(function () {
                                   jQuery(".portal-accordion").click(function () {
                                       if( jQuery(this).hasClass('is-active')){
                                         jQuery(this).parents('.naics-row').addClass('activated');
                                       } else {
                                       jQuery(this).parents('.naics-row').removeClass('activated');
                                       }
                                   });
                                 }, 3000);
                               });
                            }
                  },
         //NPP Brand List Start
            'page_id_31590': {
                init: function () {
                 var values = "brandList=Yes";
                        jQuery.ajax({
                            url: IOT_CONFIG.PORTAL_HOST + "/app/themes/sage/lib/leadSearch.php",
                            type: "POST",
                            dataType: 'text',
                            cache: false,
                            data: values, // serializes the form's elements.
                             beforeSend: function () {

                            },
                            success: function (html) {
                               jQuery('#result').after(html);
                                jQuery('.export_offer_data').css('width','300px');
                                jQuery('#exportButton').show();
                               jQuery.noConflict();
                               jQuery('.brand_list').DataTable( {
                                              responsive: true,
                                              autoWidth: false,
                                              oLanguage: {
                                                 "sSearch": "",
                                                 "oPaginate": {
                                                    "sNext": '&raquo;',
                                                    "sPrevious": '&laquo;'
                                                 },
                                               },
                                                fixedColumns: true,
                                                //autoWidth: false,
                                                   columns : [
                                                       { width : '15%' },
                                                       { width : '15%' },
                                                       { width : '15%' },
                                                       { width : '15%' }
                                                   ] ,
                                         } );
                        jQuery('.dataTables_filter').after( "<div class='clearfix'></div>" );
                        jQuery('.dataTables_filter label').addClass('result_filter');
                        jQuery('.result_filter input').attr('placeholder','Search');
                        jQuery('.dataTables_info').addClass('margin-bottom-20');
                     }
                  });
                      setTimeout(function () {
                           jQuery("#loader").hide();
                      }, 5000);
                 }
             },
         //NPP Brand List End
    //Registration
    'page_id_846': {
      init: function () {
          var pathArray = window.location.pathname.split('/');
          var regTypeFromUrl = '';

          // Check if URL contains registration type
          if (pathArray.includes('registration')) {
              var regTypes = ['business', 'employee', 'consumer'];
              var urlType = pathArray[pathArray.indexOf('registration') + 1];
              if (regTypes.includes(urlType)) {
                  regTypeFromUrl = urlType;
              }
          }
        //explicitly set each card height to it's natural value so Safari will respect the child 100% CSS value
        SageGlobals.equalHeight($('.tab-option__body'));
        SageGlobals.equalHeight($('.tab-option__description'));
       // jQuery(".nicescroll-cursors").hide();

        //test if we need to show a registration flow by default
        var queryParams = SageGlobals.getQueryParameters();
        var registrationFlow = queryParams.hasOwnProperty('flow') && ['employee', 'business', 'consumer'].indexOf(queryParams.flow) !== -1 ? queryParams.flow : '',
          passcode = queryParams.passcode || '';
        // Registration Page
        var ViewModel = function () {
          var self = this;

          self.modalActive = ko.observable(false);
          if(registrationFlow!==''){  jQuery('#main_join_now_box').hide(); }
          self.registrationType = ko.observable(registrationFlow);
         };

        var ConsumerViewModel = function () {
          var self = this;
          SageGlobals.registrationViewModel.call(self);
          SageGlobals.contactViewModel.call(self);

          //additional data
          self.contactType = 'Consumer';
          self.recordType = IOT_CONFIG.sfdc.recordType.CONSUMER;
          self.accountId = IOT_CONFIG.sfdc.recordType.CONSUMER_ACCOUNT_ID;
          self.endPoint = 'contact';

          self.getRegistrationFlowData = function(data) {
            data.contactType = self.contactType;
            data.recordTypeId = self.recordType;
            data.leadSource = self.leadSource;
            data.emailDuplicationCheck=self.username()+' - Member';
            data.accountId = self.accountId;
            if(self.computedAssociation() !== '') {
              //if lead is referred from association landing page override lead source and lead source detail
                if(self.$referrer_campaign.val()!==''){
                        data.campaign = self.$referrer_campaign.val();
               } else {
                       data.leadSource = self.$referrer_lead_source.val(); //added filed in admin
                       data.leadSourceDetail = self.computedAssociationName();
               }
            }
            return Object.assign(data, self.createUserData());
          };

          self.validate = ko.pureComputed(function() {
            return self._validate();
          });
        };

        var EmployeeViewModel = function (passcode) {
          var self = this;
          SageGlobals.registrationViewModel.call(self);
          SageGlobals.contactViewModel.call(self);

          //additional data
          self.recordType = IOT_CONFIG.sfdc.recordType.EMPLOYEE;
          self.contactType = 'Company Employee';
          self.endPoint = 'contact';

          self.getRegistrationFlowData = function(data) {
            //additional contact fields
            data.contactType = self.contactType;
            data.recordTypeId = self.recordType;
            data.leadSource = self.leadSource;
            data.emailDuplicationCheck=self.username()+' - Member';
            data.passCode = self.formatPasscode(self.passCode());

            if(self.computedAssociation() !== '') {
              //if lead is referred from association landing page override lead source and lead source detail
                 if(self.$referrer_campaign.val()!==''){
                    data.campaign = self.$referrer_campaign.val();
                 } else {
                    data.leadSource = self.$referrer_lead_source.val(); //added filed in admin
                    data.leadSourceDetail = self.computedAssociationName();
                 }
            }

            return Object.assign(data, self.createUserData());
          };

          self.passCodeDisabled = false;//ko.observable(self.validatePasscode(passcode)); no longer needed to disable passcode field when we get passcode in URL, based on the new design we will indicate validation (red / green)
          setTimeout(function (event) {
                         jQuery('#passcode').trigger('keyup');
           }, 500);

          self.passCode = ko.observable(self.formatPasscode(passcode));

          self.validate = ko.pureComputed(function () {
            return self._validate() &&
              self.validatePasscode(self.passCode());
          });

        };

        var BusinessViewModel = function () {
          var self = this;
          SageGlobals.registrationViewModel.call(self);
          SageGlobals.contactViewModel.call(self);
          SageGlobals.accountViewModel.call(self);
          SageGlobals.stateCountryViewModel.call(self);
            var gclid_cookie_val=SageGlobals.getCookieValue('gclid_cookie');
            var gclid=queryParams.gclid || gclid_cookie_val ||'';

            var utm_campaign_cookie_val=SageGlobals.getCookieValue('utm_campaign_cookie');
            var utm_campaign=queryParams.utm_campaign || utm_campaign_cookie_val ||'';

            var utm_medium_cookie_val=SageGlobals.getCookieValue('utm_medium_cookie');
            var utm_medium=queryParams.utm_medium || utm_medium_cookie_val ||'';

            var utm_source_cookie_val=SageGlobals.getCookieValue('utm_source_cookie');
            var utm_source=queryParams.utm_source || utm_source_cookie_val ||'';

        jQuery( "#company_state" ).select2();
        jQuery("#company_state").find('option:first').prop("disabled", false);
        jQuery('.select2-container--default').css('width','100%').addClass('nice-select');
        jQuery('.select2-selection--single').css({"border": "none", "height": "35px","margin-top": "8px","outline": "none!important"});
        jQuery('.select2-selection__arrow').css({"height": "100%"}).hide();

         self.fullNameValid = ko.pureComputed(function() {
            return self.isRequired(self.rep_Name());
          });
          self.emailValid = ko.pureComputed(function() {
            return self.isEmail(self.rep_email());
          });
          self.telValid = ko.pureComputed(function() {
            return self.isTel(self.rep_tel());
          });

          self.clearRep = function() {
            self.rep_Name('');
            self.rep_email('');
            self.rep_tel('');
          };
          self.saveRep = function () {
                self._rep_Name(self.rep_Name());
                self._rep_email(self.rep_email());
                self._rep_tel(self.rep_tel());
          };

        self.loadRep = function () {
            self.rep_Name(self._rep_Name());
            self.rep_email(self._rep_email());
            self.rep_tel(self._rep_tel());
        };

          self.validate = ko.pureComputed(function () {
            return self.validateEmail(self.username()) &&
              //self.validateConfirm([self.username(), self.usernameConfirm()]) &&
              //self.validateConfirm(self.username()) &&
              self.fname() !== '' &&
              self.lname() !== '' &&
              self.companyName() !== '' &&
              self.title() !== '' &&
              self.industry() !== '' &&
              self.companySize() !== '' &&
              self.memberLeadSource() !== '' &&
              self.address1() !== '' &&
              self.city() !== '' &&
              self.st() !== '' &&
              self.validatePostalCode(self.postalCode()) &&
              self.country() !== '' &&
              self.validateTel(self.tel()) &&
              self.validateUrlOpt(self.website());
          });
         self.industry.subscribe(function() {
            self.industrySubCategory('');
         });
            jQuery('#taxID').keydown(function (e) {
                         var key = e.charCode || e.keyCode || 0;
                         var $text = jQuery(this);
                         if (key !== 8 && key !== 9) {
                             if ($text.val().length === 2) {
                                 $text.val($text.val() + '-');
                             }
                         }
                     return (key === 8 || key === 9 || key === 46 || (key >= 48 && key <= 57) || (key >= 96 && key <= 105));
             });
            jQuery('#show_rep_form').change(function(){
               if(jQuery(this).is(":checked")){
                jQuery('#interets_rep_section').show();
                } else { jQuery('#interets_rep_section').hide(); }
            });
            //dynamic industry/sub industry start
                    SageGlobals.getIndustryData(IOT_CONFIG.HOST,'private');
             //dynamic industry/sub industry end
          self.Association = function(association) {
            this.id = association.id;
            this.name = association.name;
          };
            ko.extenders.updateInterestRep = function(target, viewModel) {
                 target.subscribe(function(noRepChecked) {
                    if(noRepChecked) {
                      viewModel.saveRep();
                      viewModel.clearRep();
                      jQuery(".registration-block .required-try").removeAttr('required');
                      jQuery("#step_4  .btn-inactive-ra").prop("disabled", false);
                     }
                    else {
                      viewModel.loadRep();
                      jQuery(".registration-block .required-try").addAttr('required');
                       if((jQuery(".registration-block  input[name=rep_Name]").val() !== '' ||
                        jQuery(".registration-block  input[name=rep_email]").val() !== '' ||
                        jQuery(".registration-block  input[name=rep_tel]").val() !== '') )
                        {
                            jQuery("#step_4  .btn-inactive-ra").prop("disabled", false);
                        }
                       else
                       { jQuery("#step_4 .btn-inactive-ra").prop("disabled", true);
                       }
                    }
                  });
              return target;
            };
            //self.showInterest = ko.observable('');
            self._rep_Name = ko.observable();
            self._rep_email = ko.observable();
            self._rep_tel = ko.observable();
            self.noRep = ko.observable(false).extend({updateInterestRep: self});
            self.noRepSelected = ko.pureComputed(function () {
                return self.noRep() ? 'readonly' : null;
            });
          self.recordType = IOT_CONFIG.sfdc.recordType.COMPANY_REP;
          self.availableAssociations = ko.observableArray([]);
          self.selectedAssociation = ko.observable();
          self.referrerAssociation = ko.observable('');
          self.userSubmittedAssociation = ko.observable('');
          self.userSelectedAssociation = '';
          self.showAssociationSelection = ko.observable(false);
          self.associationsLoaded = ko.observable(false);
          self.$referrerAssociation = $('#referrer-association');
          self.$referrerAssociationName = $('#referrer-association-name');
          self.$referrer_lead_source = $('#referrer-association_lead_source');
          self.$referrer_campaign = $('#referrer-association_campaign');

          self.selectedAssociationDisplay = ko.pureComputed(function() {
            return self.selectedAssociation() ? self.selectedAssociation().name : '--Select Association--';
          });

          self.endPoint = 'Lead';
          self.leadIdParam = '';
          self.verizonEligibleIndustry = ko.pureComputed(function() {
            var verizonNonEligibleIndustries = ['Retail', 'Manufacturing', 'Technology'];
            return verizonNonEligibleIndustries.indexOf(self.industry()) === -1;
          });

          self.redirectUrl = ko.pureComputed(function() {
                        // if country is CA in step 2  than redirect to company rep thank you page start here
            if (self.country() === 'CA') {
                return '/company-rep-registration-thank?exit=false';
            } else {
              var date = new Date(),
                  expires = 'expires=';
              var minutes = 30;
              date.setTime(date.getTime() + (minutes * 60 * 1000));
              expires += date.toGMTString();
              document.cookie =  'details=' + JSON.stringify({fname: self.fname(), lname: self.lname(),email: self.username(), phone: self.tel(), country: self.country(), postalcode: self.postalCode()}) + '; ' + expires + '; path=/';
                return self.verizonEligibleIndustry() ? '/company-rep-registration-thank?exit=true' : '/company-rep-registration-thank?exit=false';
                //return self.verizonEligibleIndustry() ? '/registration-additional-information/' : '/company-rep-registration-thank?exit=false';
            }
          });

            self.getRegistrationFlowData = function () {
                var data = {
                    lead: {},
                    isSalesRepCreation: false
                };
                //lead fields
                data.lead.title = self.title();
                var valuesArray = jQuery.map(jQuery(':checkbox[name=interest\\[\\]]:checked'), function (n, i) {
                    return n.value;
                }).join(',');
                data.lead.vendorInterest = valuesArray;
                data.lead.taxID = self.taxID();
                //data.companyName = self.companyName();
                data.lead.companyName = jQuery("#company_name_dnb_plus").val();
                //data.industry = self.industry();
                data.lead.industry = jQuery("#busi_industry option:selected").val();
                data.lead.industrySubCategory = jQuery("#busi_subindustry option:selected").val();
                //data.companySize = self.companySize();
                data.lead.nonprofit = jQuery("#nonprofit option:selected").val() === "1";
                data.lead.companySize = jQuery("#busi_comp_size option:selected").val();
                data.lead.empCount = self.empCount();
                data.lead.memberLeadSource = self.memberLeadSource();
                data.lead.memberLeadSourceDetail = jQuery("#other_detail").val();
                data.lead.website = self.website();
                //data.streetAddress = self.streetAddress();
                data.lead.street = jQuery("#company_address1").val() + ', ' + jQuery("#step_2 input[name=address2]").val();
                //data.city = self.city();
                data.lead.city = jQuery("#company_city").val();
                data.lead.state = jQuery("#company_state").val();
                //data.st = jQuery("#company_state option:selected").val();
                //data.st =jQuery("#company_state").next(".nice-select").find('ul li.selected').attr('data-value');
                //data.postalCode = self.postalCode();
                data.lead.postalCode = jQuery("#postal_code_dnb_plus").val();
                data.lead.country = self.country();
                data.lead.accountType = "Member Company";
                data.lead.gclid = gclid;
                data.lead.utm_source = utm_source;
                data.lead.utm_medium = utm_medium;
                data.lead.utm_campaign = utm_campaign;
                data.lead.verizonEligible = "";
                data.lead.leadSource = self.leadSource;
                data.lead.recordTypeId = self.recordType;
                data.lead.emailDuplicationCheck = self.username() + ' - Member';
                data.lead.lastname = self.lname();
                data.lead.email = self.username();
                data.lead.firstname = self.fname();
                data.lead.phone = self.tel();
                data.lead.ext = self.telExt();

                //association data
                //if computedAssociation from association landing page exists use that value
                //otherwise use association picklist value if one was selected
//                        console.log("Checking computedAssociation(): ", self.computedAssociation());
//                      if (self.computedAssociation() !== '') {
//                                              self.userSelectedAssociation = self.computedAssociation();
//
//                                                        //if lead is referred from association landing page override lead source and lead source detail
//                                                        //data.leadSource = 'Contracted Marketing Partner';
//                                              if (self.$referrer_campaign.val() !== '') {
//                                                            data.campaign = self.$referrer_campaign.val();
//                                              } else {
//                                                            data.leadSource = self.$referrer_lead_source.val(); //added filed in admin
//                                                            data.leadSourceDetail = self.computedAssociationName();
//                                              }
//                                                    }
//                                                    else {
//                                              self.userSelectedAssociation = self.selectedAssociation() ? self.selectedAssociation().id : '';
//                                          }
//
//                                                    data.userSubmittedAssociation = self.userSubmittedAssociation();

                if (self.rep_Name() && self.rep_email() && self.rep_tel() && self.verizonEligibleIndustry() && jQuery(" input[id=show_rep_form]").prop("checked") === true) {
                    data.isSalesRepCreation = true;
                    data.interestsreps = {
                        vendor: 'Verizon',
                        repName: self.rep_Name(),
                        repEmail: self.rep_email(),
                        repPhone: self.formatTel(self.rep_tel()),
                        categories: ""
                    };
                }

                return data;
            };


            //override registration for company rep because we create a Lead w/out an Auth0 account
          self.register = function() {
            SageGlobals.showLoader();
            if(self.preSubmit()) {
              //test if email address already exists in Lead or member Contact

              //append registration flow specific data
                self.data = self.getRegistrationFlowData();
                emailid = btoa(self.data.email);
                callSalesforceApi("/services/apexrest/CreateLeadAndRep", "POST", self.data)
                    .then(function (result) {
                        if (result.success === true) {
                            self.redirect();
                            //append Lead.id to redirect url
                        if(self.verizonEligibleIndustry()) {
                        //self.leadIdParam = '?id=' + result.id;
                        //self.email = '&email_id=' + emailid;
                        	}
      //           self.getRegistrationFlowDataInterest = function (data) {
      //             //only pass rep info if user didn't select no rep checkbox
      //                 data.vendor = 'Verizon';
      //                 data.repName = self.rep_Name();
      //                 data.repEmail = self.rep_email();
      //                 data.repPhone = self.formatTel(self.rep_tel());
      //                 data.lead = result.id;
      //               return data;
      //         };
      //
      //             //if association exists, create member association object and tie to lead
      //             // if(self.userSelectedAssociation) {
      //             //   var memberAssociation = {
      //             //     association: self.userSelectedAssociation,
      //             //     lead: result.id,
      //             //     isMember: true,
      //             //     primaryAssociation: true
      //             //   };
      //             //
      //             //   var memberAssocProm = _Boomi.sendRequest('POST', self.memberAssocEndPoint, memberAssociation);
      //             //   memberAssocProm.then(function (result) {
      //             //     if(result.success === 'true') {
      //             //       self.redirect();
      //             //     }
      //             //     else {
      //             //       SageGlobals.log({
      //             //         errorSeverity: 'WARNING',
      //             //         error: result.status.errors,
      //             //         payload: result.payload,
      //             //         description: 'Failure in ' + self.endPoint + ' - ' + self.memberAssocEndPoint + '.Create'
      //             //       });
      //             //     }
      //             //
      //             //   }).catch(function(response) {
      //             //     //if there is an error adding the association log it, but let the process continue
      //             //     SageGlobals.log({
      //             //       errorSeverity: 'WARNING',
      //             //       error: response,
      //             //       payload: memberAssociation,
      //             //       description: 'Exception thrown during ' + self.endPoint + ' - ' + self.memberAssocEndPoint + '.Create'
      //             //     });
      //             //   });
      //             // }
      //           //vendor Interest
      //               if(self.rep_Name() && self.rep_email() && self.rep_tel() && self.verizonEligibleIndustry() && jQuery(" input[id=show_rep_form]").prop("checked")===true) {
      //                     self.data = self.getRegistrationFlowDataInterest({});
      //                     var memberAssocProm1 = _Boomi.sendRequest('POST', 'Interests_Reps__c', self.data);
      //
      //                    memberAssocProm1.then(function (result) {
      //                       if(result.success === 'true') {
      //                         self.redirect();
      //                       }
      //                       else {
      //                         SageGlobals.log({
      //                           errorSeverity: 'WARNING',
      //                           error: result.status.errors,
      //                           payload: result.payload,
      //                           description: 'Failure in Interests_Reps__c Create'
      //                         });
      //                       }
      //
      //                     });
      //                     //    .catch(function(response) {
      //                     //   //if there is an error adding the Interesrs rep log it, but let the process continue
      //                     //   SageGlobals.log({
      //                     //     errorSeverity: 'WARNING',
      //                     //     error: response,
      //                     //     payload: memberAssociation,
      //                     //     description: 'Exception thrown during Interests_Reps__c  - ' + self.memberAssocEndPoint + '.Create'
      //                     //   });
      //                     // });
      //                   }
      // //vendor interest
                  else {
                    self.redirect();
                  }
                   document.cookie = 'gclid_cookie=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
                    document.cookie = 'utm_campaign_cookie=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
                    document.cookie = 'utm_medium_cookie=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
                    document.cookie = 'utm_source_cookie=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
                }
                else {
                            jQuery("#loader").hide();
                            if (result.error && result.error.includes('Duplicate Contact')) {
                                var custom_msg = 'This email address is already in use. Please <a data-gat="click" data-gatcategory="Registration" data-gatlabel="Error Message" data-gataction="Toggle Login" href="/?login=true">login</a> or use another email address. If you have any questions on your registration, please contact us at <a href="mailto:customerservice@mynpp.com">customerservice@mynpp.com</a> or <a href="tel:800.810.3909">800.810.3909</a>.';
                                self.setMessage('error', self.errorClass, custom_msg);
                            }else {
                                SageGlobals.log({
                                    errorSeverity: 'WARNING',
                                    error: result.status.errors || result.status,
                                    payload: result.payload,
                                    description: 'Error in ' + self.endPoint + '.Create'
                                });
                                self.setMessage('error', self.errorClass, 'Something went wrong during registration. Please try again later.');
                            }
                        }
                        })
                        .catch(function (response) {
                            // Extract relevant information from the response object
                            var errorMessage = '';
                            jQuery("#loader").hide();
                            if (response.responseText) {
                                try {
                                    var errorObj = JSON.parse(response.responseText);
                                    errorMessage = errorObj.error;

                                    // Check for specific duplicate email error
                                    if (errorMessage && errorMessage.includes('Duplicate Contact')) {
                                        var custom_msg = 'This email address is already in use. Please <a data-gat="click" data-gatcategory="Registration" data-gatlabel="Error Message" data-gataction="Toggle Login" href="/?login=true">login</a> or use another email address. If you have any questions on your registration, please contact us at <a href="mailto:customerservice@mynpp.com">customerservice@mynpp.com</a> or <a href="tel:800.810.3909">800.810.3909</a>.';
                                        self.setMessage('error', self.errorClass, custom_msg);
                                    } else {
                                        self.setMessage('error', self.errorClass, 'Something went wrong during registration. Please try again later.');
                                    }
                                } catch (e) {
                                    errorMessage = 'Failed to parse error response.';
                                    self.setMessage('error', self.errorClass, errorMessage);
                                }
                            } else {
                                self.setMessage('error', self.errorClass, 'No response from the server.');
                            }
                  //exception thrown during create request
                  SageGlobals.log({
                    errorSeverity: 'WARNING',
                    error: response,
                    payload: self.data,
                    description: 'Exception thrown during ' + self.endPoint + '.Create'
                  });
              });

          }
          };

          self.redirect = function() {
            //if nonce form exists - set action to redirect url and post it.
            // On landing page the nonce will be verified to prevent CSRF attacks on id
            if(self.$redirectForm.length) {
                //self.$redirectForm.attr({'action': self.redirectUrl() + self.leadIdParam + self.email +self.lead_industry});
                self.$redirectForm.attr({'action': self.redirectUrl() + self.leadIdParam });
				self.$redirectForm.submit();
            }
            else {
              window.location.href = self.redirectUrl() + self.leadIdParam;
            }
          };
        };

        ko.bindingHandlers.stopBinding = {
          init: function () {
            return {controlsDescendantBindings: true};
          }
        };
        ko.virtualElements.allowedBindings.stopBindings = true;

        ko.applyBindings(new ViewModel(), document.getElementById('registration'));
          if (regTypeFromUrl) {
              // Hide main options
              jQuery('#main_join_now_box').hide();

              // Show specific section
              var section = document.getElementById(regTypeFromUrl + '-section');
              if (section) {
                  section.style.display = 'block';
                  section.classList.remove('hidden');

                  // Update Knockout viewmodel
                  var viewModel = ko.dataFor(section);
                  if (viewModel && viewModel.registrationType) {
                      viewModel.registrationType(regTypeFromUrl);
                  }
              }
          }
        ko.applyBindings(new ConsumerViewModel(), document.getElementById('consumer-registration'));
        ko.applyBindings(new EmployeeViewModel(passcode), document.getElementById('employee-registration'));
        ko.applyBindings(new BusinessViewModel(), document.getElementById('business-registration'));
      }
    },

    //Partner Registration
    'page_id_848': {
      init: function () {
        // Partner Registration Page
        var PartnerViewModel = function () {
          var self = this;
          SageGlobals.registrationViewModel.call(self);
          SageGlobals.contactViewModel.call(self);
          SageGlobals.stateCountryViewModel.call(self);
          jQuery("#company_state").find('option:first').prop("disabled", false);
          //Company info
          self.companyName = ko.observable('');
          self.website = ko.observable('');
          self.primaryProduct = ko.observable();
          self.partnerExperience = ko.observable('');
          self.exclusiveOffer = ko.observable('Yes');
          self.annualSales = ko.observable();
          self.currentSales = ko.observable();
          self.annualSalesDisplay = ko.pureComputed(function () {
            return self.annualSales() !== '' ? self.annualSales() : '--Select Company Sales--';
          });
          self.currentSalesDisplay = ko.pureComputed(function () {
            return self.currentSales() !== '' ? self.currentSales() : '--Select Sales Model--';
          });

          //Address
          //state/country come from stateCountryViewModel
          self.address1 = ko.observable('');
          self.address2 = ko.observable('');
          self.city = ko.observable('');
          self.postalCode = ko.observable('');

          //additional values
          self.recordType = IOT_CONFIG.sfdc.recordType.PARTNER;

          self.address = ko.pureComputed(function() {
            return self.address1() + '\n' + self.address2();
          });

          //add year validation for company incorporation date
          self.validateMessage.year = 'Year needs to be 4 digits long e.g. 2016';
          self.validateYear = function(value) {
            var yearRe = /^[0-9]{4}$/;
            return value.match(yearRe);
          };


          self.validate = ko.pureComputed(function () {
            //TODO: add newly required fields to validation
            return self.username() !== '' &&
              self.fname() !== '' &&
              self.lname() !== '' &&
              self.title() !== '' &&
              self.companyName() !== '' &&
              self.website() !== '' &&
              self.primaryProduct() !== '' &&
              self.partnerExperience() !== '' &&
              self.annualSales() !== '' &&
                self.currentSales() !== '' &&
              self.exclusiveOffer() !== '' &&
              self.address1() !== '' &&
              self.city() !== '' &&
              self.st() !== '' &&
              self.validatePostalCode(self.postalCode()) &&
              self.country() !== '' &&
              self.confirmTel() &&
              self.validateUrl(self.website());
          });

          self.endPoint = 'Lead';
          self.redirectUrl = '/partner-rep-registration-thank-you';
            self.getRegistrationFlowData = function() {

                var data = {
                    lead: {},
                    // interestsreps: {},
                    isSalesRepCreation: false
                };
                //additional contact fields
                data.lead.title = self.title();
                data.lead.firstname = self.fname();
                data.lead.lastname  = self.lname();
                //account fields
                data.lead.companyName = self.companyName();
                data.lead.website = self.website();
                data.lead.primaryProduct = self.primaryProduct();
                data.lead.partnerExperience = self.partnerExperience();
                data.lead.exclusiveOffer = self.exclusiveOffer();
                data.lead.annualSales = self.annualSales();
                data.lead.currentSales = self.currentSales();
                //address fields
                data.lead.street = self.address();
                data.lead.city = self.city();
                data.lead.state = self.st();
                data.lead.postalCode = self.postalCode();
                data.lead.country = self.country();
                data.lead.leadSource = self.leadSource;
                data.lead.recordTypeId = self.recordType;
                data.lead.email = self.username();
                data.lead.phone = self.tel();
                data.lead.ext = self.telExt();
                data.lead.emailDuplicationCheck = self.username() + ' - Partner';


                return data;
            };
            jQuery("#company_state").change(function() {
               if( jQuery("#company_state").val!==""){
                 jQuery("#company_state").find('option:first').prop("disabled", true);
               }
            });
            jQuery("#partner-reg .required-try").on('blur keyup change', function (e) {
                if (jQuery('.required-try').val()==='' ||
                      jQuery("#annual_sale").val()=== '' ||jQuery("#annual_sale").next(".nice-select").children(".current").text() === '--Select Company Sales--' || jQuery("#current_sale").val() === '' ||
                    jQuery("#current_sale").next(".nice-select").children(".current").text() === '--Select Sales Model--')  {
                    jQuery("#annual_sale").next('.nice-select').addClass('is-invalid');
                   jQuery("#current_sale").next('.nice-select').addClass('is-invalid');
                    } else {
                         jQuery("#annual_sale").next('.nice-select').removeClass('is-invalid').addClass('user-success');
                     jQuery("#current_sale").next('.nice-select').removeClass('is-invalid').addClass('user-success');
                    }
                });
          //override registration flow because there is no user account component and we need to show a success msg
          self.register = function(form) {
            var $this = $(form),
              data;

            if(self.preSubmit()) {
                 SageGlobals.showLoader();
                data = {
                  // recordTypeId: self.recordTypeId,
                  leadSource: self.LeadSource,
                  firstname: self.fname(),
                  lastname: self.lname(),
                  email: self.username(),
                  phone: self.tel(),
                  ext: self.telExt()
                };
                //append registration flow specific data
                data = self.getRegistrationFlowData(data);

                //create account in Salesforce
                callSalesforceApi('/services/apexrest/CreateLeadAndRep', 'POST', data)
                    .then(function (result) {
                        self.setWorking(false);

                        if (result.success === true) {
                            jQuery("#loader").hide();
                            window.location.href = self.redirectUrl;
                        }
                  else {
                    result.status.errors.forEach(function (item) {
                      var emailExists = self.checkEmailExists(item.message),
                        errorMsg = item.message;

                      if(emailExists !== false) {
                        errorMsg = emailExists.errorMsg;
                      }
                       jQuery("#loader").hide();
                      self.setMessage('error', self.errorClass, errorMsg);
                    });

                    SageGlobals.log({
                      errorSeverity: 'WARNING',
                      error: result.status.errors || result.status,
                      payload: result.payload,
                      description: 'Status code: ' + result.statusCode + ' - Error updating ' + self.endPoint + ' profile'
                    });
                  }
                }) .catch(function (error) {
                    jQuery("#loader").hide();

                    var errorMsg = SageGlobals.GENERIC_ERROR_MSG;

                    if (
                        (error.message && error.message.toLowerCase().includes("already")) ||
                        (error.responseJSON && error.responseJSON.error && error.responseJSON.error.toLowerCase().includes("already"))
                    ) {
                        var custom_msg = 'This email address is already in use. Please <a data-gat="click" data-gatcategory="Registration" data-gatlabel="Error Message" data-gataction="Toggle Login" href="/?login=true">login</a> or use another email address.If you have any questions on your registration, please contact us at <a href="mailto:customerservice@mynpp.com">customerservice@mynpp.com</a> or <a href="tel:800.810.3909">800.810.3909</a>.';
                        self.setMessage('error', self.errorClass, custom_msg);
                    }
                    else{
                        self.setMessage('error', self.errorClass, SageGlobals.GENERIC_ERROR_MSG);
                    }
                  SageGlobals.log({
                    errorSeverity: 'WARNING',
                    error: error,
                    payload: data,
                    description: 'Exception creating ' + self.endPoint
                  });
                    // self.setMessage('error', self.errorClass, SageGlobals.GENERIC_ERROR_MSG);
                });
            }
          };
        };

        ko.applyBindings(new PartnerViewModel(), document.getElementById('partner-registration'));
      }
    },

    //Migrate
    'page_id_1057': {
      init: function() {
        var queryParams = SageGlobals.getQueryParameters();

        var username = queryParams.email ? queryParams.email : '',
          token = queryParams.token ? queryParams.token : '',
          redirect = queryParams.redirection ? SageGlobals.formatRedirectUrl(decodeURIComponent(queryParams.redirection)) : '/';

        var nonce = $('#impersonate-complete-account').val();

        var MigrationViewModel = function (username, token, redirect, nonce) {
          var self = this;
          SageGlobals.accountRegistrationViewModel.call(self, username, token, redirect, nonce, 'Migrate');

          self.username(username);
          self.contactEndPoint = 'contact/token';

          self.validUser = ko.pureComputed(function() {
            return self._recordTypeName() === 'Member';
          });

          //set email verified for Auth0 to true because they already have had to have access to their email to get the url to trigger this flow
          self.verifyEmail = true;
          //don't force Account load in accountRegistrationViewModel because Consumers can use this flow
          self.accountLoad = false;

          //set emailVerified to true to SFDC as well to match with Auth0
          self.getRegistrationFlowData = function() {
            return {
              emailVerified: true,
              emailVerifiedDate: SageGlobals.getTimeStamp()
            };
          };

          self.getPromises = function() {
            // var updateUserPromise = _Boomi.sendRequest('PUT', 'contact/' + self._contactId(), self.userData);
            var updateUserPromise = callSalesforceApi("/services/apexrest/contact/" + self._contactId(), "PUT", {contact:self.userData});
            updateUserPromise.then(function (result) {
              if (result.success !== 'true') {
                var errorMsg = result.statusCode === '500' ? result.status : result.status.errors;

                SageGlobals.log({
                  errorSeverity: 'WARNING',
                  error: errorMsg,
                  payload: self.userData,
                  description: 'Error updating Contact during Migrate Account'
                });

                self.setMessage('error', self.errorClass, SageGlobals.GENERIC_ERROR_MSG);
              }
            }).catch(function (response) {
              SageGlobals.log({
                errorSeverity: 'WARNING',
                error: response,
                payload: self.data,
                description: 'Exception updating Contact during Migrate Account'
              });

              self.setMessage('error', self.errorClass, SageGlobals.GENERIC_ERROR_MSG);
            });

            return [updateUserPromise];
          };

          self.setUserData = function() {
            self.username(self._username());
            self.fname(self._fname());
            self.lname(self._lname());
          };

          self.validate = ko.pureComputed(function() {
            return self.validUser() &&
                 //self.validateConfirm(self.password()) &&
                //self.validateConfirm([self.password(), self.passwordConfirm()]) &&
                self.valid();
          });
        };
        ko.applyBindings(new MigrationViewModel(username, token, '/email-verified?redirection=' + redirect, nonce), document.getElementById('migration-registration'));
      }

    },

    //Account
    'page_id_1156': {
      init: function () {
        var $emailUpdate = $('#email-update'),
          $userProfile = $('#user-profile');
        var nonce = $('#nonce').val();

        var hash = window.location.hash;
        if(hash.length){
            setTimeout(function () { jQuery('html, body').animate({
                scrollTop: jQuery(hash).offset().top-100
            }, 3000); }, 3000);
        }
        var contactId = null,
          accountId = null,
          contact = null,
          account = null,
          contactLoadError = false,
          accountLoadError = false;

        var initKo = function(contact, account, contactLoadError, accountLoadError) {
          var ContactUpdateViewModel = function(contact, account, contactLoadError, accountLoadError) {
            var self = this;
            SageGlobals.formViewModel.call(self);
            SageGlobals.contactViewModel.call(self);
            SageGlobals.accountViewModel.call(self);

             if(contact.type === 'Affiliate'){
                 jQuery("#company_website").on('blur', function (e) {
                        if (jQuery("#company_website").val() !== '' &&  self.validateUrlOpt(jQuery("#company_website").val())) {
                                 jQuery("#affiliate_form .btn-inactive-ra").prop("disabled", false);
                                  jQuery("#company_website").removeClass('user-error');
                             }  else {
                                 jQuery("#affiliate_form .btn-inactive-ra").prop("disabled", true);
                                 jQuery("#company_website").addClass('user-error');
                                 return false;
                             }
                 });
               }

                      jQuery("#contact_form .required-try").on('blur', function(e) {
                             var count=jQuery('#contact_form .is-invalid').length;

                             if((jQuery("#contact_form input[name=fname]").val() !== '' || jQuery("#refer-a-friend input[name=lname]").val() !== '' ||
                                 jQuery("#contact_form input[name=tel]").val() !== '') && (count === 0)){
                                jQuery("#contact_form #contact_submit").prop("disabled", false);
                             }  else if(jQuery("#contact_form input[name=tel-mobile]").hasClass('user-error') || jQuery("#contact_form input[name=tel]").hasClass('user-error') || jQuery("#contact_form input[name=tel-ext]").hasClass('user-error')){
                                   jQuery("#contact_form #contact_submit").prop("disabled", true);
                                  return false;
                             }  else {
                                jQuery("#contact_form #contact_submit").prop("disabled", true);
                               return false;
                             }
                      });

            self.contactLoaded = ko.observable(!!contact);
            self.contactLoadFailure = ko.observable(contactLoadError);
            self.accountLoaded = ko.observable(!!account);

             if(contact.type==='Affiliate'){
                 jQuery("#mebership_size").find('option').removeAttr('selected');
                 var membership_text=account.membershipSize;
                 jQuery("#mebership_size option[value='" + membership_text + "']").attr("selected","selected");
                 jQuery('#mebership_size').niceSelect('update');
                 jQuery('.select_membershipSize .list').mCustomScrollbar();
             }
            self.accountLoadFailure = ko.observable(accountLoadError);

            //second set of messages for Account
            self.messagesAccount = ko.observableArray();
            self.messageStateAccount = ko.observable('');

            self.passCode = ko.observable('');
            self.edit = ko.observable('Edit');
            self.cancel = ko.observable('Cancel');
            self.passCodeConfirmed = ko.observable(false);
            self.passCodeModalActive = ko.observable(false);

            //account info for passcode logic
            self.tempAccount = {};
            self.accountId = ko.observable('');
            self.accountName = ko.observable('');
            self.accountBillingStreet = ko.observable('');
            self.accountBillingCity = ko.observable('');
            self.accountBillingState = ko.observable('');
            self.accountBillingPostalCode = ko.observable('');
            self.accountBillingCountry = ko.observable('');

            self.contact = {};
            self.contactType = ko.observable('');

            //internal properties
            self._contactId = self.contactLoaded() ? contact.id : '';
            self._accountId = self.accountLoaded() ? account.id : '';

            self.saveShadow = function() {
              //save copy of contact for edit mode
              self.fnameShadow = self.fname();
              self.lnameShadow = self.lname();
              self.titleShadow = self.title();
              self.departmentShadow = self.department();
              self.telShadow = self.tel();
              self.telExtShadow = self.telExt();
              self.telMobileShadow = self.telMobile();
              self.emailOptOutShadow = self.emailOptOut();
              self.dataSharingAllowedShadow = self.dataSharingAllowed();
              self.passCodeShadow = self.passCode();
                if(contact.type === 'Affiliate'){
                  self.websiteShadow = self.website();
                }
            };

            if(self.contactLoaded()) {
              SageGlobals.saveContact(self, contact);
              self.contactType(contact.type);
              // //save copy of contact for edit mode
              self.saveShadow();
            }

            if(self.accountLoaded()) {
              SageGlobals.saveAccount(self, account);
                 if(contact.type === 'Affiliate'){
                       self.saveShadow();
                  }
            }


            self.accountAddress = ko.pureComputed(function() {
              return self.accountBillingStreet() + '<br>' +
                self.accountBillingCity() + ', ' + self.accountBillingState() + ' ' + self.accountBillingPostalCode() + '<br>' +
                self.accountBillingCountry();
            });

            self.cancelPasscode = function() {
              self.setWorking(false);
              self.formWorking(false);
              self.passCodeModalActive(false);
            };

            self.confirmPasscode = function() {
              self.passCodeConfirmed(true);
              self.passCodeModalActive(false);
              self.contact.accountid = self.accountId();
              //update Account info
              SageGlobals.saveAccount(self, self.tempAccount);
              self._updateContact(self.contact);
            };

            self.endPoint = 'contact';
            self.state('summary');
            self.passCodeProcessed = false;

            //shadow profile properties
                        //It blanks fields when cliek on cancel button in edit mode
//                        self.fnameShadow = '';
//                        self.lnameShadow = '';
//                        self.telShadow = '';
//                        self.telExtShadow = '';
//                        self.telMobileShadow = '';
//                        self.emailOptOutShadow = '';
//                        self.passCodeShadow = '';

            self.cancelEdit = function() {
              //reset all data to original
              self.fname(self.fnameShadow);
              self.lname(self.lnameShadow);
              self.title(self.titleShadow);
              self.department(self.departmentShadow);
              self.tel(self.telShadow);
              self.telExt(self.telExtShadow);
              self.telMobile(self.telMobileShadow);
              self.emailOptOut(self.emailOptOutShadow);
              self.dataSharingAllowed(self.dataSharingAllowedShadow);
                if(contact.type === 'Affiliate'){
                   jQuery("#company_website").removeClass('user-error');
                  self.website(self.websiteShadow);
                }

              //reset passcode to empty because it may be invalid and be block legit update requests until user manually clears it
              // self.passCode('');
              self.setState('summary');
            };



            self.validate = ko.pureComputed(function() {
              var validSubmission = self.validateEmail(self.username()) &&
                self.fname() !== '' &&
                self.lname() !== '' &&
                self.validatePasscodeOpt(self.passCode()) &&
                self.validateTelOpt(self.telMobile());


              //should only trigger catch if nonce fails
              try {
                //make tel optional for consumer and employee to match registration flow
                if (self.contactType() === 'Consumer' || self.contactType() === 'Company Employee'||
                  self.contactType() === 'Affiliate' || self.contactType() === 'Sales rep') {
                  return validSubmission && (self.validateTelOpt(self.tel()));
                }
                else {
                  return validSubmission && self.validateTel(self.tel());
                }
              }
              catch(e) {
                return false;
              }

            });



            self._updateContact = function(contact) {
               SageGlobals.showLoader();
              // var prom = _Boomi.sendRequest('PUT', self.endPoint + '/' + self._contactId, contact);
              var prom = callSalesforceApi("/services/apexrest/contact/" + self._contactId, "PUT", {contact:contact});
              prom.then(function(result) {
                if(result.success === true || result.success === 'true') {
                  self.saveShadow();
                  self.setWorking(false);
                  self.setState('summary');
                  jQuery("#loader").hide();
                }
                else {
                  SageGlobals.log({
                    errorSeverity: 'WARNING',
                    error: result.status.errors || result.status,
                    payload: result.payload,
                    description: 'Status code: ' + result.statusCode + ' - Error updating ' + self.endPoint + ' profile'
                  });
                  jQuery("#loader").hide();
                  self.setMessage('error', self.errorClass, SageGlobals.GENERIC_ERROR_MSG);
                }

              }).catch(function(response) {
                SageGlobals.log({
                  errorSeverity: 'WARNING',
                  error: response,
                  payload: contact,
                  description: 'Exception updating ' + self.endPoint + ' profile'
                });
                jQuery("#loader").hide();
                self.setMessage('error', self.errorClass, SageGlobals.GENERIC_ERROR_MSG);
              });
            };

            self.updateContact = function() {
              if(self.preSubmit()) {

                if(self.validate()) {
                  var contact = {
                    firstname: self.fname(),
                    lastname: self.lname(),
                    title: self.title(),
                    department: self.department(),
                    tel: self.formatTel(self.tel()),
                    ext: self.telExt(),
                    phoneMobile: self.formatTel(self.telMobile())
                  };

                  //do optIn logic
                  //if user opts out, set custom Salesforce fields to allow Salesforce workflow to trigger
                  //if user opts in we can set the standard Salesforce opt-in field. Need to reverse the value for opt-in because user
                  //is editing their opt-out value
                   if(jQuery('#optIn').is(":checked")){
                      contact.optIn = true;
                      contact.hasOptedOutOfEmail = false;
                    } else if(jQuery('#optIn').is(":not(:checked)")){
                       contact.hasOptedOutOfEmail = true;
                       jQuery('#optIn').prop( "checked", false );
                    }
                    if(jQuery('#dataSharingAllowed').is(":checked")){
                       contact.dataSharingAllowed = true;
                    }
                    else if(jQuery('#dataSharingAllowed').is(":not(:checked)")){
                       contact.dataSharingAllowed = false;
                    }
//                                    if (self.emailOptOut() === 'true') {
//                                        contact.hasOptedOutOfEmail = self.emailOptOut();
//                                    }
//                                    else {
//                                        contact.optIn = 'true';
//                                    }

                  // var passcode = self.validatePasscodeOpt(self.passCode());

                  //save reference to contact obj to use during passcode logic
                  self.contact = contact;
                  self._updateContact(self.contact);

                  //if user has entered passcode, validate if passcode exists
                  //if exists, verify w/ user that this is the company they want to join
                  //if user verifies, add accountid to contact profile and update user

                  //removing Passcode logic for the moment
                  // if(self.validatePasscodeOpt(self.passCode()) && self.passCodeShadow !== self.formatPasscode(self.passCode())) {
                  //   var accountProm = _Boomi.sendRequest('GET', 'AccountPasscode', self.formatPasscode(self.passCode()));
                  //   accountProm.then(function(result) {
                  //     if(result.success === 'true') {
                  //       self.tempAccount = result;
                  //
                  //       //save account info
                  //       self.accountId(result.accountId || '');
                  //       self.accountName(result.companyName || '');
                  //       self.accountBillingStreet(result.streetAddress || '');
                  //       self.accountBillingCity(result.city || '');
                  //       self.accountBillingState(result.st || '');
                  //       self.accountBillingPostalCode(result.postalCode || '');
                  //       self.accountBillingCountry(result.country || '');
                  //
                  //       //show confirmation modal to user
                  //       self.passCodeModalActive(true);
                  //     }
                  //     else {
                  //       self.setMessage('error', self.errorClass, SageGlobals.GENERIC_ERROR_MSG);
                  //     }
                  //   })
                  //     .catch(function(response) {
                  //       self.setMessage('error', self.errorClass, SageGlobals.GENERIC_ERROR_MSG);
                  //     });
                  // }
                  // else {
                  //   //no passcode, update contact
                  //   self._updateContact(self.contact);
                  // }

                }
                else {
                  self.setMessage('error', self.errorClass, 'Please fill out all required fields');
                }
              }
            };
            //update account for affiliate

            self._updateAccount = function(account) {
                 SageGlobals.showLoader();
                     self.setState('edit_account');
                      setTimeout(function () {
                                       if (jQuery("#company_website").val() === ''){ jQuery("#affiliate_form .btn-inactive-ra").prop("disabled", true);}
                                       else { jQuery("#affiliate_form .btn-inactive-ra").prop("disabled", false); }
                                     }, 2000);
                callSalesforceApi('/services/apexrest/Account/' + self._accountId, 'PUT', account)
                    .then(function (result) {
                        if(result.success === true) {
                          self.saveShadow();
                          self.setWorking(false);
                          self.setState('summary');
                          jQuery("#loader").hide();
                        }
                        else {
                          SageGlobals.log({
                            errorSeverity: 'WARNING',
                            error: result.status.errors || result.status,
                            payload: result.payload,
                            description: 'Status code: ' + result.statusCode + ' - Error updating Account  profile'
                          });
                           jQuery("#loader").hide();
                          self.setMessage('error', self.errorClass, SageGlobals.GENERIC_ERROR_MSG);
                        }

                      }).catch(function(response) {
                        SageGlobals.log({
                          errorSeverity: 'WARNING',
                          error: response,
                          payload: contact,
                          description: 'Exception updating Account profile'
                        });
                         jQuery("#loader").hide();
                        self.setMessage('error', self.errorClass, SageGlobals.GENERIC_ERROR_MSG);
                      });
                    };

                    self.updateAccount = function() {

					   if(jQuery("#company_website").val()===''){
	                         jQuery("#company_website").addClass('user-error');
	                         jQuery("#affiliate_sec").show();
                         }
                          if(self.preSubmit()) {

                            if(self.validate()) {
                              var account = {
                                  account: {
                                      website: self.website(),
                                      membershipSize: self.membershipSize()
                                  }
                              };
                              //save reference to contact obj to use during passcode logic
                              self.account = account;
                              self._updateAccount(self.account);



                            }
                            else {
                              jQuery("#company_website").addClass('user-error');
                              jQuery("#affiliate_sec").show();
                              //self.setMessage('error', self.errorClass, 'Please fill out all required fields');
                            }
                          }
                        };
            //update account for affiliate end
          };

          var OfferRedemptionViewModel = function(contact) {
            var self = this;
            self.offerRedemptions = ko.observableArray();


            //load offer redemptions on bind
            (function(contactId) {
                callSalesforceApi('/services/apexrest/OfferRedemption/' + contactId, 'GET')
                    .then(function (result) {
                        if (result.success === true) {
                            // Map the response to match the template's expected structure
                            var mappedRedemptions = result.OfferRedemptions.map(function(item) {
                                var date = new Date(item.CreatedDate);
                                var formattedDate = date.toLocaleDateString('en-US', {
                                        month: '2-digit',
                                        day: '2-digit',
                                        year: '2-digit'
                                    }) + ' ' +
                                    date.toLocaleTimeString('en-US', {
                                        hour: 'numeric',
                                        minute: '2-digit',
                                        hour12: true
                                    });
                                return {
                                    partner: item.PartnerName,
                                    offer: item.OfferName,
                                    createdDate: formattedDate,
                                    url: item.offer.WordPressOfferURL // Access the nested offer object's URL
                                };
                            });
                  self.offerRedemptions(mappedRedemptions);
                }else {
                            SageGlobals.log({
                                errorSeverity: 'WARNING',
                                error: result.status ? result.status.errors : 'Unknown error',
                                payload: result,
                                description: 'Failure loading Offer Redemptions on Account page.'
                            });
                        }
              }).catch(function(response) {
                //if there is an error adding the association log it, but let the process continue
                SageGlobals.log({
                  errorSeverity: 'WARNING',
                  error: response,
                  payload: contactId,
                  description: 'Exception thrown during loading Offer Redemptions on Account page.'
                });
              });



            }(contact.id));
          };


          ko.applyBindings(new ContactUpdateViewModel(contact, account, contactLoadError, accountLoadError), document.getElementById('user-profile'));

          ko.applyBindings(new SageGlobals.resetPasswordViewModal(contact.email, contact.connection), document.getElementById('email-update'));

          ko.applyBindings(new OfferRedemptionViewModel(contact), document.getElementById('offer-redemptions'));
        };

        var preVMErrorMsg = function() {
          $userProfile.html('<strong>' + SageGlobals.GENERIC_ERROR_MSG + '</strong>');
        };

        if($userProfile.length) {
          //get contact data
          if(!nonce) {
            SageGlobals.log({
              errorSeverity: 'WARNING',
              error: 'No nonce passed',
              payload: nonce,
              description: 'Missing nonce on Account page'
            });

            preVMErrorMsg();
          }
          else {
            var userPromise = _Lib.sendRequest('GET', 'user.php', 'k=' + nonce);
            userPromise.then(function(result) {
              if(result.success === 'true') {
                contactId = result.contactId;
                accountId = result.accountId;

                // var promises = [_Boomi.sendRequest('GET', 'contact', contactId)];
                var promises = [callSalesforceApi('services/apexrest/contact/'+ contactId, 'GET', {'apiName':'getContact'})];
                                    //var hostName = SageGlobals.getHostName(SiteUrl);
                                    //Added condition as sales rep account setting takes much time to load
                  if (window.location.origin === IOT_CONFIG.HOST || result.contactType==='Affiliate') {
                    if(result.accountId) {
                      // var accountProm = _Boomi.sendRequest('GET', 'Account', accountId);
                      var accountProm = callSalesforceApi('services/apexrest/Account/'+ accountId, 'GET', {'apiName':'getAccount'});
                      promises.push(accountProm);
                    }
                }
                Promise.all(promises).then(function(result) {
                  //[0] = contact
                  //[1] = account
                  if(result[0].success === 'true') {
                    contact = result[0];
                  }
                  else {
                    SageGlobals.log({
                      errorSeverity: 'WARNING',
                      error: result.status.errors || result.status,
                      payload: contactId,
                      description: 'Failure to find contact on profile'
                    });

                    contactLoadError = true;
                  }

                  //test if account promise was processed
                  if(result[1]) {
                    if(result[1].success === 'true') {
                      account = result[1];
                    }
                    else {
                      SageGlobals.log({
                        errorSeverity: 'WARNING',
                        error: result.status.errors || result.status,
                        payload: accountId,
                        description: 'Failure to find company on Account page'
                      });

                      accountLoadError = true;
                    }
                  }

                  //init VM once user information is loaded
                  initKo(contact, account, contactLoadError, accountLoadError);
                })
                  .catch(function(response) {
                    SageGlobals.log({
                      errorSeverity: 'WARNING',
                      error: response,
                      payload: {contact: contactId, account: accountId },
                      description: 'Exception when loading user profile on Account page'
                    });

                    preVMErrorMsg();
                  });
              }
              else {
                SageGlobals.log({
                  errorSeverity: 'WARNING',
                  error: result.message,
                  payload: nonce,
                  description: 'Error loading user information on Account page'
                });

                preVMErrorMsg();
              }
            })
              .catch(function(response) {
                SageGlobals.log({
                  errorSeverity: 'WARNING',
                  error: response,
                  payload: nonce,
                  description: 'Exception when loading contact on profile'
                });

                preVMErrorMsg();
              });
          }
        }
      }
    },

    //Verizon Rep Registration
    'page_id_2269': {
      init: function () {
        // Verizon Rep Registration Page
        var VerizonRepViewModel = function () {
          var self = this;
          SageGlobals.registrationViewModel.call(self);
          SageGlobals.contactViewModel.call(self);
          SageGlobals.stateCountryViewModel.call(self);
            jQuery( "#company_state" ).select2();
            jQuery("#company_state").find('option:first').prop("disabled", false);
            jQuery('.select2-container--default').css('width','100%').addClass('nice-select');
            jQuery('.select2-selection--single').css({"border": "none", "height": "35px","margin-top": "8px","outline": "none!important"});
            jQuery('.select2-selection__arrow').css({"height": "100%"}).hide();
          self.showComplete = ko.observable(false);

          //Verizon Rep info
          self.verizonRepChannel = ko.observable('');
          self.verizonMarketSegment = ko.observable('');

          //Rep Address
          //state/country come from stateCountryViewModel
          //set country to US to show list of states for rep to pick
          self.country('US');
          self.city = ko.observable('');
          self.postalCode = ko.observable('');

          self.verizonRepChannelDisplay = ko.pureComputed(function() {
            return self.verizonRepChannel() !== '' ? self.verizonRepChannel() : '--Select Rep Channel--';
          });

          self.verizonMarketSegmentDisplay = ko.pureComputed(function() {
            return self.verizonMarketSegment() !== '' ? self.verizonMarketSegment() : '--Select Market Segment--';
          });

          //additional values
          self.recordType = IOT_CONFIG.sfdc.recordType.VERIZON;
          self.companyName = 'Verizon Wireless';
          self.redirectUrl = '/register-verizon-rep-thank-you';
          self.validateMessage.verizonEmail = 'Please enter your Verizon email address @vzw.com';

            self.validateVerizonEmail = function (value) {
                var emailRe = /^[a-zA-Z0-9._%+-]+@(vzw\.com|verizonwireless\.com)$/i;
                return emailRe.test(value);
            };
            self.emailIsValid = ko.observable(true);

            self.username.subscribe(function(newValue) {
                self.emailIsValid(self.validateVerizonEmail(newValue));
            });

          self.validate = ko.pureComputed(function () {
              return self.emailIsValid() &&
              self.fname() !== '' &&
              self.lname() !== '' &&
              self.city() !== '' &&
              self.st() !== '' &&
                self.manageremail() !== '' &&
              self.validatePostalCode(self.postalCode()) &&
              self.title() !== '' &&
              self.verizonRepChannel() !== '' &&
              self.verizonMarketSegment() !== '' &&
              self.validateTel(self.tel());
          });

          self.endPoint = 'Lead';
          self.getRegistrationFlowData = function(data) {
            //additional contact fields
            // data.title = self.title();
            // data.verizonRepChannel = self.verizonRepChannel();
            // data.verizonMarketSegment = self.verizonMarketSegment();
            //
            // //address fields
            // data.city = self.city();
            // data.st = self.st();
            // data.postalCode = self.postalCode();
            // data.leadSource = self.leadSource;
            // data.recordTypeId = self.recordType;

            return data;
          };

          //override registration flow because there is no user account component and we need to show a success msg
          self.register = function() {
            var data;

              if (self.preSubmit()) {
                  if (!self.emailIsValid()) {
                      self.setMessage('error', self.errorClass, self.validateMessage.verizonEmail);
                      return;
                  }
                  data = {
                      lead:{
                          firstname: self.fname(),
                          lastname: self.lname(),
                          email: self.username(),
                          manageremail: self.manageremail(),
                          phone: self.tel(),
                          ext: self.telExt(),
                          title: self.title(),
                          verizonRepChannel: self.verizonRepChannel(),
                          verizonMarketSegment: self.verizonMarketSegment(),
                          city: self.city(),
                          state: self.st(),
                          postalCode: self.postalCode(),
                          companyName: self.companyName,
                          leadSource : self.leadSource,
                          recordTypeId : self.recordType,
                          emailDuplicationCheck : self.username() + ' - Portal'

                      },};
              if(jQuery('#spambot').val()==='') {
              //append registration flow specific data
              data = self.getRegistrationFlowData(data);

              //create account in Salesforce
               callSalesforceApi('/services/apexrest/CreateLeadAndRep', 'POST', data)
               .then(function (result) {
                 self.setWorking(false);
                 if (result.success === true) {
                     window.location.href = self.redirectUrl;
                     }
                else {
                  SageGlobals.log({
                    errorSeverity: 'WARNING',
                    error: result.status.errors || result.status,
                    payload: result.payload,
                    description: 'Status code: ' + result.statusCode + ' - Error updating ' + self.endPoint + ' profile'
                  });
                   var custom_msg= 'This email address is already in use. Please <a data-gat="click" data-gatcategory="Registration" data-gatlabel="Error Message" data-gataction="Toggle Login" href="/?login=true">login</a> or use another email address.If you have any questions on your registration, please contact us at <a href="mailto:customerservice@mynpp.com">customerservice@mynpp.com</a> or <a href="tel:800.810.3909">800.810.3909</a>.';
                   self.setMessage('error', self.errorClass, custom_msg);
                     // self.setMessage('error', self.errorClass, SageGlobals.GENERIC_ERROR_MSG);
                }
              }).catch(function (response) {
                   SageGlobals.log({
                       errorSeverity: 'WARNING',
                       error: response,
                       payload: data,
                       description: 'Exception creating ' + self.endPoint
                   });
                   self.setMessage('error', self.errorClass, 'This email address is already in use. Please <a data-gat="click" data-gatcategory="Registration" data-gatlabel="Error Message" data-gataction="Toggle Login" href="/?login=true">login</a> or use another email address.If you have any questions on your registration, please contact us at <a href="mailto:customerservice@mynpp.com">customerservice@mynpp.com</a> or <a href="tel:800.810.3909">800.810.3909</a>.');
               });
              } else {
                  self.setMessage('error', self.errorClass, SageGlobals.GENERIC_ERROR_MSG);
              }
              } else {
                  self.setMessage('error', self.errorClass, 'Please fill in all required fields correctly.');
              }
          };
        };

        ko.applyBindings(new VerizonRepViewModel(), document.getElementById('verizon-rep-registration'));
      }
    },

    //Express Registration
    'page_id_3832': {
      init: function() {
        var queryParams = SageGlobals.getQueryParameters();

        var username = queryParams.email ? queryParams.email : '',
          token = queryParams.token ? queryParams.token : '';

        var nonce = $('#impersonate-express-reg').val();
        var redirectUrl = '/express-registration-complete';

        var ExpressRegistrationViewModel = function(username, token, redirectUrl, nonce) {
          var self = this;
          SageGlobals.accountRegistrationViewModel.call(self, username, token, redirectUrl, nonce, 'Express Registration');

          //override verify flag to false because user enters their email address manually
          self.verifyEmail = false;

          self.getPromises = function() {
            //var updateUserPromise = _Boomi.sendRequest('PUT', 'contact/' + self._contactId(), self.userData, {'Set-Null': 'yes'});
          //  var updateUserPromise = _Boomi.sendRequest('PUT', 'contact/' + self._contactId(), self.userData);
          var updateUserPromise = callSalesforceApi("/services/apexrest/contact/" + self._contactId(), "PUT", {contact:self.userData});
            updateUserPromise.then(function (result) {
              if (result.success !== true) {
                var errorMsg = result.statusCode === '500' ? result.status : result.status.errors;

                SageGlobals.log({
                  errorSeverity: 'WARNING',
                  error: errorMsg,
                  payload: self.userData,
                  description: 'Error updating Contact during Express registration'
                });

                self.setMessage('error', self.errorClass, SageGlobals.GENERIC_ERROR_MSG);
              }
            }).catch(function (response) {
              SageGlobals.log({
                errorSeverity: 'WARNING',
                error: response,
                payload: self.data,
                description: 'Exception updating Contact during Express registration'
              });

              self.setMessage('error', self.errorClass, SageGlobals.GENERIC_ERROR_MSG);
            });

            return [updateUserPromise];
          };

          self.getRegistrationFlowData = function() {
            var extraData = {
              expressRegistration: true
            };

            var userData = Object.assign(extraData, self.createUserData());

            //remove joinDate property because we don't want to override the joinDate set when Lead is converted
            delete userData.joinDate;
            return userData;
          };
        };

        ko.applyBindings(new ExpressRegistrationViewModel(username, token, redirectUrl, nonce), document.getElementById('express-registration'));
      }
    },

    //Complete Account
    'page_id_3834': {
      init: function() {
        var queryParams = SageGlobals.getQueryParameters();

        var username = queryParams.email ? queryParams.email : '',
          token = queryParams.token ? queryParams.token : '',
          redirect = queryParams.redirection ? SageGlobals.formatRedirectUrl(decodeURIComponent(queryParams.redirection)) : false;
          if (redirect !== false && redirect.indexOf('?login') > -1) {
            redirect= redirect+'=true';
          }
        var nonce = $('#impersonate-complete-account').val();
        var redirectUrl = redirect === false ? '/complete-account-thank-you' : redirect;

        var ExpressRegistrationViewModel = function(username, token, redirectUrl, nonce) {
          var self = this;
          SageGlobals.accountRegistrationViewModel.call(self, username, token, redirectUrl, nonce, 'Complete Account');

          //set email verified for Auth0 to true because they already have had to have access to their email to get the url to trigger this flow
          self.verifyEmail = true;

          //set emailVerified to true to SFDC as well to match with Auth0
          self.getRegistrationFlowData = function() {
            return {
              emailVerified: true,
                            status:'Active',
              emailVerifiedDate: SageGlobals.getTimeStamp()
            };
          };

          self.getPromises = function() {
            // var updateUserPromise = _Boomi.sendRequest('PUT', 'contact/' + self._contactId(), self.userData);
            var updateUserPromise = callSalesforceApi("/services/apexrest/contact/" + self._contactId(), "PUT", {contact:self.userData});
            updateUserPromise.then(function (result) {
              if (result.success !== true) {
                var errorMsg = result.statusCode === '500' ? result.status : result.status.errors;

                SageGlobals.log({
                  errorSeverity: 'WARNING',
                  error: errorMsg,
                  payload: self.userData,
                  description: 'Error updating Contact during Complete Account'
                });

                self.setMessage('error', self.errorClass, SageGlobals.GENERIC_ERROR_MSG);
              }
            }).catch(function (response) {
              SageGlobals.log({
                errorSeverity: 'WARNING',
                error: response,
                payload: self.data,
                description: 'Exception updating Contact during Complete Account'
              });

              self.setMessage('error', self.errorClass, SageGlobals.GENERIC_ERROR_MSG);
            });

            return [updateUserPromise];
          };

          self.setUserData = function() {
            self.username(self._username());
            self.fname(self._fname());
            self.lname(self._lname());
          };

          self.validate = ko.pureComputed(function() {
            //return self.validateConfirm([self.password(), self.passwordConfirm()]) &&
               //return self.validateConfirm(self.password()) &&
             return self.valid();
          });
        };

        ko.applyBindings(new ExpressRegistrationViewModel(username, token, redirectUrl, nonce), document.getElementById('complete-account'));
      }

    },

    //Additional Information for Partner Rep Registration
    'page_id_4163': {
      init: function() {

        ko.extenders.updateInterestRep = function(target, viewModel) {
          target.subscribe(function(noRepChecked) {
            if(noRepChecked) {
              viewModel.saveRep();
              viewModel.clearRep();
              jQuery(".registration-block  .btn-inactive-ra").prop("disabled", false);
               jQuery(".registration-block  input[name=fullName]").removeClass('is-invalid user-error');
            }
            else {
              viewModel.loadRep();

                if (jQuery(".registration-block  input[name=fullName]").val() !== '')
               {
                    jQuery(".registration-block  input[name=fullName]").removeClass('is-invalid user-error');
                    jQuery(".registration-block  .btn-inactive-ra").prop("disabled", false);
               }
               else
               {
               jQuery(".registration-block  .btn-inactive-ra").prop("disabled", true);
            }
            }
          });
          return target;
        };

        //setup VM for the steps
        var InterestViewModelController = function(interests) {
          var self = this;
          self.interests = interests;
          self.baseStep = 3; //setting at 3 because the Company Rep registration technically is counting as steps 1 & 2
          self.currentStep = ko.observable(self.baseStep);
          self.totalSteps = ko.observable(self.baseStep + self.interests.length - 1);
          self.currentInterest = ko.observable(self.interests[0]);


          self.redirect = '/company-rep-registration-thank?exit=false';

          //send initial funnel event to GA
           if(IOT_CONFIG.HOST===SiteUrl) {
          ga('set', 'page', '_extra-registration/' + self.currentStep());
          ga('send', 'pageview');
            }
          self.nextInterest = function($data) {
            if(self.currentInterest().next !== null) {
              $data.setWorking(false);
              self.currentInterest(self.currentInterest().next);
              self.currentStep(self.currentStep() + 1);
              if(IOT_CONFIG.HOST===SiteUrl) {
              ga('set', 'page', '_extra-registration/' + self.currentStep());
              ga('send', 'pageview');
            }
            }
            else {
              location.href = self.redirect;
            }
          };
        };

        var InterestViewModel = function(options) {
          var self = this;
          SageGlobals.formViewModel.call(self);
          SageGlobals.contactViewModel.call(self);

          var queryParams = SageGlobals.getQueryParameters();
          self.leadId = queryParams.hasOwnProperty('id') ? queryParams.id : '';

          self.showInterest = ko.observable('');
          self.fullName = ko.observable('');
          self.email = ko.observable('');
          self.noRep = ko.observable(false).extend({updateInterestRep: self});
          self.noRepSelected = ko.pureComputed(function() {
            return self.noRep() ? 'readonly' : null;
          });

          self.continueSubmit = ko.observable('Continue');
          self.endPoint = 'Interests_Reps__c';
          self.next = null;


          //internal properties
          self._fullName = ko.observable();
          self._email = ko.observable();
          self._tel = ko.observable();

          //form copy and customizable properties
          self.vendor = options.vendor || '';
          self.formQuestion = ko.observable(options.formQuestion || '');
          self.noRepQuestion = ko.observable(options.noRepQuestion || '');
          self.fullNameLabel = ko.observable(options.fullNameLabel || '');
          self.fullNamePlaceHolder = ko.observable(options.fullNamePlaceHolder || '');
          self.emailLabel = ko.observable(options.emailLabel || '');
          self.emailPlaceHolder = ko.observable(options.emailPlaceHolder || '');
          self.telLabel = ko.observable(options.telLabel || '');
          self.telPlaceHolder = ko.observable(options.telPlaceHolder || '');

          self.interestPathChosen = ko.pureComputed(function() {
            return self.showInterest() !== '';
          });
            self.checkvalidation = function() {

                    jQuery(".registration-block .required-try").on('blur keyup', function(e) {
                     var count=jQuery(".registration-block .is-invalid").length;
                     var user_error_count=jQuery(".registration-block .user-error").length;
                      if(user_error_count !== 0){
                            jQuery(".registration-block .btn-inactive-ra").prop("disabled", true);
                      }
                      else
                      {
                         jQuery(".registration-block  .btn-inactive-ra").prop("disabled", false);
                      }


                      //if full name blank or not
                      if (jQuery(".registration-block  input[name=fullName]").val() !== '')
                      {
                           if(count ===0)
                             {
                                  jQuery(".registration-block  .btn-inactive-ra").prop("disabled", false);
                             }
                             else
                               {
                            jQuery(".registration-block .btn-inactive-ra").prop("disabled", true);
                               }
                           jQuery(".registration-block  input[name=fullName]").removeClass('is-invalid user-error');
                      }
                      else
                      {
                            if(jQuery(".registration-block  input[name=interest-norep]").prop("checked") === false)
                            {jQuery(".registration-block  input[name=fullName]").addClass('is-invalid user-error');}
                            else
                            { jQuery(".registration-block  input[name=fullName]").removeClass('is-invalid user-error');}
                      }

              });
             return true;
          };
          //validator fields
          self.fullNameValid = ko.pureComputed(function() {
            return self.isRequired(self.fullName());
          });
          self.emailValid = ko.pureComputed(function() {
            return self.isEmail(self.email());
          });
          self.telValid = ko.pureComputed(function() {
            return self.isTel(self.tel());
          });

          self.validate = function() {
            return self.leadId !== '' &&
              (self.fullName() !== '' &&
              self.validateEmailOpt(self.email()) &&
              self.validateTelOpt(self.tel())) ||
              self.noRep();
          };

          self.getRegistrationFlowData = function(data) {
            //only pass rep info if user didn't select no rep checkbox
            data.vendor = self.vendor;
            if(!self.noRep()) {
              data.repName = self.fullName();
              data.repEmail = self.email();
              data.repPhone = self.formatTel(self.tel());
            }
            data.lead = self.leadId;

            return data;
          };

          self.saveRep = function() {
            self._fullName(self.fullName());
            self._email(self.email());
            self._tel(self.tel());
          };

          self.loadRep = function() {
            self.fullName(self._fullName());
            self.email(self._email());
            self.tel(self._tel());
          };

          self.clearRep = function() {
            self.fullName('');
            self.email('');
            self.tel('');
          };

          self.resetFormState = function(value, element) {
            $(element).parents('.form').find('.' + self.inputClasses.dirty).removeClass(self.inputClasses.dirty);
            return true;
          };

          self.submitInterest = function($parent) {
            if(self.preSubmit()) {
                SageGlobals.showLoader();
              //append registration flow specific data
              self.data = self.getRegistrationFlowData({});
              var prom = _Boomi.sendRequest('POST', self.endPoint, self.data);
              prom.then(function (result) {
                if (result.success === 'true') {
                  $parent.nextInterest(self);
                }
                else {
                  if (result.statusCode === '200') {
                    // failed to create SFDC InterestReps object. But no exception thrown.
                    result.status.errors.forEach(function (item) {
                      self.setMessage('error', self.errorClass, item.message);
                    });

                    SageGlobals.log({
                      errorSeverity: 'NOTICE',
                      error: result.status.errors,
                      payload: result.payload,
                      description: 'Failure in ' + self.endPoint + '.Create'
                    });
                  }
                  else {
                    SageGlobals.log({
                      errorSeverity: 'WARNING',
                      error: result.status.errors || result.status,
                      payload: result.payload,
                      description: 'Error in ' + self.endPoint + '.Create'
                    });
                    self.setMessage('error', self.errorClass, 'Something went wrong during processing your request. Please contact us.');
                      jQuery("#loader").hide();
                  }
                }
              })
                .catch(function (response) {
                  //exception thrown during create request
                  SageGlobals.log({
                    errorSeverity: 'WARNING',
                    error: response,
                    payload: self.data,
                    description: 'Exception thrown during ' + self.endPoint + '.Create'
                  });
                  self.setMessage('error', self.errorClass, 'Something went wrong during processing your request. Please contact us.');
                    jQuery("#loader").hide();
                });
            }
          };
        };

        //TODO: pull interests from WP REST API via ajax call. Need custom obj in WP to control copy
        var interests = [],
          interestOptions = [
            {
              vendor: 'Verizon',
              formQuestion: 'Are you interested in getting a discount with Verizon?',
              noRepQuestion: 'I am not working with a Verizon Rep at this time. I would like NPP to help me establish a Verizon Rep.',
              fullNameLabel: 'Verizon Rep Name',
              fullNamePlaceHolder: 'Enter Verizon Rep\'s Name',
              emailLabel: 'Verizon Rep Email Address',
              emailPlaceHolder: 'username@vzw.com',
              telLabel: 'Verizon Rep Phone',
              telPlaceHolder: '555-555-5555'
            }
          ];

        interestOptions.forEach(function(element) {
          var interestOption = new InterestViewModel(element);
          if(interests.length) {
            interests[interests.length - 1].next = interestOption;
          }
          interests.push(interestOption);
        });

        if(document.getElementById('interest')) {
          ko.applyBindings(new InterestViewModelController(interests), document.getElementById('interest'));
        }

      }
    },

    //SF Communities "Refer A Friend"
    'page_id_5074': {
      init: function() {
        var queryParams = SageGlobals.getQueryParameters();
        jQuery(".referr_frnd #company_state").prop("selectedIndex", 0);
        jQuery('.referr_frnd #company_state > option').slice(-14).remove();
        jQuery('.referr_frnd #company_state').niceSelect();
        jQuery('.referr_frnd #company_state').next(".nice-select").children(".current").text('--Select State/Province--');
        jQuery(".referr_frnd #company_state").next(".nice-select").children(".list").mCustomScrollbar();
        var contactId = jQuery("#contact_id").val();
        jQuery("#refer-a-friend .required-try").on('keyup blur change', function (e) {
         var count=jQuery('#refer-a-friend .is-invalid').length;
           if (jQuery("#refer-a-friend #company_state").next(".nice-select").children(".current").text()!== '--Select State/Province--' &&
                        jQuery("#refer-a-friend input[name=fullname]").val() !== '' &&
                        jQuery("#refer-a-friend input[name=username]").val() !== '' &&  count === 0 ) {
                        jQuery("#refer-a-friend .btn-inactive-ra").prop("disabled", false);
                    } else if (jQuery("#refer-a-friend input[name=username]").hasClass('user-error') || jQuery("#refer-a-friend #company_state").next(".nice-select").children(".current").text()=== '--Select State/Province--' ) {
                        jQuery("#refer-a-friend .btn-inactive-ra").prop("disabled", true);
                        return false;
                    } else {
                        jQuery("#refer-a-friend .btn-inactive-ra").prop("disabled", true);
                        return false;
                    }
                });
               jQuery("#refer-a-friend input[name=username]").on('blur keyup', function (e) {
               /*to allow specific domain only start*/
               var str=jQuery("#domain_allow").val();
               var splitString = str.split(',');
               var email= jQuery("#refer-a-friend input[name=username]").val().split('@').pop();
               if(jQuery("#refer-a-friend input[name=username]").val() === "cras.nmcmillan@gmail.com" || jQuery("#refer-a-friend input[name=username]").val() === "mhillman090@gmail.com" && jQuery("#refer-a-friend #company_state").next(".nice-select").children(".current").text()!== '--Select State/Province--' && jQuery("#refer-a-friend input[name=fullname]").val() !== ''){
                    jQuery("#refer-a-friend input[name='username").removeClass('is-invalid user-error');
                    jQuery("#refer-a-friend .btn-inactive-ra").prop("disabled", false);
                    return true;
               }else if(splitString.indexOf(email) > -1 )
               {
                    jQuery("#refer-a-friend input[name='username").removeClass('is-invalid user-error');
                   if(jQuery("#refer-a-friend #company_state").next(".nice-select").children(".current").text()!== '--Select State/Province--') {
                       jQuery("#refer-a-friend .btn-inactive-ra").prop("disabled", false);
                       return true;
                   }else {
                       jQuery("#refer-a-friend .btn-inactive-ra").prop("disabled", true);
                       return false;
                   }
               } else{
                    jQuery("#refer-a-friend input[name='username").addClass('is-invalid user-error');
                    jQuery("#refer-a-friend .btn-inactive-ra").prop("disabled", true);
                    return false;
               }
               /*to allow specific domain only end*/
               });
        var ReferAFriendViewModel = function(contactId) {
          var self = this;
          SageGlobals.formViewModel.call(self);

          //fields
          self.fullName = ko.observable('');
          self.username = ko.observable('');
                    SageGlobals.stateCountryViewModel.call(self);

                    self.country('US');
                    self.st = ko.observable();
                    self.stDisplay = ko.observable('');
          //internal props
          self.endPoint = 'VerizonReferral';

          self.validate = ko.pureComputed(function() {
            return self.fullName() !== '' &&
                self.validateEmail(self.username()) &&
                contactId !== '';
          });


          self.submitForm = function() {
            SageGlobals.showLoader();
            if(self.preSubmit()) {
                var verizonreferral = {
                    verizonreferral: {
                        contactid: contactId,
                        email: self.username(),
                        state: jQuery("#company_state").val(),
                        name: self.fullName()
                    }
              };

                callSalesforceApi("/services/apexrest/VerizonReferral", "POST", verizonreferral)
                .then(function(result) {
                if(result.success === true) {
                  jQuery("#loader").hide();
                  self.setMessage('success', self.successClass, 'Referral successfully sent!');
                  self.username('');
                  self.fullName('');
                  jQuery("#refer-a-friend .btn-inactive-ra").prop("disabled", true);
                  setTimeout(function(){
                         jQuery( "input[name='fullname" ).removeClass('is-invalid user-error user-success');
                         jQuery( "input[name='username" ).removeClass('is-invalid user-error user-success');
                                            jQuery("#refer-a-friend #company_state").next(".nice-select").removeClass('is-invalid user-error user-success');
                                            jQuery("#refer-a-friend #company_state").next(".nice-select").children(".current").text('--Select State/Province--');
                   }, 500);

                }
                else {
                  SageGlobals.log({
                    errorSeverity: 'WARNING',
                    error: result.status.errors || result.status,
                    payload: verizonreferral,
                    description: 'Failure to create VerizonReferral object'
                  });
                   jQuery("#loader").hide();
                  //failed due to user not being found
                   jQuery("#refer-a-friend .btn-inactive-ra").prop("disabled", true);
                  self.setMessage('error', self.errorClass, SageGlobals.GENERIC_ERROR_MSG);
                }
              })
              .catch(function(response) {
                SageGlobals.log({
                  errorSeverity: 'WARNING',
                  error: response,
                  payload: verizonreferral,
                  description: 'Exception creating VerizonReferral object'
                });
                jQuery("#loader").hide();
                jQuery("#refer-a-friend .btn-inactive-ra").prop("disabled", true);
                self.setMessage('error', self.errorClass, SageGlobals.GENERIC_ERROR_MSG);
              });
            }
             setTimeout(function() {
                  self.resetMessages();
            }, 5000);
          };
        };

        ko.applyBindings(new ReferAFriendViewModel(contactId), document.getElementById('refer-a-friend'));
      }
    },

    //Impersonate
    'page_id_5206': {
      init: function() {
        var queryParams = SageGlobals.getQueryParameters();
        var email = queryParams.email ? queryParams.email : '';
        var nonce = $('#impersonate-complete-account').val();

        var ImpersonateViewModel = function(email, nonce) {
          var self = this;
          SageGlobals.formViewModel.call(self);

          self.impersonateSubmitText = 'Impersonate User';

          self.foundUser = ko.observable(false);
          self.impersonationWorking = ko.observable(false);
          self.username = ko.observable(email);
          self.fullName = ko.observable('');
          self.email = ko.observable('');
          self.impersonateSubmit = ko.observable(self.impersonateSubmitText);


          self.submitForm = function() {
            if(self.preSubmit()) {
              var queryParams = {
                fields: 'user_id,name,email',
                searchValues: self.username()
              };

              _Auth0.query(queryParams).then(function (result) {
                if (result.length) {
                  self.userId = result[0].user_id;
                  self.fullName(result[0].name);
                  self.email(result[0].email);
                  self.foundUser(true);
                  self.setWorking(false);
                  self.resetMessages();

                }
                else {
                  SageGlobals.log({
                    errorSeverity: 'NOTICE',
                    error: 'User not found during NPP impersonation',
                    payload: self.username(),
                    description: ''
                  });

                  self.setMessage('error', self.errorClass, 'User not found');
                }
              }).catch(function (response) {
                SageGlobals.log({
                  errorSeverity: 'WARNING',
                  error: response,
                  payload: self.username(),
                  description: 'Exception querying Auth0 during NPP impersonation'
                });

                self.setMessage('error', self.errorClass, SageGlobals.GENERIC_ERROR_MSG);
              });
            }

          };

          self.impersonate = function() {
            self.impersonationWorking(true);
            self.impersonateSubmit('Working...');
            self._impersonate(self.userId, nonce, '/&impersonate=true');
          };

          self.cancel = function() {
            self.resetMessages();
            self.foundUser(false);
            self.username('');
          };

          self.validate = ko.pureComputed(function() {
            return self.validateEmail(self.username());
          });

          //internal logic to implement impersonation. Use public facing impersonate function to handle requests from UI
          self._impersonate = function(userId, nonce, redirect) {
            //reset messages to avoid repeating error notifications
            self.resetMessages();
            _Auth0.getImpersonationUrl(userId, userId, nonce, redirect).then(function (result) {
              try {
                if (result.success) {
                  //successfully got impersonation url. Send the user to get logged in and redirected to the redirect url
                  window.location.href = result.url;
                }
                else {
                  SageGlobals.log({
                    errorSeverity: 'WARNING',
                    error: result,
                    payload: {userId: userId, imposterId: userId, nonce: nonce},
                    description: 'Error getting impersonation url'
                  });
                  self.setMessage('error', self.errorClass, SageGlobals.GENERIC_ERROR_MSG);
                  self.impersonationWorking(false);
                  self.impersonateSubmit(self.impersonateSubmitText);
                }
              }
              catch (e) {
                SageGlobals.log({
                  errorSeverity: 'WARNING',
                  error: e.message,
                  payload: result,
                  description: 'Failed to parse impersonation ajax response'
                });
                self.setMessage('error', self.errorClass, SageGlobals.GENERIC_ERROR_MSG);
                self.impersonationWorking(false);
                self.impersonateSubmit(self.impersonateSubmitText);
              }
            }).catch(function (response) {
              SageGlobals.log({
                errorSeverity: 'WARNING',
                error: response,
                payload: {userId: userId, imposterId: userId, nonce: nonce},
                description: 'Error thrown from impersonation API call'
              });
              self.setMessage('error', self.errorClass, SageGlobals.GENERIC_ERROR_MSG);
              self.impersonationWorking(false);
              self.impersonateSubmit(self.impersonateSubmitText);
            });
          };
        };

        ko.applyBindings(new ImpersonateViewModel(email, nonce), document.getElementById('impersonate'));
      }
    },

    'page_id_8092': {
      init: function() {

        var BusinessViewModel = function (st, associationId) {
          var self = this;
          SageGlobals.registrationViewModel.call(self);
          SageGlobals.contactViewModel.call(self);
          SageGlobals.accountViewModel.call(self);
          SageGlobals.stateCountryViewModel.call(self);
            jQuery( "#company_state" ).select2();
            jQuery("#company_state").find('option:first').prop("disabled", false);
            jQuery('.select2-container--default').css('width','100%').addClass('nice-select');
            jQuery('.select2-selection--single').css({"border": "none", "height": "35px","margin-top": "8px","outline": "none!important"});
            jQuery('.select2-selection__arrow').css({"height": "100%"}).hide();
          self.country('US');
          self.st(st);
          self.leadSource = 'Contracted Marketing Partner';
          self.leadSourceDetail = 'Guidant';
          self.recordType = IOT_CONFIG.sfdc.recordType.COMPANY_REP;
          self.availableAssociations = ko.observableArray([]);
          self.selectedAssociation = ko.observable();
          self.referrerAssociation = ko.observable('');
          self.userSelectedAssociation = associationId;
          self.showAssociationSelection = ko.observable(false);
          self.associationsLoaded = ko.observable(false);
          self.$referrerAssociation = $('#referrer-association');
          self.$referrerAssociationName = $('#referrer-association-name');
          self.guidantId = ko.observable();
          self.usernameConfirm = ko.observable('');
          self.endPoint = 'Lead';
          self.redirectUrl = '/guidant-thank-you';
            self.emailsMatch = ko.computed(function() {
                return self.username() === self.usernameConfirm();
            });
          self.validate = ko.pureComputed(function () {
            return self.validateEmail(self.username()) &&
                self.emailsMatch() &&
              self.fname() !== '' &&
              self.lname() !== '' &&
              self.companyName() !== '' &&
              self.title() !== '' &&
              self.industry() !== '' &&
              self.companySize() !== '' &&
              self.address1() !== '' &&
              self.city() !== '' &&
              self.st() !== '' &&
              self.validatePostalCode(self.postalCode()) &&
              self.country() !== '' &&
              self.validateTel(self.tel()) &&
              self.validateUrlOpt(self.website());
          });

            self.getRegistrationFlowData = function () {
                var data = {
                    lead: {},
                    // rep: {},
                    isSalesRepCreation: false
                };
                //Lead fields
                data.lead.title = self.title();
                data.lead.companyName = self.companyName();
                data.lead.industry = self.industry();
                data.lead.companySize = self.companySize();
                data.lead.website = self.website();
                data.lead.street = self.streetAddress();
                data.lead.city = self.city();
                data.lead.state = self.st();
                data.lead.postalCode = self.postalCode();
                data.lead.country = self.country();
                data.lead.accountType = "Member Company";
                data.lead.verizonEligible = "";
                data.lead.leadSource = self.leadSource;
                data.lead.leadSourceDetail = self.leadSourceDetail;
                data.lead.contractedMarketingPartnerId = self.guidantId();
                data.lead.recordTypeId = self.recordType;
                data.lead.lastname = self.lname();
                data.lead.firstname = self.fname();
                data.lead.email = self.username();
                data.lead.phone = self.tel();
                data.lead.ext = self.telExt();
                data.lead.emailDuplicationCheck = self.username() + ' - Member';


                return data;
            };


            //override registration for company rep because we create a Lead w/out an Auth0 account
            self.register = function () {
                if (!self.emailsMatch()) {
                    self.setMessage('error', self.errorClass, 'Email and Confirm Email do not match.');
                    return; // Prevent form submission
                }
                if (self.preSubmit()) {
                    self.data = self.getRegistrationFlowData();
                    callSalesforceApi("/services/apexrest/CreateLeadAndRep", "POST", self.data)
                        .then(function (result) {
                      if (result.success === true || result.success === 'true') {

                                //if association exists, create member association object and tie to lead
                  var memberAssociation = {
                    association: self.userSelectedAssociation,
                    lead: result.leadid,
                    isMember: true,
                    primaryAssociation: true,
                    contractedMarketingPartnerId: self.guidantId()
                  };

                    callSalesforceApi('/services/apexrest/MemberAssociation', 'POST', memberAssociation)
                        .then(function (result) {
                        // Parse the response manually
                         var parsedResult = JSON.parse(result);
                           if (parsedResult.success === true) {
                                 self.redirect();
                             }else {
                                   throw new Error("Member association creation failed: " + JSON.stringify(result));
                             }


                        // self.setMessage('error', self.errorClass, SageGlobals.GENERIC_ERROR_MSG);

                      }).catch(function(response) {
                    //if there is an error adding the association log it, but let the process continue
                    SageGlobals.log({
                      errorSeverity: 'WARNING',
                      error: response,
                      payload: memberAssociation,
                      description: 'Exception thrown during ' + self.endPoint + ' - ' + self.memberAssocEndPoint + '.Create'
                    });

                    self.setMessage('error', self.errorClass, SageGlobals.GENERIC_ERROR_MSG);
                  });
                }
                else {
                  if (result.statusCode === '200') {

                    result.status.errors.forEach(function (item) {
                      var emailExists = self.checkEmailExists(item.message),
                        errorMsg = item.message;

                      if(emailExists !== false) {
                        errorMsg = emailExists.errorMsg;
                      }

                      self.setMessage('error', self.errorClass, errorMsg);
                    });

                    SageGlobals.log({
                      errorSeverity: 'NOTICE',
                      error: result.status.errors,
                      payload: result.payload,
                      description: 'Failure in ' + self.endPoint + '.Create'
                    });
                  }
                  else {
                    SageGlobals.log({
                      errorSeverity: 'WARNING',
                      error: result.status.errors || result.status,
                      payload: result.payload,
                      description: 'Error in ' + self.endPoint + '.Create'
                    });
                    self.setMessage('error', self.errorClass, 'Something went wrong during registration. Please try again later.');
                  }
                }
              })
                .catch(function (response) {
                            var errorMessage = '';
                            jQuery("#loader").hide();
                            if (response.responseText) {
                                try {
                                    var errorObj = JSON.parse(response.responseText);
                                    errorMessage = errorObj.error;

                                    // Check for specific duplicate email error
                                    if (errorMessage && errorMessage.includes('Duplicate Contact')) {
                                        var custom_msg = 'This email address is already in use. Please <a data-gat="click" data-gatcategory="Registration" data-gatlabel="Error Message" data-gataction="Toggle Login" href="/?login=true">login</a> or use another email address. If you have any questions on your registration, please contact us at <a href="mailto:customerservice@mynpp.com">customerservice@mynpp.com</a> or <a href="tel:800.810.3909">800.810.3909</a>.';
                                        self.setMessage('error', self.errorClass, custom_msg);
                                    } else {
                                        self.setMessage('error', self.errorClass, 'Something went wrong during registration. Please try again later.');
                                    }
                                } catch (e) {
                                    errorMessage = 'Failed to parse error response.';
                                    self.setMessage('error', self.errorClass, errorMessage);
                                }
                            } else {
                                self.setMessage('error', self.errorClass, 'No response from the server.');
                            }
                  //exception thrown during create request
                  SageGlobals.log({
                    errorSeverity: 'WARNING',
                    error: response,
                    payload: self.data,
                    description: 'Exception thrown during ' + self.endPoint + '.Create'
                  });
                            // self.setMessage('error', self.errorClass, 'Something went wrong during registration. Please try again later.');
                });
            }
          };

          self.redirect = function() {
            window.location.href = self.redirectUrl;
          };
        };

        var businessModel = new BusinessViewModel($('#guidant-st').val(), $('#guidant-cmp').val());

        //custom binding that wraps the value binding and does initialization
        ko.bindingHandlers.valueWithInitialize = {
          init: function(element, valueAccessor, allBindingsAccessor) {
            var value = valueAccessor();
            if (ko.isObservable(value)) {
              value(element.value);
            }
            ko.bindingHandlers.value.init(element, valueAccessor, allBindingsAccessor);
          },
          update: function(element, valueAccessor) {
            ko.bindingHandlers.value.update(element, valueAccessor);
          }
        };

        businessModel.guidantId($('#guidant-id').val());
        businessModel.username($('#guidant-email').val());
        businessModel.usernameConfirm($('#guidant-emailconfirm').val());
        businessModel.companyName($('#guidant-company').val());
        businessModel.lname($('#guidant-lname').val());
        businessModel.fname($('#guidant-fname').val());
        businessModel.title($('#guidant-title').val());
        businessModel.tel($('#guidant-tel').val());
        businessModel.telExt($('#guidant-tel-ext').val());
        businessModel.address1($('#guidant-address1').val());
        businessModel.city($('#guidant-city').val());
        businessModel.postalCode($('#guidant-postalcode').val());

        ko.applyBindings(businessModel, document.getElementById('guidant-registration'));

      }
    },
        //Sales rep Account
    'page_id_6710': {
                     init: function() {
                         SageGlobals.trackingScript('home');
                        // jQuery('.report-table').find('tr:has(td.hiderow)').hide();
                           if(jQuery('.report-table').find('tr:visible').length <= 1){
                               jQuery('.report-table').find('tr').remove();
                               jQuery('.report-table').append("<tr><td><p class='no-data'>No Data Found</p></td></tr>");
                           }
                      }
                 },
          //affiliate-dashboard
         'page_id_6868': {
                 init: function() {
                        SageGlobals.trackingScript('affiliate-dashboard');
                 }
          },
            //Marketing Material
    'page_id_6874': {
          init: function() {
                       document.multiselect('#bransSelect').deselectAll();
                       jQuery('#bransSelect_itemList ul').mCustomScrollbar();
                       jQuery('#bransSelect_input').attr('placeholder','Brand');
                       jQuery('#tfa_872').removeClass('nice-select');
                        var queryParams = SageGlobals.getQueryParameters();
                        var formAssemblySubmitted = queryParams.hasOwnProperty('tfa_next');

                         if (formAssemblySubmitted) {
                          jQuery('#myModal').modal('show');
                          jQuery('.offer_redemption_main').css('display','none');
                          jQuery('#offer_redemption_thanks').css('display','block');
                          window.history.pushState('page2', 'Title', '/marketing-material');
                       }
                           jQuery.extend(jQuery.expr[":"], {
                                   "containsIN": function(elem, i, match, array) {
                                   return (elem.textContent || elem.innerText || "").toLowerCase().indexOf((match[3] || "").toLowerCase()) >= 0;
                                   }
                               });
                            var brand = queryParams.hasOwnProperty('brand');
                            var type = queryParams.hasOwnProperty('type');
                            var brand_id='';
                                  if (brand ) {
                                  var brand1=queryParams.brand;

                                   brand_id=jQuery('#bransSelect option:containsIN("'+brand1+'")').val();
                                    console.log(brand_id);
                                    }
                                    if (type) {
                                    var types1=queryParams.type;
                                    jQuery('#filer_dropdown option:containsIN("'+types1+'")').attr('selected','selected');
									jQuery("#filer_dropdown").next(".nice-select").find("ul li").removeClass("selected focus");
									jQuery("#filer_dropdown").next(".nice-select").find('ul li:containsIN("'+types1+'")').addClass("selected focus");
                                   }
                                    if (brand||type) {
                                 setTimeout(function (event) {
                                   document.multiselect('#bransSelect').select(brand_id);
                                   jQuery('.seachMaterial').trigger('click');
                                 }, 800);
                                 }
                     }
     },
        //Resources page
        'page_id_5018': {
            init: function() {
                var queryParams = SageGlobals.getQueryParameters();
                var formAssemblySubmitted = queryParams.hasOwnProperty('tfa_next');
                if (formAssemblySubmitted) {
                    jQuery('#myModal').modal('show');
                    jQuery('.offer_redemption_main').css('display','none');
                    jQuery('#offer_redemption_thanks').css('display','block');
                    window.history.pushState('page2', 'Title', '/communities-solutions/');
                }
            }
        },
        //Resources page
        'page_id_44785': {
            init: function() {
                var queryParams = SageGlobals.getQueryParameters();
                var formAssemblySubmitted = queryParams.hasOwnProperty('tfa_next');
                if (formAssemblySubmitted) {
                    jQuery('#myModal').modal('show');
                    jQuery('.offer_redemption_main').css('display','none');
                    jQuery('#offer_redemption_thanks').css('display','block');
                    window.history.pushState('page2', 'Title', '/communities-solutions/');
                }
            }
        },
        //Referrals page
                //'page_id_39892': { //for staging
                   'page_id_44423': { //for production
                    init: function() {
                      jQuery('#SelectReferrals').change(function () {
                        //show form according selection
                        if (jQuery(this).val() === '5008889') {
                          window.location.href = "/referrals/?ref=company";
                        }
                        if (jQuery(this).val() === '5008895') {
                          window.location.href = "/referrals/?ref=membership";
                        }
                      });

                      var queryParams = SageGlobals.getQueryParameters();
                      var FormKey = queryParams.ref;
                      if (FormKey === 'membership') {
                        jQuery('#SelectReferrals option[value="5008895"]').prop('selected', true);                     }

                      if (FormKey === 'company') {
                        jQuery('#SelectReferrals option[value="5008889"]').prop('selected', true);
                      }
                      var formAssemblySubmitted = queryParams.hasOwnProperty('tfa_next');
                      var response = queryParams.tfa_next ? queryParams.tfa_next : '';
                      console.log(response);
                      if (formAssemblySubmitted && response === '/responses/last_success?jsid') {
                        jQuery('#myModal').modal('show');
                        //jQuery('.show_form').show();
                        jQuery('#offer_redemption_thanks').css('display', 'block');
                        window.history.pushState('page2', 'Title', window.location.pathname);
                        jQuery('#SelectReferrals option[value="default"]').prop('selected', true);
                      } else if (formAssemblySubmitted && response !== '/responses/last_success?jsid') {
                        jQuery('.success_msg').show();
                        //jQuery('.show_form').hide();
                      }
                    }
                   },
            //deactive contact
                //'page_id_32506': { //for staging
                 'page_id_44611': { // for production
                    init: function() {
                         var queryParams = SageGlobals.getQueryParameters();
                         var formAssemblySubmitted = queryParams.hasOwnProperty('form_submit');
                         var response = queryParams.tfa_next ? queryParams.tfa_next : '';
                        jQuery(".modal-header").removeClass('custom_thnk');
                        jQuery(".modal-body").removeClass('custom_thnk');
                        jQuery(".close").show();
                            jQuery('#offer_redemption_thanks').css('display','none');
                            jQuery('#offer_redemption_main').css('display','block');
                            if(jQuery('#offer_redemption_main').css('display') === 'block')
                            {
                                jQuery('.modal-content').addClass('backgoundFFF');
                            }
                            if (formAssemblySubmitted ) {
                              jQuery('#myModal').modal('show');
                              jQuery('#offer_redemption_thanks').css('display','block');
                              jQuery(".modal-header").addClass('custom_thnk');
                                jQuery(".modal-body").addClass('custom_thnk');
                                jQuery(".close").hide();
                                jQuery('#offer_redemption_main').css('display','none');
                                if(jQuery('#offer_redemption_main').css('display') === 'none')
                                {
                                    jQuery('.modal-content').removeClass('backgoundFFF');
                                }
                              window.history.pushState('page2', 'Title', window.location.pathname);
                          }
                            jQuery('#tfa_16').val(jQuery('#contact_id').val());
                            jQuery('#tfa_17').val(jQuery('#AccId').val());
                            jQuery('#tfa_18').val(jQuery('#email').val());
                            jQuery('#tfa_20').val(jQuery('#nameF').val());
                            jQuery('#tfa_22').val(jQuery('#AccName').val());
                            jQuery('#tfa_24').val(jQuery('#AccPass').val());
                        }
                },
     //Tutorial page
//    'page_id_25147': {
//         init: function () {
//            jQuery(document).ready(function () {
//              var hash = window.location.hash;
//              var anchor =jQuery(hash);
//                 if (anchor.length > 0){
//                     anchor.click();
//                 }
//
//            });
//            }
//          },
          // Affiliate Referral
          'page_id_25178': {
              init: function () {
                  jQuery(document).ready(function () {
                     jQuery('#tfa_2831').val(jQuery('.contact_email').attr('id'));
                 });
              }
            },
        // Internal Referral
              'page_id_25180': {
                  init: function () {
                      jQuery(document).ready(function () {
                          jQuery('#tfa_2787').val(jQuery('.contact_id').attr('id'));
         });
         }
       },
            // Lead Search production
                     'page_id_25356': {
                          init: function () {
                           var self = this;
                            SageGlobals.stateCountryViewModel.call(self);

                           self.country('US');
                           jQuery(document).ready(function () {
                             if(jQuery('#IsGovPrivateRep').val()==='Yes'){
                                           SageGlobals.getIndustryData(IOT_CONFIG.PORTAL_HOST,'private,gov');
                                      } else if(jQuery('#IsGovPrivateRep').val()==='gov'){
                                           SageGlobals.getIndustryData(IOT_CONFIG.PORTAL_HOST,'gov');
                                      } else { SageGlobals.getIndustryData(IOT_CONFIG.PORTAL_HOST,'private'); }

                                       jQuery("#company_state").prop("selectedIndex", 0);
                                      jQuery('#company_state > option').slice(-14).remove();
                                       jQuery('.select_single_states #company_state').niceSelect();
                                       jQuery('.select_single_states #company_state').next(".nice-select").children(".current").text('--Select State/Province--');

                                        jQuery(".select_single_states #company_state").next(".nice-select").children(".list").mCustomScrollbar();

                                    jQuery('#advance_search').click(function(){
                                           if(jQuery('#show_advance_section').is(':hidden'))
                                           {   jQuery('#show_advance_section').show();
                                               jQuery('.form-group select').next(".nice-select").find('li:first').prop("disabled", false);
                                               jQuery('.form-group select').find('option:first').prop("disabled", false);
                                                jQuery('#show_advance_section').css({"float": "left", "margin": "50px 0"});
                                               jQuery('.submit_section').appendTo('#show_advance_section').last('.form-group');
                                               jQuery('#show_advance_section .submit_section').addClass('form-group');
                                               jQuery('#show_advance_section #company_dnb_search').css("margin-top", "-11px");
                                               jQuery('#show_advance_section .input-icon-tooltip').css({"width": "269px", "bottom": "-19px","right": "-205px"});
                                           }
                                           else {jQuery('#show_advance_section').hide();
                                           jQuery('.submit_section').appendTo('#business-registration_dnb').last('.form-group');
                                           jQuery('#business-registration_dnb .submit_section').removeClass('form-group');
                                           jQuery('#business-registration_dnb #company_dnb_search').removeAttr( 'style' );
                                           jQuery('#business-registration_dnb .input-icon-tooltip').removeAttr( 'style' );
                                           }
                                       });
                                       jQuery(':checkbox[name=lead_type\\[\\]]').change(function() {
                                             var lead_type =  jQuery.map(jQuery(':checkbox[name=lead_type\\[\\]]:checked'), function (n, i) {
                                               return n.value;
                                              }).join(',');
                                               SageGlobals.getIndustryData(IOT_CONFIG.PORTAL_HOST,lead_type);
                                               if((jQuery("#busi_industry").next(".nice-select").children(".current").text('--Select Industry--')) &&
                                                   (jQuery("#busi_subindustry").next(".nice-select").children(".current").text('--Select Sub Industry--')) &&
                                                   (jQuery("#busi_verizonv").next(".nice-select").children(".current").text('--Select Verizon Vertical--')) &&
                                                   (jQuery("#company_state").next(".nice-select").children(".current").text('--Select State/Province--'))
                                                   (jQuery('#code-dnb').val()==='') && (jQuery('#company-dnb').val()==='') ){
                                               jQuery(".search_section #company_dnb_search").removeClass('active');}

                                        });
                                        jQuery('#reset_search').click(function(){
                                           jQuery('#company-dnb, #code-dnb, select').val('').removeAttr('selected');
                                           jQuery("#busi_industry").next(".nice-select").children(".current").text('--Select Industry--');
                                           jQuery("#busi_subindustry").next(".nice-select").children(".current").text('--Select Sub Industry--');
                                           jQuery("#busi_verizonv").next(".nice-select").children(".current").text('--Select Verizon Vertical--');
                                           jQuery("#company_state").next(".nice-select").children(".current").text('--Select State/Province--');
                                           jQuery(".search_section #company_dnb_search").removeClass('active');
                                                  return false;
                                        });

                             });
                        }
                       },
     'page_id_5115': {
          init: function () {
            //explicitly set each card height to it's natural value so Safari will respect the child 100% CSS value
            SageGlobals.equalHeight($('.tab-option__body'));
            SageGlobals.equalHeight($('.tab-option__description'));


            //test if we need to show a registration flow by default
            var queryParams = SageGlobals.getQueryParameters();
            //                var registrationFlow = "community",
            //                    passcode = queryParams.passcode || '';
             var registrationFlow = queryParams.hasOwnProperty('flow') && ['rep', 'affiliate'].indexOf(queryParams.flow) !== -1 ? queryParams.flow : '',
              passcode = queryParams.passcode || '';
            // Registration Page
            var ViewModel = function () {
              var self = this;

              self.modalActive = ko.observable(false);
              if(registrationFlow!==''){  jQuery('#main_join_now_box').hide(); }
              self.registrationType = ko.observable(registrationFlow);
             };



            var EmployeeViewModel = function (passcode) {
              var self = this;
              SageGlobals.registrationViewModel.call(self);
              SageGlobals.contactViewModel.call(self);

              //additional data
             // self.recordType = IOT_CONFIG.sfdc.recordType.COMMUNITY;
                self.recordType = IOT_CONFIG.sfdc.recordType.SALESREP;
                self.contactType = 'Sales rep';
             //self.contactType = 'Company Employee';
              self.endPoint = 'contact';
                if (queryParams.hasOwnProperty('isReferral')) {
                    self.leadSource = 'Rep Referral';
                    console.log('Setting leadSource to Referral');

                }


                self.getRegistrationFlowData = function(data) {
                //additional contact fields
                data.contactType = self.contactType;
               data.recordTypeId = self.recordType;
                data.leadSource = self.leadSource;
                data.emailDuplicationCheck=self.username()+' - Portal';
                data.passCode = self.formatPasscode(self.passCode());

                if(self.computedAssociation() !== '') {
                  //if lead is referred from association landing page override lead source and lead source detail
                  data.leadSource = 'Contracted Marketing Partner';
                  data.leadSourceDetail = self.computedAssociationName();
                }

                return Object.assign(data, self.createUserData());
              };

              self.passCodeDisabled = false;//ko.observable(self.validatePasscode(passcode)); no longer needed to disable passcode field when we get passcode in URL, based on the new design we will indicate validation (red / green)
              setTimeout(function (event) {
                             jQuery('#passcode').trigger('keyup');
               }, 500);

              self.passCode = ko.observable(self.formatPasscode(passcode));

              self.validate = ko.pureComputed(function () {
                return self._validate() &&
                  self.validatePasscode(self.passCode());
              });

            };

            var AffiliateViewModel = function (passcode) {
                var self = this;
                SageGlobals.registrationViewModel.call(self);
                SageGlobals.contactViewModel.call(self);
                self.recordType = IOT_CONFIG.sfdc.recordType.AFFILIATE;
                //additional data
                self.contactType = 'Affiliate';
                self.endPoint = 'contact';
                var referral = queryParams.hasOwnProperty('referral');
                if(referral){
                 self.referralContact=true;
                }

                self.getRegistrationFlowData = function (data) {
                    //additional contact fields
                    data.contactType = self.contactType;
                    data.referralContact = self.referralContact;
                    data.recordTypeId = self.recordType;
                    data.leadSource = self.leadSource;
                    data.emailDuplicationCheck=self.username()+' - Portal';
                    data.passCode = self.formatPasscode(self.passCode());

                    if (self.computedAssociation() !== '') {
                        //if lead is referred from association landing page override lead source and lead source detail
                        if(self.$referrer_campaign.val()!==''){
                            data.campaign = self.$referrer_campaign.val();
                         } else {
                            data.leadSource = self.$referrer_lead_source.val(); //added filed in admin
                            data.leadSourceDetail = self.computedAssociationName();
                        }
                    }

                    return Object.assign(data, self.createUserData());
                };

                self.passCodeDisabled = false;//ko.observable(self.validatePasscode(passcode)); no longer needed to disable passcode field when we get passcode in URL, based on the new design we will indicate validation (red / green)
                setTimeout(function (event) {
                    jQuery('#passcode-affiliate').trigger('keyup');
                }, 500);
                jQuery('#affilatstep_3 .btn-inactive-ra').prop("disabled", true);
                self.passCode = ko.observable(self.formatPasscode(passcode));

                self.validate = ko.pureComputed(function () {
                    return self._validate() &&
                        self.validatePasscode(self.passCode());
                });

                            };
            ko.bindingHandlers.stopBinding = {
              init: function () {
                return {controlsDescendantBindings: true};
              }
            };
            ko.virtualElements.allowedBindings.stopBindings = true;

            ko.applyBindings(new ViewModel(), document.getElementById('registration'));

            ko.applyBindings(new EmployeeViewModel(passcode), document.getElementById('community-registration'));
            ko.applyBindings(new AffiliateViewModel(passcode), document.getElementById('affiliate-registration'));

          }
        }
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.


// //custom code
function isMobile() {
  return (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent));
}
function loadScript(url,what,type) {
 var script = document.createElement(what);
  script.type = "text/"+type;
  if(what==='script'){ script.src = url; }
  else {
  script.href  = url;
  script.rel="stylesheet";
  }
  document.body.appendChild(script);
}
if (isMobile() && ( jQuery('body').hasClass('lead-search') || jQuery('body').hasClass('member-search') )) {
  loadScript("https://cdn.datatables.net/responsive/2.2.7/js/dataTables.responsive.min.js",'script','javascript');
  loadScript("https://cdn.datatables.net/1.10.24/css/jquery.dataTables.min.css",'link','css');
  loadScript("https://cdn.datatables.net/responsive/2.2.7/css/responsive.dataTables.min.css",'link','css');
  console.log("mobile script");
}
jQuery(document).ready(function() {
   var notFound = jQuery("#notFound");
   notFound.hide();
    jQuery("#myInput").on("keyup", function () {
        jQuery("#notFound").hide();
        jQuery('.myTable').show();
        var value = jQuery(this).val().toLowerCase();

        var allItems = jQuery(".myTable .sec_naics");
        var matchedItems = jQuery(".myTable .sec_naics").filter(function () {
            return jQuery(this).text().toLowerCase().indexOf(value) > -1;
        });
        allItems.toggle(false);
        matchedItems.toggle(true);

        if (matchedItems.length === 0) { notFound.show(); jQuery('.naics-title').hide();}
        else { notFound.hide(); jQuery('.naics-title').show();}
        jQuery('.title_indu').hide();
        jQuery('.naics_all_code').each(function (index, element) {
            if (jQuery(element).find('.sec_naics').is(':visible')) {
                jQuery(this).find('.title_indu').show();
            }
        });
    });
});
function getLeadData(values){
    jQuery("#lead_result").remove();
    jQuery('#reminder_message').css('display', 'none');
  jQuery.ajax({
        url: IOT_CONFIG.PORTAL_HOST + "/app/themes/sage/lib/leadSearch.php",
     type: "POST",
     dataType: 'text',
     cache: false,
     data: values, // serializes the form's elements.
     beforeSend: function(){
       // Show image container
       jQuery("#loader").show();
     },
     success: function(html)
     {
       jQuery('#result').after(html);
           var temp = jQuery('#code-dnb').val().split(",");
           if(temp.length > 5){
               jQuery('#myModalmulti').modal('show');
               jQuery('#offer_redemption_main_multi').css('display','none');
               jQuery('#offer_redemption_thanks_multi, .close').css('display','block');
           }
            var sortfield=[0,5];
            var sortfilter=[3, 5];
            if (!jQuery('#verion_show').hasClass('verizon_no')) {
                sortfield=[0,4];
                sortfilter=[3, 4];
            }

           jQuery.noConflict();
               jQuery('#company_list_table').DataTable( {
                          responsive: true,
                          oLanguage: {
                             "sSearch": "",
                             "oPaginate": {
                                "sNext": '&raquo;',
                                "sPrevious": '&laquo;'
                             },
                           },
                           "columnDefs": [
                              { "orderable": false, "targets": sortfield}
                           ],
                          initComplete: function () {
                              this.api().columns(sortfilter).every( function () {
                                  var column = this;
                                   var select = jQuery('<select multiple="multiple" class="result_filter "><option value="">Filter By '+jQuery(column.header()).html()+'</option></select>')
                                      .appendTo( '.dataTables_filter')
                                      .on( 'change', function () {
//                                          var val = $.fn.dataTable.util.escapeRegex(
//                                              $(this).val()
//                                          );
                                           //var val =jQuery(this).val();
                                           var vals = jQuery('option:selected', this).map(function (index, element) {
                                                                   	return jQuery(this).val();
                                                                   }).toArray().join('|');
                                          column
                                              .search( vals ? '^'+vals+'$' : '', true, false )
                                              .draw();
                                        } );

                                  column.data().unique().sort().each( function ( d, j ) {
                                       if(d!==''){select.append( '<option value="'+d+'">'+d+'</option>' ); }
                                  } );
                              } );

                          }
                      } );
                      jQuery('#company_list_table_filter').after( "<div class='clearfix'></div>" );
                      jQuery('#company_list_table_filter label').addClass('result_filter');
                      jQuery('.result_filter input').attr('placeholder','Search');
                      jQuery('#company_list_table_info').addClass('margin-bottom-20');
                      jQuery('table th:first').removeClass('sorting_asc');
                       if (isMobile()) {
                            jQuery('#lead_result').find('table#company_list_table').removeClass('company_list_table');
                        }
                      //jQuery('.dataTables_paginate').addClass('custom-pagination _pagination');
                     // jQuery('.paginate_button').addClass('page-numbers');
                      //jQuery(".dataTables_filter select").niceSelect();
                      //jQuery('.list').mCustomScrollbar({});


       if (jQuery(html).filter('#lead_result').find('.no_data_found').length) {
         jQuery(".sendgrid_lead_search").css("display", "none");
         jQuery('.sendgrid_lead_search').removeAttr('id');
       } else {
         jQuery(".sendgrid_lead_search").css("display", "block");
         if (jQuery('body').hasClass('verizonwireless')) {
           // Add the id 'show-verizon-content' to the element(s) with class 'sendgrid_lead_search'
           jQuery('.sendgrid_lead_search').attr('id', 'show-verizon-content');

         }
       }
       jQuery("#loader").hide();
     }
   });
 }

function getData(pagelength) {
    pagelength = pagelength || 1;
   var account_id = jQuery('#account_id').val();
    var ccode_dnb = jQuery('#code-dnb').val();
    var company_dnb = jQuery('#company-dnb').val();
    var contact_id=jQuery('#rep_name').val();
    var temp = ccode_dnb.split(",");
    console.log(temp.length);
    var industry='';
    var subindustry='';
    var vz_vertical="";
    if (jQuery('#verion_show').hasClass('verizon_no')) {
         industry = jQuery('#busi_industry').val().trim();
         subindustry = jQuery('#busi_subindustry').val();
    }
    else
    {
        vz_vertical=jQuery('#busi_verizonv').val();
    }
    var state="";
    if(jQuery('#company_state').val()!==null){ state= jQuery('#company_state').val();}
    var valuesArray =  jQuery.map(jQuery(':checkbox[name=lead_type\\[\\]]:checked'), function (n, i) {
                              return n.value;
                             }).join(',');
    var lead_type =valuesArray;

    if(lead_type==='') {
        lead_type = jQuery('#IsGovPrivateRep').val();
    }
    var IsGovPrivateRep= jQuery('#IsGovPrivateRep').val();
    var morethan_five="Yes";
    var values ="";
    if (jQuery('#verion_show').hasClass('verizon_no')) {
         values = "companyname=" + encodeURIComponent(company_dnb) + "&contact_id=" + contact_id + "&account_id=" + account_id + "&postal-code-dnb=" +
    ccode_dnb + "&dnb_pagelength=" + pagelength+"&industry="+encodeURIComponent(industry)+"&sub_industry="+encodeURIComponent(subindustry)+
     "&state="+state+"&lead_type="+lead_type+"&IsGovPrivateRep="+IsGovPrivateRep;
    } else {
        values = "companyname=" + encodeURIComponent(company_dnb) + "&contact_id=" + contact_id + "&account_id=" + account_id + "&postal-code-dnb=" +
            ccode_dnb + "&dnb_pagelength=" + pagelength + "&vz_vertical=" + vz_vertical +
            "&state=" + state + "&lead_type=" + lead_type + "&IsGovPrivateRep=" + IsGovPrivateRep;
    }
     //values=values+ "&morethan_five="+morethan_five;
     if(temp.length > 5){
        jQuery('#myModalmulti').modal('show');
        jQuery('#myModalmulti').find('.modal-dialog').removeClass('zoomOut,  animated');
        jQuery('#offer_redemption_main_multi').css('display','block');
        jQuery('#offer_redemption_thanks_multi, .close').css('display','none');
        jQuery("#myModalmulti-btn-no").off('click').on("click", function(){
         location.reload();
        });
        jQuery("#myModalmulti-btn-si").off('click').on("click", function(){
          jQuery('#myModalmulti').modal('hide');
               values=values+"&morethan_five=Yes";
              getLeadData(values);
        });

    } else {
       values=values+"&morethan_five=No";
        getLeadData(values);
    }
}
 function hideShowPass_portal(){
    var emp = document.getElementById("password_type_emp");
      if (emp.type === "password") {
        emp.type = "text";
        jQuery('.input-icon2').show();
        jQuery('.input-icon1').hide();
      } else {
        emp.type = "password";
        jQuery('.input-icon2').hide();
        jQuery('.input-icon1').show();
      }
    var emp_affilate = document.getElementById("password_type_emp_affilate");
        if (emp_affilate.type === "password") {
            emp_affilate.type = "text";
            jQuery('.input-icon2').show();
            jQuery('.input-icon1').hide();
        } else {
            emp_affilate.type = "password";
            jQuery('.input-icon2').hide();
            jQuery('.input-icon1').show();
        }
 }
 function hideShowPass() {
   var con = document.getElementById("password_type");
   if (con.type === "password") {
     con.type = "text";
     jQuery('.input-icon2').show();
     jQuery('.input-icon1').hide();

   } else {
     con.type = "password";
     jQuery('.input-icon2').hide();
          jQuery('.input-icon1').show();

   }

   var emp = document.getElementById("password_type_emp");
   if (emp.type === "password") {
     emp.type = "text";
   } else {
     emp.type = "password";
   }
 }
function hideShowPasslogin() {

  var homelogin = document.getElementById("homepassword_type");
  if (homelogin.type === "password") {
    homelogin.type = "text";
    jQuery('.input-icon2').show();
    jQuery('.input-icon1').hide();

  } else {
    homelogin.type = "password";
    jQuery('.input-icon2').hide();
    jQuery('.input-icon1').show();
  }
}

 jQuery(document).ready(function () {
 jQuery('.input-icon2').hide();
    //on focus password field
    jQuery('#lead_search_info, #password_type_bus, #password_type_emp, #constep_1 #password_type, #password_type_emp_affilate').blur(function () {
      var parent_id=jQuery(this).parent().attr("id");
      jQuery('#'+parent_id+ ' .input-icon-tooltip').css({"display":"none"});
   });
    jQuery('#lead_search_info, #password_type_bus, #password_type_emp, #constep_1 #password_type, #password_type_emp_affilate').focus(function () {
     var parent_id=jQuery(this).parent().attr("id");
     jQuery('#'+parent_id+ ' .input-icon-tooltip').css({"display":"block","opacity":"1"});
   });

    // NWD-1266 NPP & NPPGov Site Referral Function

    if (jQuery('.wFormContainer a.errMsg').length > 0) {
        var errorMessage = jQuery('.wFormContainer a.errMsg').html();
        var avoidMessage = " - ";
        if(errorMessage.indexOf(avoidMessage) !== -1){
            //var avoided = errorMessage.replace(avoidMessage,'');
            var avaoided = errorMessage.split(avoidMessage);     
            jQuery('.wFormContainer a.errMsg').html(avaoided[1]);
        }
    } 
 });
function direct_reg_next() {
    //jQuery('#step_1 #continue_1').trigger('click');
    jQuery('#step_1').css("display", "none").removeClass('active_tab');
    jQuery('#step_2').css("display", "block").addClass('active_tab');
    jQuery("#company_name_dnb_plus").val('');
    jQuery("#postal_code_dnb_plus").val('');
    jQuery("#company_address1").val('');
    jQuery("#company_city").val('');
    jQuery('#busi_comp_size option, #company_state option, #busi_industry option, #busi_subindustry option').removeAttr('selected');
    jQuery("#busi_comp_size, #company_state, #busi_industry, #busi_subindustry").next(".nice-select").find('ul li').removeClass("selected focus");
    if (jQuery("#busi_comp_size").next('div.nice-select').hasClass("is-invalid")) {
        jQuery("#busi_comp_size").next('div.nice-select').removeClass('is-invalid');
    }
    jQuery("#busi_comp_size").next('div.nice-select').removeClass('user-success');
    //jQuery("#busi_comp_size").next('div.nice-select').val('');
    jQuery("#busi_comp_size").next(".nice-select").children(".current").text('--Select Company Size--');

    if (jQuery("#busi_industry").next('div.nice-select').hasClass("is-invalid")) {
        jQuery("#busi_industry").next('div.nice-select').removeClass('is-invalid');
    }
    jQuery("#busi_industry").next(".nice-select").children(".current").text('--Select Industry--');
    jQuery("#busi_industry").next('div.nice-select').removeClass('user-success');
    if (jQuery("#busi_subindustry").next('div.nice-select').hasClass("is-invalid")) {
            jQuery("#busi_subindustry").next('div.nice-select').removeClass('is-invalid');
        }
     jQuery("#busi_subindustry").next(".nice-select").children(".current").text('--Select Sub Industry--');
      jQuery("#busi_subindustry").next('div.nice-select').removeClass('user-success');

    //jQuery("#company_state").next('div.nice-select').val('');
    jQuery("#company_website").next('div.nice-select').val('');
    jQuery("#company_address2").next('div.nice-select').val('');
    if (jQuery("#company_name_dnb_plus").hasClass("is-invalid")) {
        jQuery("#company_name_dnb_plus").removeClass('is-invalid');
    }
    jQuery("#company_name_dnb_plus").removeClass('user-success');
    jQuery("#company_name_dnb_plus").next("span").css('display', 'none');
    if (jQuery("#postal_code_dnb_plus").hasClass("is-invalid")) {
        jQuery("#postal_code_dnb_plus").removeClass('is-invalid');
    }
    jQuery("#postal_code_dnb_plus").removeClass('user-success');
    jQuery("#postal_code_dnb_plus").next("span").css('display', 'none');
    if (jQuery("#company_address1").hasClass("is-invalid")) {
        jQuery("#company_address1").removeClass('is-invalid');
    }
    jQuery("#company_address1").removeClass('user-success');
    jQuery("#company_address1").next("span").css('display', 'none');
    if (jQuery("#company_city").hasClass("is-invalid")) {
        jQuery("#company_city").removeClass('is-invalid');
    }
    jQuery("#company_city").removeClass('user-success');
    jQuery("#company_city").next("span").css('display', 'none');
//    if (jQuery("#company_state").next('div.nice-select').hasClass("is-invalid")) {
//        jQuery("#company_state").next('div.nice-select').removeClass('is-invalid');
//    }
    if (jQuery("#busi_country").hasClass("is-invalid")) {
        jQuery("#busi_country").next('div.nice-select').removeClass('is-invalid');
    }
    jQuery("#busi_country").next('div.nice-select').removeClass('user-success');
    if (jQuery('.company_list_table').find('tr.selected').hasClass('selected')) {
        jQuery('.company_list_table').find('[type=checkbox]').prop('checked', false);
        jQuery('.company_list_table').find('tr.selected').removeClass('selected');

    }
    if (jQuery("#step_1 .continue").hasClass('btn-active-ra')) {
        jQuery("#step_1 .continue").removeClass('btn-active-ra');
    }
    }
 jQuery(document).ready(function(){
     setTimeout(function(){

         //after changing position of country and state selected class is going to "Alaska"
         //jQuery("#company_state").next(".nice-select").find('ul li.selected').removeClass("selected");
        // jQuery("#company_state").next(".nice-select").find('ul li:first').addClass('selected');
     }, 1000);
//niceSelect
    jQuery('.wForm select').addClass('nice-select');
    jQuery("select:not('.rs_searchWrapper select, .wForm select, .brand_search select, #company_state')").niceSelect();
    // jQuery('.list').mCustomScrollbar({});
    jQuery('.list .mCSB_draggerContainer').mouseleave(function (e)//not closing options on drag cursor
    {
        jQuery(this).closest('.nice-select').addClass('open');
    });
    //niceSelect
   jQuery('ul.steps a:first').addClass('fill');
   jQuery("div[id^='step_']").hide();
     jQuery('#step_2').show().addClass('active_tab');
     direct_reg_next();
   jQuery("div[id^='empstep_']").hide();
   jQuery('#empstep_1').show().addClass('active_tab');

   jQuery("div[id^='affilatstep_']").hide();
   jQuery('#affilatstep_1').show().addClass('active_tab');


   jQuery("#business-registration_dnb input[name=postal-code-dnb], #business-registration_dnb #company-dnb, #show_advance_section #busi_industry, #show_advance_section #busi_subindustry, #show_advance_section #company_state, #show_advance_section #busi_verizonv").on('keyup blur change', function(e) {
       if ((jQuery("#business-registration_dnb input[name=postal-code-dnb]").val() !== '' && jQuery("#business-registration_dnb input[name=postal-code-dnb]").val().length >= 5) ||
           jQuery("#business-registration_dnb input[name=company-name-dnb]").val() !== '' ||
           jQuery("#show_advance_section #busi_industry").val()!=='' || jQuery("#show_advance_section #busi_subindustry").val() !=='' || jQuery("#show_advance_section #company_state").val()!== '' || jQuery("#show_advance_section #busi_verizonv").val()!== '') {
          //jQuery("#business-registration_dnb #company_dnb_search").addClass('active');
            jQuery(".search_section #company_dnb_search").addClass('active');
     } else {
            jQuery(".search_section #company_dnb_search").removeClass('active');
       return false;
     }
   });

    /*jQuery("#code-dnb").on('keyup', function (e) {
         if(jQuery("#step_1 input[name=postal-code-dnb]").val().length >= 5){
             jQuery(this).addClass('user-success');
           jQuery(this).removeClass('user-error');
         } else {
             jQuery(this).removeClass('user-success');
             jQuery(this).addClass('user-error');
             return false;
         }
     });

   //jQuery('#step_1 .company_list_table > tbody > tr').change(function () {// on selecting company using checkbox
   /*jQuery(document).on('change', 'input.company_select', function(){
       if(jQuery("input.company_select").prop('checked') === true) {
       jQuery("#step_1 .continue").addClass('btn-active-ra');
     }else{
       jQuery("#step_1 .continue").removeClass('btn-active-ra');
       return false;
     }
   });*/
   jQuery("#constep_1 .required-try").on('blur', function(e) {
            var count=jQuery('#constep_1 .is-invalid').length;
       setTimeout(function(){
           var user_error_count=jQuery('#constep_1 .user-error').length;
           if(user_error_count !== 0){
               jQuery("#constep_1 .btn-inactive-ra").removeClass('btn-active-ra');
                jQuery("#constep_1 .btn-inactive-ra").prop("disabled", true);
           }
       }, 100);
            if((jQuery("#constep_1 input[name=fname]").val() !== '' && jQuery("#constep_1 input[name=lname]").val() !== '' && jQuery("#constep_1 input[name=username]").val() !== '' && jQuery("#constep_1 input[name=pw]").val() !== '') && (count === 0)){
              jQuery("#constep_1 .btn-inactive-ra").addClass('btn-active-ra');
              jQuery("#constep_1 .btn-inactive-ra").prop("disabled", false);
            } else if(jQuery("#constep_1 input[name=username]").hasClass('user-error') ||jQuery("#constep_1 input[name=tel]").hasClass('user-error') ){
                 jQuery("#constep_1 .btn-inactive-ra").removeClass('btn-active-ra');
                 jQuery("#constep_1 .btn-inactive-ra").prop("disabled", true);
                 return false;
            }  else {
               jQuery("#constep_1 .btn-inactive-ra").removeClass('btn-active-ra');
               jQuery("#constep_1 .btn-inactive-ra").prop("disabled", true);
              return false;
            }
    });
     jQuery("#empstep_2 .required-try").on('blur', function(e) {
       var count=jQuery('#empstep_2 .is-invalid').length;
         setTimeout(function(){
             var user_error_count=jQuery('#empstep_2 .user-error').length;
             if(user_error_count !== 0){
                 jQuery("#empstep_2 .btn-inactive-ra").removeClass('btn-active-ra');
             }
         }, 100);
       if((jQuery("#empstep_2 input[name=fname]").val() !== '' && jQuery("#empstep_2 input[name=lname]").val() !== '' && jQuery("#empstep_2 input[name=username]").val() !== '' && jQuery("#empstep_2 input[name=pw]").val() !== '') && (count === 0)){
          jQuery("#empstep_2 .btn-inactive-ra").addClass('btn-active-ra');
         } else if(jQuery("#empstep_2 input[name=username]").hasClass('user-error') ||jQuery("#empstep_2 input[name=tel]").hasClass('user-error') ){
                jQuery("#empstep_2 .btn-inactive-ra").removeClass('btn-active-ra');
                return false;
         } else {
          jQuery("#empstep_2 .btn-inactive-ra").removeClass('btn-active-ra');
          return false;
         }
    });
// zipcode pattern check start here
    function check_zipcode() {
        var zipcode = jQuery('#postal_code_dnb_plus').val();
        var zipRegex = /^(\d{5}-\d{4}|\d{5}|\d{9})$|^([a-zA-Z]\d[a-zA-Z]( )?\d[a-zA-Z]\d)$/;
        if (!zipRegex.test(zipcode)) {
            jQuery("#postal_code_dnb_plus").next("span").css('display', 'none');
            return false;
        }
        else {
            jQuery("#postal_code_dnb_plus").next("span").css('display', 'block');
            return true;
        }
    }

    // zipcode pattern check end here
jQuery("#step_2 .required-try").on('keyup blur change', function(e) {
    var minlength = parseInt(jQuery('#postal_code_dnb_plus').attr('minLength'), 10);
    if (jQuery("#step_2 input[name=postal-code]").val().length === minlength) {
        if(jQuery(this).hasClass('is-invalid')){
          jQuery(this).removeClass('is-invalid');
        }
  }
  var count=jQuery('#step_2 .is-invalid').length;
  var zip = check_zipcode();
  if ((jQuery("#step_2 input[name=company-name]").val() !== '' && jQuery('#postal_code_dnb_plus').val().length >= minlength &&
         jQuery("#step_2 input[name=address1]").val() !== '' && jQuery("#step_2 input[name=city]").val() !== '' &&  jQuery("#company_address1").val().indexOf("@") === -1 &&
  jQuery("#step_2 #busi_industry").find(':selected').prop('disabled') === false && jQuery("#step_2 #bus_heard_about").find(':selected').prop('disabled') === false &&
  jQuery("#step_2 #busi_comp_size").find(':selected').prop('disabled') === false && jQuery("#busi_comp_size").next(".nice-select").children(".current").text() !== '--Select Company Size--' &&
  //jQuery("#step_2 #company_state").find(':selected').prop('disabled')  === false && jQuery("#step_2 #company_state option:selected").length > 0 &&  jQuery("#company_state").next(".nice-select").children(".current").text() !== '--Select State/Province--' &&
         jQuery("#company_state").val() !== '' && jQuery("#step_2 #busi_industry").val()  !== '' && jQuery("#step_2 #busi_subindustry").val()  !== '' &&
  jQuery("#step_2 #busi_country option:selected").length > 0) && (count === 0) && zip === true)
  {
      jQuery("#step_2 .btn-inactive-ra").addClass('btn-active-ra');
      jQuery("#step_2 .btn-inactive-ra").prop("disabled", false);
    } else {
      jQuery("#step_2 .btn-inactive-ra").removeClass('btn-active-ra');
      jQuery("#step_2 .btn-inactive-ra").prop("disabled", true);
    return false;
    }
     if(jQuery(".tax_number").css('display') !== 'none')
     {
         if(jQuery('#taxID').val().length !==10){
            jQuery("#step_2 .btn-inactive-ra").removeClass('btn-active-ra');
            jQuery("#step_2 .btn-inactive-ra").prop("disabled", true);
            return false;
        }
     }
 });

   jQuery("#continue_2").click(function(){//to add a class clicking without selecting industry
     if(jQuery("#step_2 #busi_industry").find(':selected').prop('disabled') === true){
      jQuery('#step_2 #busi_industry').addClass('is-invalid');
     }
   });

jQuery("#step_3 .required-try").on('blur', function(e) {
   jQuery("#step_4 .btn-inactive-ra").prop("disabled", true);
  var count=jQuery('#step_3 .is-invalid').length;
    setTimeout(function(){
        var user_error_count=jQuery('#step_3 .user-error').length;
        if(user_error_count !== 0){
            jQuery("#step_3 .btn-inactive-ra").prop("disabled", true);
            jQuery("#step_3 .btn-inactive-ra").removeClass('btn-active-ra');
        }
    }, 100);

  if((jQuery("#step_3 input[name=fname]").val() !== '' && jQuery("#step_3 input[name=lname]").val() !== '' && jQuery("#step_3 input[name=job-title]").val() !== '' && jQuery("#step_3 input[name=username]").val() !== '' && jQuery("#step_3 input[name=tel]").val() !== '' && jQuery("#step_3 input[name=pw]").val() !== '') && (count === 0)){
      jQuery("#step_3 .btn-inactive-ra").addClass('btn-active-ra');
            jQuery("#step_3 .btn-inactive-ra").prop("disabled", false);
    } else if(jQuery("#step_3 input[name=username]").hasClass('user-error') ||jQuery("#step_3 input[name=tel]").hasClass('user-error') ){
            jQuery("#step_3 .btn-inactive-ra").prop("disabled", true);
          jQuery("#step_3 .btn-inactive-ra").removeClass('btn-active-ra');
          return false;
    } else {
      jQuery("#step_3 .btn-inactive-ra").removeClass('btn-active-ra');
            jQuery("#step_3 .btn-inactive-ra").prop("disabled", true);
      return false;
    }
    });


   jQuery('#step_4 .checkbox').change(function() {
       if (jQuery('#step_4 .checkbox:checked').length) {
           jQuery("#step_4 .btn-inactive-ra").prop("disabled", false);
           jQuery("#step_4 .btn-inactive-ra").addClass('btn-active-ra');
       } else {
            jQuery("#step_4 .btn-inactive-ra").prop("disabled", true);
             jQuery("#step_4 .btn-inactive-ra").removeClass('btn-active-ra');
       }
   });
//   jQuery('#none_above').click(function(){
//        jQuery('#step_4 :checkbox[name=interest\\[\\]]').attr('checked', false);
//        jQuery(this).attr('checked', true);
//   });
jQuery('#step_4 :checkbox[name=interest\\[\\]]').change(function() {
      var id=jQuery(this).attr('id');
	  if(id==='none_above'){
	   jQuery('#step_4 :checkbox[name=interest\\[\\]]').attr('checked', false);
	    jQuery(this).attr('checked', true);
	  } else {
	  jQuery('#none_above').attr('checked', false);
	  }

   });
jQuery('#show_all').click(function(){
       if(jQuery('#platinum_brand').is(':hidden'))
       {   jQuery('#platinum_brand').show();
           jQuery('.non_above').appendTo('.platinum_brand').last('.form-group');
       }
       else {jQuery('#platinum_brand').hide();
       jQuery('.non_above').insertBefore('.all_brand');
       }
   });
   jQuery("#business-section .continue").click(function(){
     jQuery(window).scrollTop(0);
     var id=jQuery(this).attr('id');
     var lasttab=jQuery("div[id^='step_']").last().attr('id');
     var showtab=jQuery("div.active_tab").attr('id');
     console.log(lasttab);
     console.log(showtab);
     if(showtab==='step_1'){
       if(jQuery("#company-dnb").val() === ''|| jQuery( "#code-dnb" ).val() === ''|| jQuery( "#code-dnb").hasClass('is-invalid') || jQuery(".company_select").is(":checked") === false){
       return false;
       }
      }
      if(showtab==='step_2'){
         if(jQuery('input[name=company-name]').val() === ''||
             jQuery("#busi_industry").find(':selected').prop('disabled') === true ||
                jQuery("#busi_subindustry").find(':selected').prop('disabled') === true ||
             jQuery("#busi_comp_size").find(':selected').prop('disabled') === true ||
            jQuery("#bus_heard_about").find(':selected').prop('disabled') === true ||
           jQuery('input[name=address1]').val() === ''||
           jQuery('input[name=city]').val() === ''||
           jQuery('select[name=st]').val() === ''||
           jQuery('input[name=postal-code]').val() === ''||
           jQuery('select[name=country]').val() === '')
           {  return false;
           }
      }
      if(lasttab!==showtab)
     {
       jQuery("#" + showtab).hide().removeClass('active_tab');
       jQuery("#" + showtab).next("div").show().addClass('active_tab');
     }else{
       window.location.href = IOT_CONFIG.HOST + '?page_id=846';
     }
   });

   jQuery("#employee-section .continue").click(function(){
     var id=jQuery(this).attr('id');
     var lasttab=jQuery("div[id^='empstep_']").last().attr('id');
     var showtab=jQuery("#employee-section div.active_tab").attr('id');
     if(showtab==='empstep_1'){
         if(jQuery('input[name=passcode]').val() === ''||  jQuery('input[name=passcode]').hasClass('is-invalid')){
            return false;
          }
      }
     if(lasttab!==showtab)
     {
       jQuery('#employee-section .form__msg ul').empty();
       jQuery("#" + showtab).hide().removeClass('active_tab');
       jQuery("#" + showtab).next("div").show().addClass('active_tab');
     }
//     else{
//       window.location.href = IOT_CONFIG.HOST + '?page_id=846';
//     }
   });
   jQuery("#business-section .backdtat").click(function(){
     var showtab=jQuery("div.active_tab").attr('id');
        if (showtab !== 'step_2') {
       jQuery("#" + showtab).hide().removeClass('active_tab');
       jQuery("#" + showtab).prev("div").show().addClass('active_tab');
     } else{
       console.log(showtab);
       window.location.href = IOT_CONFIG.HOST + '?page_id=846';
       //jQuery("#" + showtab).hide().removeClass('active_tab');
       //jQuery("#" + showtab).prev("div").show().addClass('active_tab');
     }

   });
   jQuery("#employee-section .backdtat").click(function(){
     var showtab=jQuery("#employee-section div.active_tab").attr('id');
     if(showtab!=='empstep_1') {
       jQuery("#" + showtab).hide().removeClass('active_tab');
       jQuery("#" + showtab).prev("div").show().addClass('active_tab');
      } else {
        if(jQuery("#" + showtab).hasClass('portal')){
                window.location.href = IOT_CONFIG.PORTAL_HOST + '?page_id=5115';
        }
         else {window.location.href = IOT_CONFIG.HOST + '?page_id=846'; }
      }
    });
    jQuery("#consumer-section .backdtat").click(function(){
        window.location.href = IOT_CONFIG.HOST + '?page_id=846';
   });
   jQuery('.inner_box').click(function(e) {
    // e.stopPropagation();
    // e.stopImmediatePropagation();
       jQuery(this).find('input[type="radio"]').prop("checked", true).triggerHandler("click");
       jQuery('#main_join_now_box').hide();
    });

   /*jQuery(document).on("change", "input.company_select" , function() {//restricting to check only one checkbox
         jQuery('input.company_select').not(this).prop('checked', false);
   });*/

   /*jQuery('#step_1 .company_list_table > tbody > tr').click(function () {// on selecting company using checkbox
     jQuery(this).find(".company_select").trigger('click');
   });*/

   jQuery(document).on('click', '#registration .company_list_table tr', function(event){
       jQuery('tr').removeClass('selected');
       if (event.target.type !== 'checkbox') {
           jQuery('input.company_select').not(this).prop('checked', false);
       jQuery(':checkbox', this).trigger('click');
         if(jQuery(':checkbox', this).prop('checked') === true) {
           jQuery(this).closest('tr').addClass('selected');
           jQuery("#step_1 .continue").addClass('btn-active-ra');
         }else{
           jQuery("#step_1 .continue").removeClass('btn-active-ra');
           return false;
         }
     }
   });
   jQuery('#company_dnb_search').click(function () {// restricting when there is no data in search fields
         if (jQuery(this).hasClass('active')) {
            // jQuery("#step_1 .continue").removeClass('btn-active-ra');
             getData();
         } else {
             return false;
         }
     });

   jQuery('select').change(function () {//to change to select option color
     jQuery(this).css('color', '#0a2c3b');
   });

   jQuery('#continue_1').click(function(){//on changing color pre polulating data
     jQuery('select option:selected').each(function() {
       if (jQuery(this).parent().prop('id') !== 'busi_country') {
         if (jQuery(this).index() !== 0) {
           jQuery(this).parent().css('color', '#0a2c3b');
         } else {
           jQuery(this).parent().css('color', '#c2cace');
         }
       }else{
         jQuery(this).parent().css('color', '#0a2c3b');
       }
     });
        //start set industry to Select Industry when click on back button
        //jQuery("#step_2 #busi_industry").next(".nice-select").children(".current").text('--Select Industry--');
        //end
        // if country is canada zip code min length is 7
        var minlength = jQuery('#postal_code_dnb_plus').attr('minLength');
     jQuery("#company_name_dnb_plus").addClass('user-success padding-right-ontickmark');
     jQuery("#company_name_dnb_plus").next("span").css('display','block');
      var postal_code = check_zipcode();
     if (jQuery('#postal_code_dnb_plus').val().length >= minlength && postal_code === true) {
       jQuery("#postal_code_dnb_plus").removeClass('is-invalid user-error').addClass('user-success');
       jQuery("#postal_code_dnb_plus").next("span").css('display', 'block');
     }else{
       jQuery("#postal_code_dnb_plus").next("span").css('display', 'none');
       jQuery("#postal_code_dnb_plus").addClass('is-invalid');
     }
     jQuery("#company_address1").addClass('user-success padding-right-ontickmark');
     jQuery("#company_address1").next("span").css('display','block');
     jQuery("#company_city").addClass('user-success');
     jQuery("#company_city").next("span").css('display','block');
     if(jQuery("#busi_comp_size").next(".nice-select").children(".current").text() !== '--Select Company Size--') {
       jQuery("#busi_comp_size").next('div.nice-select').removeClass('is-invalid').addClass('user-success');
     }else{
       jQuery("#busi_comp_size").next('div.nice-select').addClass('is-invalid');
     }
        jQuery("#empCount").addClass('user-success ');
    if(jQuery("#bus_heard_about").next(".nice-select").children(".current").text() !== '--Select--') {
        jQuery("#bus_heard_about").next('div.nice-select').removeClass('is-invalid').addClass('user-success');
      }else{
        jQuery("#bus_heard_about").next('div.nice-select').addClass('is-invalid');
    }
        if (jQuery("#company_state").val()!== '') {
            jQuery("#company_state").next('.nice-select').removeClass('is-invalid').addClass('user-success');
     }else{
            jQuery("#company_state").next('.nice-select').addClass('is-invalid');
     }
     jQuery("#busi_country").next('div.nice-select').addClass('user-success');
        if (jQuery("#busi_industry").next(".nice-select").children(".current").text() !== '--Select Industry--' || jQuery("#busi_industry").val()!== '') {
       jQuery("#busi_industry").next('div.nice-select').removeClass('is-invalid').addClass('user-success');
     }else{
       jQuery("#busi_industry").next('div.nice-select').addClass('is-invalid');
     }

        if (jQuery("#busi_subindustry").next(".nice-select").children(".current").text() !== '--Select Sub Industry--' || jQuery("#busi_subindustry").val()!== '') {
                    jQuery("#busi_subindustry").next('div.nice-select').removeClass('is-invalid').addClass('user-success');
                } else {
                    jQuery("#busi_subindustry").next('div.nice-select').addClass('is-invalid');
                }
		 var count_err = jQuery('#step_2 .is-invalid').length;
        if(count_err === 0){
            jQuery("#step_2 .btn-inactive-ra").addClass('btn-active-ra');
            jQuery("#step_2 .btn-inactive-ra").prop("disabled", true);
        }else{
            jQuery("#step_2 .btn-inactive-ra").removeClass('btn-active-ra');
            jQuery("#step_2 .btn-inactive-ra").prop("disabled", false);
        }
   });

   jQuery('#step_1').keydown(function(event){ //to restrict form submit and search results
     if(event.keyCode === 13) {
       console.log('yes');
       jQuery(".active_tab").find("[data-button='submit']").click();
       event.preventDefault();
       return false;
     }
   });

   var getUrlParameter = function getUrlParameter(sParam) { //get url parameters for search
     var sPageURL = window.location.search.substring(1),
         sURLVariables = sPageURL.split('&'),
         sParameterName,
         i;

     for (i = 0; i < sURLVariables.length; i++) {
       sParameterName = sURLVariables[i].split('=');

       if (sParameterName[0] === sParam) {
         return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
       }
     }
   };

   //script for search page
   jQuery('#filter_search').on('change', function() { //filter search results in search page
     jQuery("#loader").show();
     var filter_search_value = jQuery(this).val();
     sessionStorage.setItem('filter_vale', filter_search_value);
     var search_tag = getUrlParameter('s');
     window.location = IOT_CONFIG.HOST +'?s='+search_tag+'&'+filter_search_value;
   });

   //script for search page
   jQuery('#magnifier_search , #magnifier_search_custom').on('click', function() { //filter search results in search page
     jQuery("#loader").show();
	 jQuery("#loader").addClass('search-loader');
   });

   jQuery("#filter_search").val(sessionStorage.getItem('filter_vale'));
   sessionStorage.removeItem('filter_vale');

   jQuery( "#filter_search" ).on('focusout',function() {
     jQuery(this).css( 'border', '1px solid #c2cace');
   });

   /*var page_no = getUrlParameter('paged');
   if(page_no >= 1) {
     jQuery('.custom_arrow').css('display', 'none');
   }*/
     var url = window.location.pathname;
     url = url.split("page");
     if(url[1] != null) {
         var page_no = url[1].replace(/\//g, '');
         if (page_no >= 1) {
             jQuery('.custom_arrow').css('display', 'none');
         }
     }
   //script for search page ends


      jQuery(document).on("click",".nice-select", function() {//for adding check mark in registration
//        jQuery("#busi_comp_size").next(".nice-select").find('ul li.focus').removeClass("selected focus");
//        var company_busi_size = jQuery("#busi_comp_size option:selected").text();
//        jQuery("#busi_comp_size").next(".nice-select").find("ul li:contains('" + company_busi_size + "')").addClass("selected focus");
//        jQuery("#company_state").next(".nice-select").find('ul li.focus').removeClass("selected focus");
//        var company_state = jQuery("#company_state option:selected").text();
//        jQuery("#company_state").next(".nice-select").find("ul li:contains('" + company_state + "')").addClass("selected focus");
//
//        jQuery("#busi_industry").next(".nice-select").find('ul li.focus').removeClass("selected focus");
//        var indusrty = jQuery("#busi_industry option:selected").text();
//        jQuery("#busi_industry").next(".nice-select").find("ul li:contains('" + indusrty + "')").addClass("selected focus");
    });


jQuery(document).on("click",".nice-select ul li", function() {//new dropdown ul li validation
     if (jQuery(this).is(':not(:first-child)'))
     {
       jQuery(this).closest('.nice-select').removeClass('user-error is-invalid').addClass('user-success');
     }
   });
    //for moving cookie bar div to above header
     jQuery('.header').before(jQuery("#cookie-law-info-bar"));
     jQuery('.header').before(jQuery("#cookie-law-info-again"));

     jQuery(document).on('click', '.company_pagination a.page-numbers', function(e){ //script for pagination increment and decrement in company search
         var pagelength;

         if(jQuery(this).has( "span.page_increment" )){
             pagelength = jQuery(this).has("span.page_increment").text();
         }
         if(jQuery(this).has("span.page_decrement")){
             pagelength = jQuery(this).has("span.page_decrement").text();
         }
         pagelength = jQuery(e.target).text();
         if(jQuery("#step_1 .continue").hasClass('btn-active-ra')) {
             jQuery("#step_1 .continue").removeClass('btn-active-ra');
         }
         console.log(pagelength);
         getData(pagelength);
     });

 });//document ready ends


function dnb_data(name, postal, address, city, state, company_size,country,industry1) {
   var size;
  var option_count = 0;
  jQuery("#busi_comp_size option").each(function() //for selecting company size
  {
    var option = this.value.split(" ");
    var min = option[0];
    var max = option[2];
    if(min !== undefined && max !== undefined) {
      if( parseInt(min) < parseInt(company_size) &&  parseInt(company_size) < parseInt(max)){
         size =  option_count;
          return false;
      }
    }
    option_count++;
  });
  jQuery('#step_1 #continue_1').removeAttr("disabled");
  //jQuery('#step_1 #continue_1').addClass('btn-active-ra');
  var addr = address.replace(/%/g, " ");
  var com_name = name.replace(/%/g, " ");
    var city_name = city.replace(/%/g, " ");
    var com_size= company_size.replace(/%/g, " ");
    var industry = industry1.replace(/%/g, " ");
  jQuery("#company_name_dnb_plus").val(com_name);
    //jQuery("#postal_code_dnb_plus").val(postal.replace(/[^a-z0-9\s]/gi, ''));
  jQuery("#postal_code_dnb_plus").val(postal.replace(/[/\\#,+()$~%.'":*?<>{}\s]/gi, ' '));
  jQuery("#company_address1").val(addr);
  jQuery("#company_city").val(city_name);
    //jQuery('#busi_comp_size option:eq(' + size + ')').attr('selected', 'selected');

    jQuery('#busi_country option[value=' + country + ']').attr('selected', 'selected');
    jQuery("#busi_country").next(".nice-select").children(".current").text(jQuery("#busi_country option:selected").text());

    if(country === 'CA'){
        jQuery('#postal_code_dnb_plus').attr('minlength', 7);
        jQuery('#postal_code_dnb_plus').attr('maxlength', 10);
    }else{
        jQuery('#postal_code_dnb_plus').attr('minlength', 5);
        jQuery('#postal_code_dnb_plus').attr('maxlength', 5);
    }
    if(state === '') {
        jQuery("#company_state").next(".nice-select").children(".current").text('--Select State/Province--');
        jQuery('.comman-reg #company_state').next().addClass('is-invalid');
    }else{
        jQuery('#busi_country').trigger('change');
        jQuery('#company_state option[value='+ state +']').attr('selected','selected');
        jQuery("#company_state").next(".nice-select").children(".current").text(jQuery("#company_state option:selected").text());


    }
     jQuery("#busi_industry, #busi_comp_size, #busi_subindustry").next(".nice-select").find(" li").removeClass('selected focus');
     jQuery("#busi_comp_size ").find("option[value='"+com_size+"']").attr('selected', 'selected');
  jQuery("#busi_comp_size").next(".nice-select").children(".current").text(jQuery("#busi_comp_size option:selected").text());

     jQuery("#busi_industry ").find("option[value='"+industry+"']").attr('selected', 'selected');
    // jQuery("#busi_industry").next(".nice-select").children(".current").text('--Select State/Province--');
     jQuery("#busi_industry").next(".nice-select").children(".current").text(jQuery("#busi_industry option:selected").text());
     jQuery("#busi_subindustry").next(".nice-select").children(".current").text(jQuery("#busi_subindustry option:selected").text());

}

function show_login_popup(){
jQuery("#login_main_button").trigger('click');
}
function scrollToField() {
    jQuery('html, body').animate({
            scrollTop: jQuery("#association-registration").offset().top-200
    }, 1000);
    jQuery('.comman-reg input[name=fname]').focus();
}
function scrollToForm() {
            jQuery('html, body').animate({
                    scrollTop: jQuery(".become_affiliate_form").offset().top-200
            }, 1000);
            jQuery('.form-container input[name=fname]').focus();
}

function show_forgot_popup() {
   jQuery('#login_main_button').trigger('click');
   jQuery('.redirect_forgotpassword').trigger('click');
}
function onlyAlphabets(e, t) {
  var inputValue = e.charCode;
 if (!(inputValue >= 65 && inputValue <= 122)   && (inputValue !== 32 && inputValue !== 0 && inputValue !== 45 && inputValue !== 39 && inputValue !== 126 &&
      inputValue !== 252 && inputValue !== 228 && inputValue !== 235 && inputValue !== 239 && inputValue !== 196 &&
      inputValue !== 246 && inputValue !== 214 && inputValue !== 220 && inputValue !== 203 && inputValue !== 207 )) {
         e.preventDefault();
   }
    if(inputValue ===  91 || inputValue ===  93 || inputValue ===  94 ){
      e.preventDefault();
     }
}
jQuery('.paste_alpha').bind('paste',function(e){
var clipdata=window.clipboardData || e.originalEvent.clipboardData;
var text=clipdata.getData('text');
for(var i=0;i<text.length;i++){
var inputValue=text.charCodeAt(i);
console.log(inputValue);
if (!(inputValue >= 65 && inputValue <= 122)   && (inputValue !== 32 && inputValue !== 0 && inputValue !== 45 && inputValue !== 39 && inputValue !== 126 &&
     inputValue !== 252 && inputValue !== 228 && inputValue !== 235 && inputValue !== 239 && inputValue !== 196 &&
     inputValue !== 246 && inputValue !== 214 && inputValue !== 220 && inputValue !== 203 && inputValue !== 207 )) {
       e.preventDefault();
  }
   if(inputValue ===  91 || inputValue ===  93 || inputValue ===  94 ){
     e.preventDefault();
    }
}
});
jQuery("#company_address1").keypress(function (e) {
  if(e.keyCode===64){return false;}
});
function isNumber(evt) {
  evt = (evt) ? evt : window.event;
  var charCode = (evt.which) ? evt.which : evt.keyCode;
  if (charCode > 31 && (charCode < 48 || charCode > 57)) {
    return false;
  }
  return true;
}
jQuery("#acountdiscount").click(function(){
 jQuery('.offer_redemption_main').css('display','block');
 jQuery('#offer_redemption_thanks').css('display','none');
});


function copycodeFunction(e) {
  var copyinput = document.createElement("input");
  copyinput.setAttribute("type","text");
  copyinput.setAttribute("id","myInput");
  copyinput.setAttribute("value",e);
  document.body.appendChild(copyinput);
  var copyText = document.getElementById("myInput");
  copyText.select();
  document.execCommand("copy");
  document.getElementById("myInput").style.display = "none";
  jQuery('#copycodebtn').addClass('active-bg');
  document.getElementById('copycodebtn').title = 'Copied' + " : " + copyText.value;
}

function mypasswordFunction() {
  var count = document.getElementsByClassName('is-invalid').length;
  var emailname = document.getElementById("emailid").value;
  var userpaa = document.getElementById("password_type").value;
  if(emailname !== "" && userpaa !== "" && count === 0)
  {
    document.getElementById("chncolract").classList.add('btn-active-ra');
    jQuery('#chncolract').removeAttr("disabled");

  }
  else{
    document.getElementById("chncolract").classList.remove('btn-active-ra');
     jQuery('#chncolract').attr('disabled', true);
    return false;

  }
}
//code for menu dragable
jQuery(document).ready(function(e) {
if (jQuery('body').hasClass('single-offer')) {
   var dragMenu = jQuery('.dragMenu');
	$('.dragMenu').draggable({
	  axis: "x",
	  containment: 'dragMenu'
	});

	var dragMenuWidth = 0;
	jQuery('.dragMenu li').each(function(index) {
		dragMenuWidth += parseInt(jQuery(this).outerWidth());

	});

	dragMenu.on( "drag", function( event, ui ) {
		//var child_count = jQuery('.dragMenu li').length
	  if (ui.offset.left >= 3) {
		ui.position.left = 3;
		 var scrollTo  = 0;
        $('ul.dragMenu ').css('transform', 'translateX(' + scrollTo + 'px)');
	  }


//      if ($(window).width() < 600 ) {
	  if (ui.offset.left < 3) {
         ui.position.left = '-' + jQuery('ul.dragMenu li:last-child ').outerWidth()/1.5;
          console.log();

	  }
    //  }



	});
 }

});

jQuery(document).ready(function () {
    if(jQuery('.association_page').length > 0)
              { jQuery('.asso_spec').hide(); }
            else { jQuery('.association_menu').hide();
            jQuery('.mobilemenu_login.asso_spec').hide();
            jQuery('.mobilemenu_login.all_login').show();
    }
 jQuery('.dragMenu li').on('click', function (e) {
	 var scrollTo  = 0;
        jQuery('ul.dragMenu ').css('transform', 'translateX(0)');
        //jQuery('ul.dragMenu ').css('left', '0');

		if (jQuery(this).is(':last-child')) {
			var a = jQuery(this).outerWidth();
			var b = jQuery(this).innerWidth();
			var result = a - b;
	 		scrollTo  = result;
            if (jQuery(window).width() < 767) {
        	jQuery('ul.dragMenu ').css('transform', 'translateX(-' + scrollTo + 'px)');
			}
			else{
				jQuery('ul.dragMenu ').css('transform', 'translateX(0)');
			}
		}
    });
});

//code for navigation feature start
jQuery(document).ready(function(){
	jQuery("#backto-menu, #accountnav-small, #loader, .offcanvas .sub-menu").hide();

	if (jQuery("#cookie-law-info-bar").css("display") === "block") {
		jQuery("._search").addClass("topspace");
		jQuery("#cookie-law-info-bar").removeClass("cookie-closed");
        jQuery('#banner').attr('style', 'top: 60px !important');
	}
	else {
		jQuery("._search").removeClass("topspace");
		jQuery("#cookie-law-info-bar").addClass("cookie-closed");
        jQuery('#banner').attr('style', 'top: 0px !important');
	}

	//on cookie close searchpanel at top
	jQuery("#cookie_action_close_header").click(function(){
		jQuery("._search").removeClass("topspace");
		jQuery("#cookie-law-info-bar").addClass("cookie-closed");
        jQuery('#banner').attr('style', 'top: 0px !important');
	});
	
	//open desktop search
	jQuery(".banner__search").click(function(){
		jQuery("._search").show();
		//jQuery("._search").animate({top: "-96px"}, 3000);
	});

	//close desktop search
	jQuery(".search-close").click(function(e){
		jQuery("._search").hide();
		e.stopPropagation();
	});

    //open toggle desktop account nav
    jQuery(".accountnav-container").hover(function(){
        jQuery(".accountnav-container").toggleClass("is-active");
    });
  
	//on login mobile loader
	//It affects registration flow loader sho commented by Krishna
//  jQuery(".btn-inactive-ra").click(function(){
//	jQuery("#loader").addClass('white-loader');
//	jQuery("#loader").show();
////	setTimeout(function(){
////		jQuery("#loader").hide();
////	}, 500);
//  });

  //open Submenu and close all open panels
  jQuery(".offcanvas .menu__header a").click(function(event){
	jQuery("#not-loggedin, #loggedin, #accountnav-small, .offcanvas .sub-menu").hide();
	jQuery("#loader").show();
	setTimeout(function(){
		jQuery("#loader").hide();
            //jQuery("#backto-menu, .offcanvas .sub-menu").show();
            jQuery("#backto-menu").show();
            jQuery(event.target).parent().next('.sub-menu').show();
	}, 500);
  });
  
  //open mobile search panel
  jQuery("#open-msearch").click(function(){
	jQuery("#loader").show();
	jQuery("#not-loggedin, #loggedin, #accountnav-small").hide();
	setTimeout(function(){
		jQuery("#loader").hide();
		jQuery("#backto-menu").show();
		jQuery(".mobile-search").addClass("open");
	}, 500);
  });
  
  //on mobile search while redirecting to search listing show loader
  jQuery(".msearch").click(function(){
	  jQuery("#loader").show();
	setTimeout(function(){
		jQuery("#loader").hide();
		jQuery(".offcanvas").css("opacity", 0);
	}, 10000);
  });

  //open user settings panel and close all open panels
  jQuery("#user-settings, #loggedin").click(function(){
	jQuery("#not-loggedin, #loggedin, #hideall, .offcanvas .sub-menu").hide();
	jQuery("#loader").show();
	setTimeout(function(){
		jQuery("#loader").hide();
		jQuery(".mobile-search").removeClass("open");
		jQuery("#backto-menu, #accountnav-small").show();
	}, 500);
  });

  //close all panels and back to main menu
  jQuery("#backto-menu, #close-msearch, #menuclose").click(function(){
	jQuery("#loader, #backto-menu, #accountnav-small, .offcanvas .sub-menu").hide();
	jQuery(".mobile-search").removeClass("open");
	jQuery("#not-loggedin, #loggedin, #hideall").show();
        if(jQuery('.association_page').length > 0)
          { jQuery('.asso_spec').hide(); }
        else { jQuery('.association_menu').hide();
        jQuery('.mobilemenu_login.asso_spec').hide();
        jQuery('.mobilemenu_login.all_login').show();
        }
  });
  
  	//on mobilemenu login click close mobile menu
	jQuery(".mobilemenu_login").click(function(){
		jQuery(".offcanvas").removeClass("is-active");
	});
	jQuery(".banner__menu").click(function(){
		jQuery(".offcanvas").addClass("is-active");
	});
	
  //login popup conflict resovle with sticky header
  jQuery("#login_main_button, #not-loggedin").click( function() {
    jQuery('._modal-container').removeClass('hidden');
    jQuery('.forgot_div').hide();
    jQuery('.login_div').show();
	jQuery("body").addClass("modal-open");
  });

	jQuery("._modal__close").click( function() {
		jQuery("body").removeClass("modal-open");
		jQuery("._modal").addClass('zoomOut');
		setTimeout(function(){
			jQuery('._modal-container').addClass('hidden');
			jQuery("._modal").removeClass('zoomOut');
		}, 300);
    jQuery("#login-modal").removeClass("mb_hamburger_login");
	});

function afterCss_forgot_div(){
	jQuery('.forgot_div').fadeIn();
	setTimeout(function(){
		jQuery('.login__text-container').show();
	}, 500);
}
	jQuery('._modal__inner').addClass('sec-login-active');
	jQuery(".redirect_forgotpassword").click( function() {
		jQuery('.login_div').hide();
		jQuery('._modal__inner').addClass('sec-forget-active');
		jQuery('._modal__inner').removeClass('sec-login-active');
		//This will execute after 1 seconds
		jQuery('.login__text-container').hide();
		setTimeout(afterCss_forgot_div, 300);
	});
	jQuery(".portal_forgotpassword").click( function() {
    		jQuery('.login_div').hide();
    		jQuery('.forgot_div').show();
    });
    jQuery(".login__text_portal").click( function() {
    	jQuery('.forgot_div').hide();
    	jQuery('.login_div').show();

    });
function afterCss_login_div(){
	jQuery('.login_div').fadeIn();
}
jQuery(".login__text").click( function() {
	jQuery('.forgot_div').hide();
	jQuery('._modal__inner').removeClass('sec-forget-active');
	jQuery('._modal__inner').addClass('sec-login-active');
		//This will execute after 1 seconds
	setTimeout(afterCss_login_div, 300);
});
});

jQuery('.close-model').click(function() {
	var modelId = this.attr('attr-id');
	jQuery( modelId + " .modal-dialog").addClass('zoomOut');
	setTimeout(function(){
		if( !$(this).attr("data-dismiss") ) {
			$(this).attr("data-dismiss", "modal");
			$(this).trigger('click');
		}
		else{
			$(this).removeAttr("data-dismiss");
		}
			jQuery( modelId + " .modal-dialog").removeClass('zoomOut');
	}, 300);
});

//Sticky Header
var header = document.getElementById("banner");
var sticky = header.offsetTop;

window.onscroll = function stickyHeader() {
  if (window.pageYOffset > sticky) {
    header.classList.add("sticky");
	jQuery('#cookie-law-info-bar').addClass('cookiesticky');
  }
   else {
    header.classList.remove("sticky");
	jQuery('#cookie-law-info-bar').removeClass('cookiesticky');
  }
};

// offer redimtion close and open animation.
function modalZoom(x) {
    jQuery('.modal .modal-dialog').attr('class', 'modal-dialog  ' + x + '  animated');
}

jQuery('#myModal').on('show.bs.modal', function (e) {
      modalZoom('zoomIn');
});
jQuery('#myModal').on('hide.bs.modal', function (e) {
      modalZoom('zoomOut');
});

//crawl error fixes.
    jQuery(document).ready(function(){
    jQuery("._pagination a[href*='/page/1/']").each(function () {
               var oldurl = jQuery(this).attr("href");
               var newurl = oldurl.replace(/\/page\/1/g, "");
                jQuery(this).attr("href", newurl);

            });
        });

// coupon code

jQuery('.apply_coupon_custom input').on('click', function (e) {
      var text= jQuery(this).val();
     // jQuery('#show_coupon_msg').text('');
      jQuery(this).attr('id', 'myInput');
       var copyText = document.getElementById("myInput");
      copyText.select();
      copyText.focus();
      document.execCommand('copy');
      jQuery(this).addClass('active-bg').attr('title', 'Copied: '+text);
      //jQuery('#show_coupon_msg').text('Code is copied.');
      return false;
    });

// in which pagse this function used ,1.Express Registration  2.Complete Account 3.migration

function OnFocusPasswordTooltipHideShow()
{
  jQuery('#password_type').focus(function()
   {
     jQuery('.input-icon-tooltip').css({"display":"block","opacity":"1"});
   });

 }

 function OnBlurPasswordTooltipHideShow()
 {
    jQuery('#password_type').blur(function()
    {
       jQuery('.input-icon-tooltip').css({"display":"none"});
    });
 }

// sendgrid

jQuery('#reminder_sucess_message').css('display','none');
jQuery('.portal-email').click(function(){
  jQuery('#reminder_message').css('display','none');
});
jQuery('.sendgrid').click(function() {
  var isChecked = jQuery('.portal-email').is(':checked');
  console.log(isChecked);
  if(isChecked !== false){
     jQuery('#myModal').modal('show');
     jQuery('#offer_redemption_thanks, #offer_redemption_thanks_1, #offer_redemption_main_1').css('display','none');
     jQuery('#offer_redemption_main').css('display','block');
     jQuery("#modal-btn-no").off('click').on("click", function(){
         jQuery('#myModal').modal('hide');
         jQuery('.portal-email').prop("checked", false);
      });
   jQuery("#modal-btn-si").off('click').on("click", function(){
   jQuery('#myModal').modal('hide');
  jQuery(".company_list_table input[type=radio]:checked").each(function () {
    var row = jQuery(this).closest("tr")[0];
    var name  = row.cells[1].innerHTML;
            name=name.split("</div>").pop();
    var email_txt  = row.cells[2].innerHTML;
            email_txt=email_txt.split("</div>").pop();
    //console.log(ss);
    var login_user = jQuery('#login_user').val();
    var account_name = jQuery('#account_name').val();
    var member_id = jQuery('#member_id').val();
    var values="login_user="+login_user+"&account_name="+account_name+"&member_id="+member_id+"&contact_name="+name+"&email="+email_txt+"&portal_mail_registration=";
    jQuery.ajax({
      url: IOT_CONFIG.PORTAL_HOST + "/app/themes/sage/lib/sendgrid.php",
     // url:"https://testportal.mynpp.com/app/themes/sage/lib/sendgrid.php",
      type: "POST",
      dataType: 'text',
      data: values, // serializes the form's elements.
      success: function(response) {
        //alert(response);
        console.log(response);
        jQuery('#myModal').modal('show');
        jQuery('#offer_redemption_main, #offer_redemption_thanks_1, #offer_redemption_main_1').css('display','none');
        jQuery('#offer_redemption_thanks').css('display','block');
        jQuery('.portal-email').prop("checked", false);
        return response;
      },
      error: function() {
        //alert('ajax error');
        console.log('ajax error');
      }
    });
   }); });
  }else{
    jQuery('#reminder_message').css('display','block');
  }
});

jQuery('.portal-registration-mail').click(function() {
  var isChecked = jQuery('.portal-email').is(':checked');
  console.log(isChecked);
  if(isChecked !== false){
     jQuery('#myModal').modal('show');
     jQuery('#offer_redemption_thanks_1,#offer_redemption_thanks, #offer_redemption_main').css('display','none');
     jQuery('#offer_redemption_main_1').css('display','block');
     jQuery("#modal-btn-no_1").off('click').on("click", function(){
         jQuery('#myModal').modal('hide');
         jQuery('.portal-email').prop("checked", false);
      });
    jQuery("#modal-btn-si_1").off('click').on("click", function(){
     jQuery('#myModal').modal('hide');
    jQuery(".company_list_table input[type=radio]:checked").each(function () {
      var row = jQuery(this).closest("tr")[0];
      var name  = row.cells[1].innerHTML;
      var email_txt  = jQuery.trim(row.cells[2].innerHTML);
            name=name.split("</div>").pop();
            email_txt=email_txt.split("</div>").pop();

      var contactToken  = row.cells[5].innerHTML;
            contactToken = contactToken.split("</div>").pop();
      //console.log(ss);
      var login_user = jQuery('#login_user').val();
      var account_name = jQuery('#account_name').val();
      var member_id = jQuery('#member_id').val();
     // var contactToken = ;
      var values="portal_mail_registration=portal_mail_registration&login_user="+login_user+"&contact_name="+name+"&email="+email_txt+"&contactToken="+contactToken;

      jQuery.ajax({
        url: IOT_CONFIG.PORTAL_HOST + "/app/themes/sage/lib/sendgrid.php",
        // url:"https://testportal.mynpp.com/app/themes/sage/lib/sendgrid.php",
        type: "POST",
        dataType: 'text',
        data: values, // serializes the form's elements.
        success: function(response) {
          //alert(response);
          console.log(response);
        jQuery('#myModal').modal('show');
        jQuery('#offer_redemption_main_1, #offer_redemption_thanks, #offer_redemption_main').css('display','none');
        jQuery('#offer_redemption_thanks_1').css('display','block');
        jQuery('.portal-email').prop("checked", false);
          return response;
        },
        error: function() {
          //alert('ajax error');
          console.log('ajax error');
        }
      });
        }); });
  }else{
    jQuery('#reminder_message').css('display','block');
  }
});

//This block is for lead search page
jQuery('.sendgrid_lead_search').click(function () {
    var isChecked = jQuery('.lead-email').is(':checked');
    console.log(isChecked);
    if (isChecked !== false) {
        jQuery('#reminder_message').css('display', 'none');
         jQuery('#myModalmulti').modal('hide');
        jQuery('#myModal').modal('show');
        jQuery('#offer_redemption_thanks').css('display','none');
        var accountOwner = jQuery('#get_account_owner_email').val();
        var accountOwnerName = jQuery('#get_account_owner_name').val();
        var login_user_email = jQuery('#lead_login_user').val();
        jQuery('#offer_redemption_main').css('display','block');
        jQuery("#modal-btn-no").off('click').on("click", function(){
            jQuery('#myModal').modal('hide');
            jQuery('.lead-email').prop("checked", false);
        });
        jQuery("#modal-btn-si").off('click').on("click", function(){
            jQuery('#myModal').modal('hide');
            var table = jQuery('#company_list_table').DataTable();
                            table.$('input[name=send-email]').each(function(){
                                if(this.checked){
                                    jQuery('#lead_result').append(
                                     jQuery('<input>')
                                        .attr('type', 'hidden')
                                        .attr('name', 'selectedAcc')
                                        .val(this.value)
                                  );
                               }
                         });
                   var valuesArray =  jQuery.map(jQuery('input[name=selectedAcc]'), function (n, i) {
                  return n.value;
                 }).join(',');

            var rep_name=jQuery('#rep_name').val();
            //var values = "rep_name="+rep_name+"&login_user=" + login_user_email + "&contact_name=" + accountOwnerName + "&email=" + accountOwner + "&data="+ JSON.stringify(mainArray) +  "&lead_search=true";
            var values = "rep_name="+rep_name+"&data="+ valuesArray +  "&lead_search=true";
            jQuery.ajax({
                url: IOT_CONFIG.PORTAL_HOST + "/app/themes/sage/lib/leadSearch.php",
                type: "POST",
                dataType: 'text',
                data: values, // serializes the form's elements.
                success: function (response) {
                    //alert(response);
                    console.log(response);
                    jQuery('#myModal').modal('show');
                    jQuery('#offer_redemption_main').css('display','none');
                    jQuery('#offer_redemption_thanks').css('display','block');
                    jQuery('.lead-email').prop("checked", false);
                    jQuery('input[name=selectedAcc]').remove();
                    return response;
                },
                error: function () {
                    //alert('ajax error');
                    console.log('ajax error');
                }
            });
            return false;
        });
    } else {
        jQuery('#reminder_message').css('display', 'block');
    }
});


//affilate
jQuery("#regpasscodeinfo #continue_affilate").click(function(){
        jQuery("#affilatstep_1").hide().removeClass('active_tab');
        jQuery("#affilatstep_1").next("div").show().addClass('active_tab');
 });
jQuery("#affiliate-section .continue").click(function(){
   jQuery(window).scrollTop(0);
   var id=jQuery(this).attr('id');
   var lasttab=jQuery("div[id^='affilatstep_']").last().attr('id');
   var showtab=jQuery("#affiliate-section div.active_tab").attr('id');

  if(showtab==='affilatstep_1'){
      if(jQuery('#affiliate-section input[name=passcode]').val() === ''||  jQuery('#affiliate-section input[name=passcode]').hasClass('is-invalid')){
         return false;
       }
   }

  if(lasttab!==showtab)
  {
    jQuery('#affiliate-section .form__msg ul').empty();
    jQuery("#" + showtab).hide().removeClass('active_tab');
    jQuery("#" + showtab).next("div").show().addClass('active_tab');
  }
});
jQuery("#affiliate-section .backdtat").click(function(){
   var showtab=jQuery("#affiliate-section div.active_tab").attr('id');
   if(showtab!=='affilatstep_1') {
     jQuery("#" + showtab).hide().removeClass('active_tab');
     jQuery("#" + showtab).prev("div").show().addClass('active_tab');
    } else {
       window.location.href = IOT_CONFIG.PORTAL_HOST + '?page_id=5115';
    }
});
jQuery("#affilatstep_2 .required-try").on('blur', function(e) {
 var count=jQuery('#affilatstep_2 .is-invalid').length;
   setTimeout(function(){
       var user_error_count=jQuery('#affilatstep_2 .user-error').length;
       if(user_error_count !== 0){
           jQuery("#affilatstep_2 .btn-inactive-ra").removeClass('btn-active-ra').prop("disabled", true);
       }
   }, 100);
 if((jQuery("#affilatstep_2 input[name=fname]").val() !== '' && jQuery("#affilatstep_2 input[name=lname]").val() !== '' && jQuery("#affilatstep_2 input[name=username]").val() !== '' && jQuery("#affilatstep_2 input[name=pw]").val() !== '' ) && (count === 0)){
   jQuery("#affilatstep_2 .btn-inactive-ra").addClass('btn-active-ra').prop("disabled", false);
   } else if(jQuery("#affilatstep_2 input[name=username]").hasClass('user-error') ||jQuery("#affilatstep_2 input[name=tel]").hasClass('user-error') ){
         jQuery("#affilatstep_2 .btn-inactive-ra").removeClass('btn-active-ra').prop("disabled", true);
          return false;
   } else {
    jQuery("#affilatstep_2 .btn-inactive-ra").removeClass('btn-active-ra').prop("disabled", true);
    return false;
   }
});
jQuery("#term-condition").click(function(){
      if(jQuery(this).is(':checked')){
        jQuery("#affilatstep_3 .btn-inactive-ra").addClass('btn-active-ra').prop("disabled", false);
       } else { jQuery("#affilatstep_3 .btn-inactive-ra").removeClass('btn-active-ra').prop("disabled", true); }
});
//set affilate URL
jQuery(document).ready(function () {
   //Marketing menu /footer link hide start
   // jQuery('#menu-affiliate-menu').children().eq(1).hide();
   jQuery('#menu-affiliate-menu-1').children().eq(1).hide();
   jQuery( ".revenue_footer" ).first().prev().hide();
    //Marketing menu /footer link hide end

  // var lastID1=jQuery('#menu-affiliate-menu').children().last().attr('id');
   var lastID1=jQuery('#menu-affiliate-menu').children().eq(5).attr('id');
    var lastID_rep=jQuery('#menu-portal-primary-navigation').children().eq(6).attr('id');
   //var lastID2=jQuery('#menu-affiliate-menu-1').children().last().attr('id');
   var url=jQuery('.affiliate_url').attr('id');
   if(url!==''){
    jQuery('#'+lastID1+ ' a, .affiliate_url_footer').attr({ target:"_blank", href:url,title:url});
    //jQuery('#menu-affiliate-menu-1').children().last('li').find('a').attr({ target:"_blank", href:url,title:url});
    jQuery('.affiliate-Landing-Page').find('a').attr({ target:"_blank", href:url,title:url});
   //sales rep
   jQuery('#'+lastID_rep+ ' a').attr({ target:"_blank", href:url,title:url});
   jQuery('#menu-portal-primary-navigation-1').children('li').eq(6).find('a').attr({ target:"_blank", href:url,title:url});
   //sale rep
   } else {
   jQuery('#'+lastID1+ ',#'+lastID_rep+', .affiliate_url_footer').hide();
   //jQuery('#menu-affiliate-menu-1').children().last('li').hide();
    jQuery('#menu-affiliate-menu-1').children().eq(5).hide();
    jQuery('#menu-portal-primary-navigation-1').children().eq(6).hide();
   }

   if (jQuery('#show_shareback').hasClass('show_false')) {
        jQuery( ".menu-affiliate-menu-container ul li:nth-child(3)" ).hide();
        //jQuery( ".menu-affiliate-menu-container ul.sub-menu li:nth-child(3)" ).hide();
        jQuery( ".menu-affiliate-menu-container ul.sub-menu li:nth-child(3)" ).show();
        jQuery( "#revenue" ).parent().parent().hide();
        //jQuery( ".menu-affiliate-menu-container ul li:nth-child(4)").find('.sub-menu li:nth-child(3)').hide();
        jQuery( ".revenue_footer" ).hide();

    }
//    if (jQuery('#office_depot_show').hasClass('office_depot_no')) {
//                jQuery( ".menu-portal-primary-navigation-container ul li:nth-child(7)" ).hide();
//    }
    if (jQuery('#verion_show').hasClass('verizon_no')) {
            jQuery( ".menu-portal-primary-navigation-container ul li:nth-child(3)" ).hide();
            jQuery( ".eligibility" ).hide();

    } else {
       // jQuery( ".menu-portal-primary-navigation-container ul li:nth-child(5)" ).hide();
        //jQuery( ".lead_search" ).hide();
        jQuery( ".menu-portal-primary-navigation-container ul li:nth-child(7)" ).hide();
        if (jQuery('#indirect_partner').hasClass('indirect_partner_true')) {
                   jQuery( ".menu-portal-primary-navigation-container ul li:nth-child(4)" ).hide();
                   jQuery( ".menu-portal-primary-navigation-container ul li:nth-child(5)" ).hide();
                   jQuery( ".indirect_partner" ).hide();
                   jQuery('.hide_for_indirect_off').remove();
                   jQuery( '#refer, #lead' ).parent().parent().hide();
        } else {
         jQuery('.hide_for_verizon_off ').remove();
           }

    }
    jQuery('#menu-affiliate-menu').children().last('li').find('a').attr({target:"_blank"});
    jQuery('#menu-affiliate-menu-1').children().last('li').find('a').attr({target:"_blank"});

});
jQuery("input[name='filter_by']").click(function(){
    jQuery("#loader").show();
    var radioVal = jQuery(this).val();
    location.href=IOT_CONFIG.PORTAL_HOST + '/affiliate-dashboard/?filter_by='+radioVal;
 });
 jQuery("input[name='rev_filter_by']").click(function(){
     jQuery("#loader").show();
     var radioVal = jQuery(this).val();
     location.href=IOT_CONFIG.PORTAL_HOST + '/shareback-dashboard/?filter_by='+radioVal;
  });

function createCSV(type,filterby,id){
   var values="type="+type+"&filterby="+filterby+"&assocition="+id;
   var filename='data_export_'+moment().format("YYYY_MM_DD")+'.csv';
   if(type==='revenue'){filename='revenue_share_'+moment().format("YYYY_MM_DD")+'.csv';}
   if(type==='revenue_non_member'){filename='revenue_non_member_'+moment().format("YYYY_MM_DD")+'.csv';}
   jQuery.ajax({
     url: IOT_CONFIG.PORTAL_HOST + "/app/themes/sage/lib/createCSV.php",
     type: "POST",
     dataType: 'text',
     data: values, // serializes the form's elements.
     beforeSend: function(){
       // Show image container
       jQuery("#loader").show();
     },
     success: function(data)
     {
//       var hiddenElement = document.createElement('a');
//       hiddenElement.href = 'data:text/csv;charset=utf-8,' + encodeURI(data);
//       hiddenElement.target = '_blank';
//       hiddenElement.download = filename;
//       hiddenElement.click();
       var blob = new Blob([data], {type: 'text/csv'});
            if(window.navigator.msSaveOrOpenBlob) {
                window.navigator.msSaveBlob(blob, filename);
            }
            else{
                var elem = window.document.createElement('a');
                elem.href = window.URL.createObjectURL(blob);
                elem.download = filename;
                document.body.appendChild(elem);
                elem.click();
                document.body.removeChild(elem);
            }
       jQuery("#loader").hide();
     }
   });
}
function createBrandCSV(csvType){
   var filename='';
   if(csvType==='company'){filename='CompanyBrandList.csv';}
   if(csvType==='employee'){filename='EmployeeBrandList.csv';}
   if(csvType==='all'){filename='AllBrandList.csv';}
   var values="type=BrandList&brandList=Yes&csvType="+csvType;
   jQuery.ajax({
     url: IOT_CONFIG.PORTAL_HOST + "/app/themes/sage/lib/leadSearch.php",
     type: "POST",
     dataType: 'text',
     data: values, // serializes the form's elements.
     beforeSend: function(){
       // Show image container
       jQuery("#loader").show();
     },
     success: function(data)
     {
         var blob = new Blob([data], {type: 'text/csv'});
            if(window.navigator.msSaveOrOpenBlob) {
                window.navigator.msSaveBlob(blob, filename);
            }
            else{
                var elem = window.document.createElement('a');
                elem.href = window.URL.createObjectURL(blob);
                elem.download = filename;
                document.body.appendChild(elem);
                elem.click();
                document.body.removeChild(elem);
            }
       jQuery("#loader").hide();
     }
   });
}
function getRewardInfo(){
   var couponcode = jQuery('#rep_coupon').val();
       var values = "couponcode="+couponcode;
       jQuery.ajax({
           url: IOT_CONFIG.HOST + "/app/themes/sage/lib/leadSearch.php",
           type: "POST",
           dataType: 'text',
           cache: false,
           data: values, // serializes the form's elements.
           beforeSend: function () {
               // Show image container
               jQuery("#loader").show();
           },
           success: function (html) {
              jQuery('#result').after(html);
              jQuery('.coupon_section').hide();
              jQuery("#goBack").show();
              jQuery("#loader").hide();
           }
       });
}
jQuery("#rep_coupon").keypress(function(e) {
    if(e.which === 13) {
        getRewardInfo();
		event.preventDefault();
            return false;
    }
});
jQuery(document).ready(function () {
if(jQuery('#rep_coupon').val()!==''){
console.log('test');
jQuery('#rep_coupon').focus();
}
});
jQuery('.gift_popup .close').on('click', function () {
     location.reload();
});
function sendRedeemGift(sel_gift,gift_code,assigned_to_name,assigned_to_email){
   console.log(sel_gift);
   var couponcode = jQuery('#selectedcouponCode').val();
   var sfGift=sel_gift;
   console.log(sel_gift);
   if(sfGift==='' || sfGift===undefined) {
      jQuery('.show_error').css({"color": "red", "padding-left": "75px"}).show();
      setTimeout(function () { jQuery('.show_error').hide();  }, 5000);
      return false;
   } else {
         jQuery('#myModal').modal('show');
         jQuery('#offer_redemption_thanks, .close').css('display','none');
         jQuery('#offer_redemption_main').css('display','block');
         jQuery("#modal-btn-no").off('click').on("click", function(){
             jQuery('#myModal').modal('hide');

          });
         jQuery("#modal-btn-si").off('click').on("click", function(){
            jQuery('#myModal').modal('hide');

       var values = "giftRedeem=Yes&selectedcouponcode="+couponcode+"&SelectedGiftID="+sfGift;
       jQuery.ajax({
           url: IOT_CONFIG.HOST + "/app/themes/sage/lib/leadSearch.php",
           type: "POST",
           dataType: 'text',
           cache: false,
           data: values, // serializes the form's elements.
           beforeSend: function () {
               // Show image container
               jQuery("#loader").show();
           },
           success: function (html) {

var firstStringChar = html.split(" ")[0];
   if(firstStringChar==='Error'){
                var  html_new="<div class='category-mid-section' id='show_gift' >";
                html_new= html_new+"<div class='row  '>";
                html_new= html_new+"<div id='lead_result' class='col-md-12'><h3>Oops!</h3>";
                html_new= html_new+"<table class='company_list_table no_data_found  '>";
                html_new= html_new+"<tr><td><p class='no-data'>"+html.split(' ').slice(1).join(' ')+"</p></td></tr></table></div>";
                html_new= html_new+"</div>";
                jQuery('#show_gift').remove();
                jQuery('#result').append(html_new);
                jQuery('.coupon_section').hide();
                jQuery("#goBack").show();
                jQuery("#loader").hide();
   } else{
            var values_thnks = "giftThnks=Yes&gift_code="+gift_code+"&assigned_to_name="+assigned_to_name+"&assigned_to_email="+assigned_to_email;
            jQuery.ajax({
                       url: IOT_CONFIG.HOST + "/app/themes/sage/lib/leadSearch.php",
                       type: "POST",
                       dataType: 'text',
                       cache: false,
                       data: values_thnks, // serializes the form's elements.
                       beforeSend: function () {
                           // Show image container
                           jQuery("#loader").show();
                       },
                       success: function (data) {
                      jQuery("#loader").hide();
                       jQuery('#myModal').modal('show');
                       jQuery('#offer_redemption_thanks, .close').css('display','block');
                        jQuery('#offer_redemption_main').css('display','none');
                    }
                   });
           }
           }
       });
      });
   }
}


function seachMaterial(type,pagelength){
   var values='';
   if(type===''){
     //values=jQuery('#newslist').serialize();
     values=values+'filter_type='+jQuery("#filer_dropdown").next(".nice-select").find('ul li.selected').attr("data-value");
     }
   else {
    jQuery("#filer_dropdown option[value="+type+"]").attr("selected","selected");
    var selected_type = jQuery("#filer_dropdown option:selected").text();
    jQuery("#filer_dropdown").next(".nice-select").children(".current").text(selected_type);
    jQuery("#filer_dropdown").next(".nice-select").find("ul li").removeClass("selected focus");
    jQuery("#filer_dropdown").next(".nice-select").find("ul li:contains('"+ selected_type + "')").addClass("selected focus");
    values="filter_type="+type;
   }
   // values filter brand remvoe
   jQuery('#bransSelect_itemList li.active').each(function() {
     values=values+'&filter_brand[]='+jQuery(this).find('input').attr("data-val");
 });
   pagelength = pagelength || 1;
   var wp_page=jQuery('#wp_page').val();
   values=values+"&wp_page="+pagelength+"&coller_type="+jQuery('#coller').val();
   console.log( values );
   jQuery.ajax({
     url: IOT_CONFIG.PORTAL_HOST + "/app/themes/sage/lib/filtermaterial.php",
     type: "POST",
     dataType: 'text',
     data: values, // serializes the form's elements.
     beforeSend: function(){
      jQuery("#loader").show();
    },
     success: function(data)
     {
       jQuery("#loader, #marketing_section_tile").hide();
       jQuery('html, body').animate({ scrollTop: jQuery('.marketing-filter-data').offset().top-100 });
       jQuery('#result_filter').html(data);
       jQuery("#bransSelect option:selected").prop("selected", false);
     }
   });
}
jQuery(document).on('click', '.marketing_section_page a.page-numbers', function (e) {
        e.preventDefault() ;
        var pagelength;

        if (jQuery(this).has("span.page_increment")) {
            pagelength = jQuery(this).has("span.page_increment").text();
        }
        if (jQuery(this).has("span.page_decrement")) {
            pagelength = jQuery(this).has("span.page_decrement").text();
        }
         pagelength = jQuery(this).text();
        pagelength = jQuery(e.target).text();

        console.log(pagelength);
        seachMaterial('',pagelength);
    });

   //affilateend

